/* tslint:disable */
/* eslint-disable */
/**
 * Reservare API
 * TBD
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Typ absence
 * @export
 * @enum {string}
 */

export const AbsenceType = {
    Vacation: 'VACATION',
    Illness: 'ILLNESS',
    Private: 'PRIVATE',
    Block: 'BLOCK',
    CalendarBlock: 'CALENDAR_BLOCK'
} as const;

export type AbsenceType = typeof AbsenceType[keyof typeof AbsenceType];


/**
 * 
 * @export
 * @interface AppAbsenceDto
 */
export interface AppAbsenceDto {
    /**
     * ID absence
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'id': string;
    /**
     * Název absence
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'name': string;
    /**
     * 
     * @type {AbsenceType}
     * @memberof AppAbsenceDto
     */
    'type': AbsenceType;
    /**
     * Datum začátku
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'startDate': string;
    /**
     * Čas začátku
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'startTime': string;
    /**
     * Datum konce
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'endDate': string;
    /**
     * Čas konce
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'endTime': string;
    /**
     * Popis absence
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'description'?: string;
    /**
     * Zda je absence aktivní
     * @type {boolean}
     * @memberof AppAbsenceDto
     */
    'isActive': boolean;
    /**
     * ID salonu
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'salonId': string;
    /**
     * ID uživatele (null pokud platí pro všechny)
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'userId'?: string;
    /**
     * Jméno uživatele (null pokud platí pro všechny)
     * @type {string}
     * @memberof AppAbsenceDto
     */
    'userName'?: string;
}


/**
 * Parametry pro kontrolu rezervace
 * @export
 * @interface AppBookingCheckRequest
 */
export interface AppBookingCheckRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'salonId': string;
    /**
     * UUID zaměstnance
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'workerId': string;
    /**
     * UUID služby
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'serviceId': string;
    /**
     * UUID pracoviště (volitelné)
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'workResourceId'?: string;
    /**
     * Datum rezervace
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'date': string;
    /**
     * Čas začátku rezervace
     * @type {string}
     * @memberof AppBookingCheckRequest
     */
    'startTime': string;
}
/**
 * Odpověď na ověření možnosti rezervace
 * @export
 * @interface AppBookingCheckResponse
 */
export interface AppBookingCheckResponse {
    /**
     * Zda je rezervace možná
     * @type {boolean}
     * @memberof AppBookingCheckResponse
     */
    'isAvailable': boolean;
    /**
     * Důvod, proč není rezervace možná (pokud isAvailable = false)
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'reason'?: string;
    /**
     * ID salonu
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'salonId': string;
    /**
     * Název salonu
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'salonName': string;
    /**
     * ID zaměstnance
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'workerId': string;
    /**
     * Jméno zaměstnance
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'workerName': string;
    /**
     * ID služby
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'serviceId': string;
    /**
     * Název služby
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'serviceName': string;
    /**
     * Délka služby v minutách
     * @type {number}
     * @memberof AppBookingCheckResponse
     */
    'serviceDuration': number;
    /**
     * Cena služby
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'servicePrice': string;
    /**
     * Měna
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'currency': string;
    /**
     * ID pracoviště
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'workResourceId'?: string;
    /**
     * Název pracoviště
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'workResourceName'?: string;
    /**
     * Datum a čas začátku rezervace
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'startDateTime': string;
    /**
     * Datum a čas konce rezervace
     * @type {string}
     * @memberof AppBookingCheckResponse
     */
    'endDateTime': string;
}
/**
 * 
 * @export
 * @interface AppBookingExportRequest
 */
export interface AppBookingExportRequest {
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'state'?: AppBookingExportRequestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'salonId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'workerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingExportRequest
     */
    'format': AppBookingExportRequestFormatEnum;
}

export const AppBookingExportRequestStateEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    InService: 'IN_SERVICE',
    Done: 'DONE',
    NoShow: 'NO_SHOW',
    Canceled: 'CANCELED'
} as const;

export type AppBookingExportRequestStateEnum = typeof AppBookingExportRequestStateEnum[keyof typeof AppBookingExportRequestStateEnum];
export const AppBookingExportRequestFormatEnum = {
    Csv: 'CSV',
    Excel: 'EXCEL',
    Pdf: 'PDF'
} as const;

export type AppBookingExportRequestFormatEnum = typeof AppBookingExportRequestFormatEnum[keyof typeof AppBookingExportRequestFormatEnum];

/**
 * 
 * @export
 * @interface AppBookingListItemDto
 */
export interface AppBookingListItemDto {
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'state': AppBookingListItemDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'source': AppBookingListItemDtoSourceEnum;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof AppBookingListItemDto
     */
    'customer': CustomerInfo;
    /**
     * 
     * @type {WorkerInfo}
     * @memberof AppBookingListItemDto
     */
    'worker': WorkerInfo;
    /**
     * 
     * @type {SalonInfo}
     * @memberof AppBookingListItemDto
     */
    'salon': SalonInfo;
    /**
     * 
     * @type {WorkResourceInfo}
     * @memberof AppBookingListItemDto
     */
    'workResource'?: WorkResourceInfo;
    /**
     * 
     * @type {Array<AppServiceInfo>}
     * @memberof AppBookingListItemDto
     */
    'services': Array<AppServiceInfo>;
    /**
     * 
     * @type {number}
     * @memberof AppBookingListItemDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AppBookingListItemDto
     */
    'updatedAt': string;
}

export const AppBookingListItemDtoStateEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    InService: 'IN_SERVICE',
    Done: 'DONE',
    NoShow: 'NO_SHOW',
    Canceled: 'CANCELED'
} as const;

export type AppBookingListItemDtoStateEnum = typeof AppBookingListItemDtoStateEnum[keyof typeof AppBookingListItemDtoStateEnum];
export const AppBookingListItemDtoSourceEnum = {
    Online: 'ONLINE',
    Phone: 'PHONE',
    Walkin: 'WALKIN',
    App: 'APP'
} as const;

export type AppBookingListItemDtoSourceEnum = typeof AppBookingListItemDtoSourceEnum[keyof typeof AppBookingListItemDtoSourceEnum];

/**
 * 
 * @export
 * @interface AppBookingListResponse
 */
export interface AppBookingListResponse {
    /**
     * 
     * @type {Array<AppBookingListItemDto>}
     * @memberof AppBookingListResponse
     */
    'bookings': Array<AppBookingListItemDto>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof AppBookingListResponse
     */
    'pagination': PaginationInfo;
    /**
     * 
     * @type {AppBookingSummaryDto}
     * @memberof AppBookingListResponse
     */
    'summary': AppBookingSummaryDto;
}
/**
 * 
 * @export
 * @interface AppBookingSummaryDto
 */
export interface AppBookingSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof AppBookingSummaryDto
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof AppBookingSummaryDto
     */
    'totalRevenue': number;
    /**
     * 
     * @type {{ [key: string]: AppStateSummary; }}
     * @memberof AppBookingSummaryDto
     */
    'summaryByState': { [key: string]: AppStateSummary; };
    /**
     * 
     * @type {AppRevenueSummary}
     * @memberof AppBookingSummaryDto
     */
    'summaryByRevenue': AppRevenueSummary;
}
/**
 * 
 * @export
 * @interface AppCreateAbsenceDto
 */
export interface AppCreateAbsenceDto {
    /**
     * Název absence
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'name': string;
    /**
     * Typ absence
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'type': string;
    /**
     * ID uživatele (null pro všechny zaměstnance)
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'userId'?: string;
    /**
     * Datum začátku
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'startDate': string;
    /**
     * Čas začátku
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'startTime': string;
    /**
     * Datum konce
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'endDate': string;
    /**
     * Čas konce
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'endTime': string;
    /**
     * Popis absence
     * @type {string}
     * @memberof AppCreateAbsenceDto
     */
    'description'?: string;
}
/**
 * Data pro vytvoření rezervace
 * @export
 * @interface AppCreateBookingRequest
 */
export interface AppCreateBookingRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'salonId': string;
    /**
     * UUID zaměstnance
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'workerId': string;
    /**
     * UUID služby
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'serviceId': string;
    /**
     * UUID pracoviště (volitelné)
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'workResourceId'?: string;
    /**
     * Datum rezervace
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'date': string;
    /**
     * Čas začátku rezervace
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'startTime': string;
    /**
     * Jméno zákazníka
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'firstName': string;
    /**
     * Příjmení zákazníka
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'lastName': string;
    /**
     * Email zákazníka
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'email': string;
    /**
     * Telefonní číslo zákazníka
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'phone': string;
    /**
     * Poznámky k rezervaci
     * @type {string}
     * @memberof AppCreateBookingRequest
     */
    'notes'?: string;
    /**
     * Souhlas se zpracováním osobních údajů
     * @type {boolean}
     * @memberof AppCreateBookingRequest
     */
    'gdprConsent': boolean;
}
/**
 * Odpověď na vytvoření rezervace
 * @export
 * @interface AppCreateBookingResponse
 */
export interface AppCreateBookingResponse {
    /**
     * ID rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'id': string;
    /**
     * Kód rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'code': string;
    /**
     * Stav rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'state': string;
    /**
     * Datum a čas začátku rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'startDateTime': string;
    /**
     * Datum a čas konce rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'endDateTime': string;
    /**
     * Poznámky k rezervaci
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'notes'?: string;
    /**
     * Zdroj rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'source': string;
    /**
     * ID zákazníka
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'customerId': string;
    /**
     * Jméno zákazníka
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'customerName': string;
    /**
     * Email zákazníka
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'customerEmail': string;
    /**
     * Telefon zákazníka
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'customerPhone': string;
    /**
     * ID zaměstnance
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'workerId': string;
    /**
     * Jméno zaměstnance
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'workerName': string;
    /**
     * ID salonu
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'salonId': string;
    /**
     * Název salonu
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'salonName': string;
    /**
     * ID pracoviště
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'workResourceId'?: string;
    /**
     * Název pracoviště
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'workResourceName'?: string;
    /**
     * Název služby
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'serviceName': string;
    /**
     * Délka služby v minutách
     * @type {number}
     * @memberof AppCreateBookingResponse
     */
    'serviceDuration': number;
    /**
     * Cena služby
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'servicePrice': string;
    /**
     * Měna
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'currency': string;
    /**
     * Celková cena rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'totalAmount': string;
    /**
     * Datum vytvoření rezervace
     * @type {string}
     * @memberof AppCreateBookingResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface AppCreateCustomerRequest
 */
export interface AppCreateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof AppCreateCustomerRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AppCreateCustomerRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AppCreateCustomerRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AppCreateCustomerRequest
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppCreateCustomerRequest
     */
    'gdprConsent': boolean;
}
/**
 * 
 * @export
 * @interface AppRevenueSummary
 */
export interface AppRevenueSummary {
    /**
     * 
     * @type {number}
     * @memberof AppRevenueSummary
     */
    'totalRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof AppRevenueSummary
     */
    'averageRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof AppRevenueSummary
     */
    'minRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof AppRevenueSummary
     */
    'maxRevenue': number;
}
/**
 * 
 * @export
 * @interface AppServiceInfo
 */
export interface AppServiceInfo {
    /**
     * 
     * @type {string}
     * @memberof AppServiceInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AppServiceInfo
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof AppServiceInfo
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof AppServiceInfo
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface AppStateSummary
 */
export interface AppStateSummary {
    /**
     * 
     * @type {number}
     * @memberof AppStateSummary
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AppStateSummary
     */
    'revenue': number;
}
/**
 * 
 * @export
 * @interface AppUpdateCustomerRequest
 */
export interface AppUpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof AppUpdateCustomerRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AppUpdateCustomerRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AppUpdateCustomerRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AppUpdateCustomerRequest
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppUpdateCustomerRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface AssignServiceRequest
 */
export interface AssignServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignServiceRequest
     */
    'serviceId': string;
    /**
     * 
     * @type {number}
     * @memberof AssignServiceRequest
     */
    'durationMinOverride'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignServiceRequest
     */
    'priceOverride'?: number;
}
/**
 * 
 * @export
 * @interface AttachmentMetadataResponse
 */
export interface AttachmentMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof AttachmentMetadataResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentMetadataResponse
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentMetadataResponse
     */
    'contentType': string;
    /**
     * 
     * @type {number}
     * @memberof AttachmentMetadataResponse
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentMetadataResponse
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentMetadataResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {UserResponse}
     * @memberof AuthResponse
     */
    'user'?: UserResponse;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AvailableSlotResponse
 */
export interface AvailableSlotResponse {
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotResponse
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotResponse
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableSlotResponse
     */
    'isAvailable': boolean;
}
/**
 * 
 * @export
 * @interface AvailableSlotsResponse
 */
export interface AvailableSlotsResponse {
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'serviceName': string;
    /**
     * 
     * @type {number}
     * @memberof AvailableSlotsResponse
     */
    'serviceDuration': number;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'workerId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'workerName': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'workResourceId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'workResourceName': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableSlotsResponse
     */
    'date': string;
    /**
     * 
     * @type {Array<AvailableSlotResponse>}
     * @memberof AvailableSlotsResponse
     */
    'slots': Array<AvailableSlotResponse>;
}
/**
 * 
 * @export
 * @interface BookingDto
 */
export interface BookingDto {
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'state': BookingDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'source': BookingDtoSourceEnum;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof BookingDto
     */
    'customer': CustomerInfo;
    /**
     * 
     * @type {WorkerInfo}
     * @memberof BookingDto
     */
    'worker': WorkerInfo;
    /**
     * 
     * @type {SalonInfo}
     * @memberof BookingDto
     */
    'salon': SalonInfo;
    /**
     * 
     * @type {WorkResourceInfo}
     * @memberof BookingDto
     */
    'workResource'?: WorkResourceInfo;
    /**
     * 
     * @type {Array<BookingLineResponse>}
     * @memberof BookingDto
     */
    'bookingLines': Array<BookingLineResponse>;
    /**
     * 
     * @type {number}
     * @memberof BookingDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDto
     */
    'updatedAt': string;
}

export const BookingDtoStateEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    InService: 'IN_SERVICE',
    Done: 'DONE',
    NoShow: 'NO_SHOW',
    Canceled: 'CANCELED'
} as const;

export type BookingDtoStateEnum = typeof BookingDtoStateEnum[keyof typeof BookingDtoStateEnum];
export const BookingDtoSourceEnum = {
    Online: 'ONLINE',
    Phone: 'PHONE',
    Walkin: 'WALKIN',
    App: 'APP'
} as const;

export type BookingDtoSourceEnum = typeof BookingDtoSourceEnum[keyof typeof BookingDtoSourceEnum];

/**
 * Řádky rezervace
 * @export
 * @interface BookingLineResponse
 */
export interface BookingLineResponse {
    /**
     * 
     * @type {string}
     * @memberof BookingLineResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingLineResponse
     */
    'nameSnapshot': string;
    /**
     * 
     * @type {number}
     * @memberof BookingLineResponse
     */
    'durationMin': number;
    /**
     * 
     * @type {number}
     * @memberof BookingLineResponse
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BookingLineResponse
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof BookingLineResponse
     */
    'taxRate': number;
    /**
     * 
     * @type {number}
     * @memberof BookingLineResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {string}
     * @memberof BookingLineResponse
     */
    'serviceColor'?: string;
}
/**
 * Odpověď s informacemi o vytvořené rezervaci
 * @export
 * @interface BookingResponse
 */
export interface BookingResponse {
    /**
     * UUID rezervace
     * @type {string}
     * @memberof BookingResponse
     */
    'id': string;
    /**
     * Kód rezervace
     * @type {string}
     * @memberof BookingResponse
     */
    'code': string;
    /**
     * Stav rezervace
     * @type {string}
     * @memberof BookingResponse
     */
    'state': BookingResponseStateEnum;
    /**
     * Datum a čas začátku rezervace
     * @type {string}
     * @memberof BookingResponse
     */
    'startDateTime': string;
    /**
     * Datum a čas konce rezervace
     * @type {string}
     * @memberof BookingResponse
     */
    'endDateTime': string;
    /**
     * Jméno zákazníka
     * @type {string}
     * @memberof BookingResponse
     */
    'customerFirstName': string;
    /**
     * Příjmení zákazníka
     * @type {string}
     * @memberof BookingResponse
     */
    'customerLastName': string;
    /**
     * Email zákazníka
     * @type {string}
     * @memberof BookingResponse
     */
    'customerEmail': string;
    /**
     * Telefon zákazníka
     * @type {string}
     * @memberof BookingResponse
     */
    'customerPhone': string;
    /**
     * Název služby
     * @type {string}
     * @memberof BookingResponse
     */
    'serviceName': string;
    /**
     * Trvání služby v minutách
     * @type {number}
     * @memberof BookingResponse
     */
    'serviceDuration': number;
    /**
     * Cena služby
     * @type {string}
     * @memberof BookingResponse
     */
    'servicePrice': string;
    /**
     * Měna
     * @type {string}
     * @memberof BookingResponse
     */
    'currency': string;
    /**
     * Jméno zaměstnance
     * @type {string}
     * @memberof BookingResponse
     */
    'workerName': string;
    /**
     * Název salonu
     * @type {string}
     * @memberof BookingResponse
     */
    'salonName': string;
    /**
     * Název pracoviště
     * @type {string}
     * @memberof BookingResponse
     */
    'workResourceName'?: string;
    /**
     * Poznámky k rezervaci
     * @type {string}
     * @memberof BookingResponse
     */
    'notes'?: string;
}

export const BookingResponseStateEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    InService: 'IN_SERVICE',
    Done: 'DONE',
    NoShow: 'NO_SHOW',
    Canceled: 'CANCELED'
} as const;

export type BookingResponseStateEnum = typeof BookingResponseStateEnum[keyof typeof BookingResponseStateEnum];

/**
 * 
 * @export
 * @interface BookingReviewResponse
 */
export interface BookingReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'bookingId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'bookingCode': string;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewResponse
     */
    'overallRating': number;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewResponse
     */
    'staffRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewResponse
     */
    'serviceRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewResponse
     */
    'cleanlinessRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingReviewResponse
     */
    'atmosphereRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'reviewText'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'reviewedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingReviewResponse
     */
    'isPublic': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingReviewResponse
     */
    'isVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingReviewResponse
     */
    'isModerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'salonResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'salonResponseAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'salonResponseBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'customerFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'customerLastName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'workerName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'serviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'bookingDate': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BookingReviewResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface BookingServiceResponse
 */
export interface BookingServiceResponse {
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'currency': string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingServiceResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingServiceResponse
     */
    'isBookable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingServiceResponse
     */
    'requiresDeposit': boolean;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'depositAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'maxAdvanceBookingDays': number;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'minAdvanceBookingHours': number;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'cancellationPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'salonAddress': string;
    /**
     * 
     * @type {string}
     * @memberof BookingServiceResponse
     */
    'salonCity': string;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'totalBookings'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'monthlyRevenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingServiceResponse
     */
    'averageRating'?: number;
}
/**
 * 
 * @export
 * @interface BookingSummaryDto
 */
export interface BookingSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof BookingSummaryDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof BookingSummaryDto
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof BookingSummaryDto
     */
    'totalRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof BookingSummaryDto
     */
    'newCustomers': number;
    /**
     * 
     * @type {number}
     * @memberof BookingSummaryDto
     */
    'waitingCustomers': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BookingSummaryDto
     */
    'bookingsByState': { [key: string]: number; };
    /**
     * 
     * @type {Array<ServiceRevenueInfo>}
     * @memberof BookingSummaryDto
     */
    'revenueByService': Array<ServiceRevenueInfo>;
    /**
     * 
     * @type {Array<WorkerStats>}
     * @memberof BookingSummaryDto
     */
    'topWorkers': Array<WorkerStats>;
    /**
     * 
     * @type {Array<BookingDto>}
     * @memberof BookingSummaryDto
     */
    'bookings': Array<BookingDto>;
}
/**
 * 
 * @export
 * @interface BulkUpdateEmployeeWorkingHoursRequest
 */
export interface BulkUpdateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateEmployeeWorkingHoursRequest
     */
    'userId': string;
    /**
     * 
     * @type {Array<EmployeeWorkingHoursDayRequest>}
     * @memberof BulkUpdateEmployeeWorkingHoursRequest
     */
    'workingHours': Array<EmployeeWorkingHoursDayRequest>;
}
/**
 * 
 * @export
 * @interface BulkUpdateServicesRequest
 */
export interface BulkUpdateServicesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateServicesRequest
     */
    'serviceIds': Array<string>;
    /**
     * 
     * @type {UpdateBookingServiceRequest}
     * @memberof BulkUpdateServicesRequest
     */
    'updates': UpdateBookingServiceRequest;
}
/**
 * Důvod zrušení
 * @export
 * @interface CancelBookingRequest
 */
export interface CancelBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelBookingRequest
     */
    'cancellationReason'?: string;
}
/**
 * 
 * @export
 * @interface CancelBookingResponse
 */
export interface CancelBookingResponse {
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'bookingId': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'bookingCode': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'cancelledAt': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'cancellationReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'customerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'customerPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'originalStartDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'originalEndDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBookingResponse
     */
    'workerName': string;
}
/**
 * 
 * @export
 * @interface CategoryStats
 */
export interface CategoryStats {
    /**
     * 
     * @type {string}
     * @memberof CategoryStats
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryStats
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CategoryStats
     */
    'serviceCount': number;
    /**
     * 
     * @type {number}
     * @memberof CategoryStats
     */
    'totalRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof CategoryStats
     */
    'averagePrice': number;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
}
/**
 * Data pro vytvoření rezervace
 * @export
 * @interface CreateBookingRequest
 */
export interface CreateBookingRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'salonId': string;
    /**
     * UUID zaměstnance
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'workerId': string;
    /**
     * UUID služby
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'serviceId': string;
    /**
     * UUID pracoviště (volitelné)
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'workResourceId'?: string;
    /**
     * Datum rezervace
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'date': string;
    /**
     * Čas začátku rezervace
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'startTime': string;
    /**
     * Jméno zákazníka
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'firstName': string;
    /**
     * Příjmení zákazníka
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'lastName': string;
    /**
     * Email zákazníka
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'email': string;
    /**
     * Telefonní číslo zákazníka
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'phone': string;
    /**
     * Poznámky k rezervaci
     * @type {string}
     * @memberof CreateBookingRequest
     */
    'notes'?: string;
    /**
     * Souhlas se zpracováním osobních údajů
     * @type {boolean}
     * @memberof CreateBookingRequest
     */
    'gdprConsent': boolean;
}
/**
 * 
 * @export
 * @interface CreateBookingReviewRequest
 */
export interface CreateBookingReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingReviewRequest
     */
    'bookingId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewRequest
     */
    'overallRating': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewRequest
     */
    'staffRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewRequest
     */
    'serviceRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewRequest
     */
    'cleanlinessRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingReviewRequest
     */
    'atmosphereRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingReviewRequest
     */
    'reviewText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBookingReviewRequest
     */
    'isPublic': boolean;
}
/**
 * 
 * @export
 * @interface CreateBookingServiceRequest
 */
export interface CreateBookingServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingServiceRequest
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingServiceRequest
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'currency': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBookingServiceRequest
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBookingServiceRequest
     */
    'isBookable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBookingServiceRequest
     */
    'requiresDeposit': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingServiceRequest
     */
    'depositAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingServiceRequest
     */
    'maxAdvanceBookingDays': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingServiceRequest
     */
    'minAdvanceBookingHours': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'cancellationPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingServiceRequest
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface CreateCustomerNoteRequest
 */
export interface CreateCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerNoteRequest
     */
    'noteText': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeRequest
 */
export interface CreateEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'role': CreateEmployeeRequestRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    'salonId'?: string;
}

export const CreateEmployeeRequestRoleEnum = {
    Owner: 'OWNER',
    Reception: 'RECEPTION',
    Worker: 'WORKER'
} as const;

export type CreateEmployeeRequestRoleEnum = typeof CreateEmployeeRequestRoleEnum[keyof typeof CreateEmployeeRequestRoleEnum];

/**
 * 
 * @export
 * @interface CreateEmployeeWorkingHoursRequest
 */
export interface CreateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWorkingHoursRequest
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeeWorkingHoursRequest
     */
    'weekday': number;
    /**
     * 
     * @type {Array<WorkingHoursIntervalDto>}
     * @memberof CreateEmployeeWorkingHoursRequest
     */
    'intervals': Array<WorkingHoursIntervalDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeWorkingHoursRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface CreateInvitationRequest
 */
export interface CreateInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreateInvitationResponse
 */
export interface CreateInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    'expiresAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInvitationResponse
     */
    'invitationSent': boolean;
}
/**
 * 
 * @export
 * @interface CreateSalonRequest
 */
export interface CreateSalonRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalonRequest
     */
    'timezone': string;
}
/**
 * 
 * @export
 * @interface CreateServiceCategoryRequest
 */
export interface CreateServiceCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateServiceCategoryRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceCategoryRequest
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceCategoryRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceCategoryRequest
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceCategoryRequest
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreateUserForEmployeeRequest
 */
export interface CreateUserForEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserForEmployeeRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserForEmployeeRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserForEmployeeRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserForEmployeeRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserForEmployeeRequest
     */
    'isAdmin': boolean;
}
/**
 * 
 * @export
 * @interface CreateWaitingListRequest
 */
export interface CreateWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWaitingListRequest
     */
    'timeFrom'?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWaitingListRequest
     */
    'timeTo'?: LocalTime;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateWaitingListRequest
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'preferredWorkerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaitingListRequest
     */
    'preferredWorkResourceId'?: string;
}
/**
 * 
 * @export
 * @interface CreateWorkingHoursRequest
 */
export interface CreateWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkingHoursRequest
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkingHoursRequest
     */
    'weekday': number;
    /**
     * Čas začátku pracovních hodin
     * @type {string}
     * @memberof CreateWorkingHoursRequest
     */
    'startTime': string;
    /**
     * Čas konce pracovních hodin
     * @type {string}
     * @memberof CreateWorkingHoursRequest
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkingHoursRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface CustomerBookingHistoryDto
 */
export interface CustomerBookingHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'bookingId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'bookingCode': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'workerName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerBookingHistoryDto
     */
    'services': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CustomerBookingHistoryDto
     */
    'totalPrice': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'reviewId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerBookingHistoryDto
     */
    'overallRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'reviewText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBookingHistoryDto
     */
    'reviewedAt'?: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailResponse
 */
export interface CustomerDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDetailResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'gdprConsentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerDetailResponse
     */
    'totalVisits': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDetailResponse
     */
    'totalSpent': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDetailResponse
     */
    'averageRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailResponse
     */
    'lastVisitDate'?: string;
    /**
     * 
     * @type {Array<CustomerBookingHistoryDto>}
     * @memberof CustomerDetailResponse
     */
    'bookingHistory': Array<CustomerBookingHistoryDto>;
}
/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDto
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'gdprConsentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'updatedAt': string;
}
/**
 * Informace o zákazníkovi
 * @export
 * @interface CustomerInfo
 */
export interface CustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface CustomerListResponse
 */
export interface CustomerListResponse {
    /**
     * 
     * @type {Array<CustomerDto>}
     * @memberof CustomerListResponse
     */
    'customers': Array<CustomerDto>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof CustomerListResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface CustomerNoteListResponse
 */
export interface CustomerNoteListResponse {
    /**
     * 
     * @type {Array<CustomerNoteResponse>}
     * @memberof CustomerNoteListResponse
     */
    'notes': Array<CustomerNoteResponse>;
    /**
     * 
     * @type {number}
     * @memberof CustomerNoteListResponse
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface CustomerNoteResponse
 */
export interface CustomerNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'noteText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerNoteResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<AttachmentMetadataResponse>}
     * @memberof CustomerNoteResponse
     */
    'attachments': Array<AttachmentMetadataResponse>;
}
/**
 * 
 * @export
 * @interface DuplicateServiceRequest
 */
export interface DuplicateServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof DuplicateServiceRequest
     */
    'sourceServiceId': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateServiceRequest
     */
    'newName': string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateServiceRequest
     */
    'newPrice'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DuplicateServiceRequest
     */
    'assignedStaffIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EmployeeDetailResponse
 */
export interface EmployeeDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'salonName': string;
    /**
     * 
     * @type {EmployeeStatisticsResponse}
     * @memberof EmployeeDetailResponse
     */
    'statistics': EmployeeStatisticsResponse;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface EmployeeResponse
 */
export interface EmployeeResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface EmployeeServiceResponse
 */
export interface EmployeeServiceResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeServiceResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeServiceResponse
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeServiceResponse
     */
    'serviceName': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeServiceResponse
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeServiceResponse
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeServiceResponse
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeServiceResponse
     */
    'durationMinOverride'?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeServiceResponse
     */
    'priceOverride'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeServiceResponse
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface EmployeeStatisticsResponse
 */
export interface EmployeeStatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatisticsResponse
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatisticsResponse
     */
    'monthlyBookings': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatisticsResponse
     */
    'monthlyRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatisticsResponse
     */
    'averageRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatisticsResponse
     */
    'totalRevenue': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeStatisticsResponse
     */
    'workingHours'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeStatsResponse
 */
export interface EmployeeStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'totalEmployees': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'activeEmployees': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'inactiveEmployees': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'averageRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatsResponse
     */
    'monthlyRevenue': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof EmployeeStatsResponse
     */
    'employeesByRole': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof EmployeeStatsResponse
     */
    'employeesByStatus': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface EmployeeWorkingHoursDayRequest
 */
export interface EmployeeWorkingHoursDayRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeWorkingHoursDayRequest
     */
    'weekday': number;
    /**
     * 
     * @type {Array<WorkingHoursIntervalDto>}
     * @memberof EmployeeWorkingHoursDayRequest
     */
    'intervals': Array<WorkingHoursIntervalDto>;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeWorkingHoursDayRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface EmployeeWorkingHoursDayResponse
 */
export interface EmployeeWorkingHoursDayResponse {
    /**
     * 
     * @type {number}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'weekday': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'weekdayName': string;
    /**
     * 
     * @type {Array<WorkingHoursIntervalResponse>}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'intervals': Array<WorkingHoursIntervalResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'totalDayHours': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursDayResponse
     */
    'workingHoursId'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeWorkingHoursResponse
 */
export interface EmployeeWorkingHoursResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'salonName': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeWorkingHoursResponse
     */
    'weekday': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'weekdayName': string;
    /**
     * 
     * @type {Array<WorkingHoursIntervalResponse>}
     * @memberof EmployeeWorkingHoursResponse
     */
    'intervals': Array<WorkingHoursIntervalResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeWorkingHoursResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'totalWorkingHours': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursResponse
     */
    'updatedBy': string;
}
/**
 * 
 * @export
 * @interface EmployeeWorkingHoursSummaryResponse
 */
export interface EmployeeWorkingHoursSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'salonName': string;
    /**
     * 
     * @type {Array<EmployeeWorkingHoursDayResponse>}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'workingHoursByDay': Array<EmployeeWorkingHoursDayResponse>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'totalWeeklyHours': string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeWorkingHoursSummaryResponse
     */
    'isFullyConfigured': boolean;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'nano'?: number;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
}
/**
 * Data pro přesunutí rezervace
 * @export
 * @interface MoveBookingRequest
 */
export interface MoveBookingRequest {
    /**
     * Nové datum rezervace
     * @type {string}
     * @memberof MoveBookingRequest
     */
    'newDate': string;
    /**
     * Nový čas začátku rezervace
     * @type {string}
     * @memberof MoveBookingRequest
     */
    'newStartTime': string;
    /**
     * Nový zaměstnanec (volitelné)
     * @type {string}
     * @memberof MoveBookingRequest
     */
    'newWorkerId'?: string;
    /**
     * Nové pracoviště (volitelné)
     * @type {string}
     * @memberof MoveBookingRequest
     */
    'newWorkResourceId'?: string;
    /**
     * Poznámky k přesunutí
     * @type {string}
     * @memberof MoveBookingRequest
     */
    'notes'?: string;
}
/**
 * Odpověď na přesunutí rezervace
 * @export
 * @interface MoveBookingResponse
 */
export interface MoveBookingResponse {
    /**
     * ID rezervace
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'id': string;
    /**
     * Kód rezervace
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'code': string;
    /**
     * Stav rezervace
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'state': string;
    /**
     * Původní datum a čas
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'originalStartDateTime': string;
    /**
     * Nové datum a čas
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'newStartDateTime': string;
    /**
     * Nové datum a čas konce
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'newEndDateTime': string;
    /**
     * Poznámky k přesunutí
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'moveNotes'?: string;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof MoveBookingResponse
     */
    'customer': CustomerInfo;
    /**
     * 
     * @type {WorkerInfo}
     * @memberof MoveBookingResponse
     */
    'worker': WorkerInfo;
    /**
     * 
     * @type {SalonInfo}
     * @memberof MoveBookingResponse
     */
    'salon': SalonInfo;
    /**
     * 
     * @type {WorkResourceInfo}
     * @memberof MoveBookingResponse
     */
    'workResource'?: WorkResourceInfo;
    /**
     * Řádky rezervace
     * @type {Array<BookingLineResponse>}
     * @memberof MoveBookingResponse
     */
    'bookingLines': Array<BookingLineResponse>;
    /**
     * Celková částka
     * @type {number}
     * @memberof MoveBookingResponse
     */
    'totalAmount': number;
    /**
     * Datum a čas přesunutí
     * @type {string}
     * @memberof MoveBookingResponse
     */
    'movedAt': string;
}
/**
 * 
 * @export
 * @interface PageEmployeeWorkingHoursResponse
 */
export interface PageEmployeeWorkingHoursResponse {
    /**
     * 
     * @type {number}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'size'?: number;
    /**
     * 
     * @type {Array<EmployeeWorkingHoursResponse>}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'content'?: Array<EmployeeWorkingHoursResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageEmployeeWorkingHoursResponse
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageWorkingHoursResponse
 */
export interface PageWorkingHoursResponse {
    /**
     * 
     * @type {number}
     * @memberof PageWorkingHoursResponse
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageWorkingHoursResponse
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageWorkingHoursResponse
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageWorkingHoursResponse
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageWorkingHoursResponse
     */
    'size'?: number;
    /**
     * 
     * @type {Array<WorkingHoursResponse>}
     * @memberof PageWorkingHoursResponse
     */
    'content'?: Array<WorkingHoursResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageWorkingHoursResponse
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageWorkingHoursResponse
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageWorkingHoursResponse
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageWorkingHoursResponse
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageWorkingHoursResponse
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'size'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pageable
     */
    'sort'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageableObject
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseBookingServiceResponse
 */
export interface PaginatedResponseBookingServiceResponse {
    /**
     * 
     * @type {Array<BookingServiceResponse>}
     * @memberof PaginatedResponseBookingServiceResponse
     */
    'data': Array<BookingServiceResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseBookingServiceResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginatedResponseEmployeeResponse
 */
export interface PaginatedResponseEmployeeResponse {
    /**
     * 
     * @type {Array<EmployeeResponse>}
     * @memberof PaginatedResponseEmployeeResponse
     */
    'data': Array<EmployeeResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseEmployeeResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginatedResponseSalonResponse
 */
export interface PaginatedResponseSalonResponse {
    /**
     * 
     * @type {Array<SalonResponse>}
     * @memberof PaginatedResponseSalonResponse
     */
    'data': Array<SalonResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseSalonResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginatedResponseSalonServiceResponse
 */
export interface PaginatedResponseSalonServiceResponse {
    /**
     * 
     * @type {Array<SalonServiceResponse>}
     * @memberof PaginatedResponseSalonServiceResponse
     */
    'data': Array<SalonServiceResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseSalonServiceResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginatedResponseSalonStaffResponse
 */
export interface PaginatedResponseSalonStaffResponse {
    /**
     * 
     * @type {Array<SalonStaffResponse>}
     * @memberof PaginatedResponseSalonStaffResponse
     */
    'data': Array<SalonStaffResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseSalonStaffResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginatedResponseWaitingListResponse
 */
export interface PaginatedResponseWaitingListResponse {
    /**
     * 
     * @type {Array<WaitingListResponse>}
     * @memberof PaginatedResponseWaitingListResponse
     */
    'data': Array<WaitingListResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponseWaitingListResponse
     */
    'pagination': PaginationInfo;
}
/**
 * 
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface ReviewStatsResponse
 */
export interface ReviewStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof ReviewStatsResponse
     */
    'entityId': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewStatsResponse
     */
    'entityType': string;
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'averageRating': number;
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'totalReviews': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReviewStatsResponse
     */
    'ratingDistribution': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'averageStaffRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'averageServiceRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'averageCleanlinessRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewStatsResponse
     */
    'averageAtmosphereRating'?: number;
}
/**
 * 
 * @export
 * @interface SalonDetailResponse
 */
export interface SalonDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalonDetailResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'timezone': string;
    /**
     * 
     * @type {SalonUserAccessResponse}
     * @memberof SalonDetailResponse
     */
    'userAccess': SalonUserAccessResponse;
    /**
     * 
     * @type {SalonStatisticsResponse}
     * @memberof SalonDetailResponse
     */
    'statistics': SalonStatisticsResponse;
    /**
     * 
     * @type {Array<WorkResourceResponse>}
     * @memberof SalonDetailResponse
     */
    'workResources': Array<WorkResourceResponse>;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SalonDetailResponse
     */
    'updatedAt': string;
}
/**
 * Informace o salonu
 * @export
 * @interface SalonInfo
 */
export interface SalonInfo {
    /**
     * 
     * @type {string}
     * @memberof SalonInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonInfo
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SalonPublicResponse
 */
export interface SalonPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'timezone': string;
    /**
     * 
     * @type {Array<ServiceCategoryPublicResponse>}
     * @memberof SalonPublicResponse
     */
    'serviceCategories': Array<ServiceCategoryPublicResponse>;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'facebookUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'instagramUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'twitterUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalonPublicResponse
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof SalonPublicResponse
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonPublicResponse
     */
    'backgroundImageUrl'?: string;
    /**
     * 
     * @type {Array<WorkingHoursPublicResponse>}
     * @memberof SalonPublicResponse
     */
    'workingHours': Array<WorkingHoursPublicResponse>;
}
/**
 * 
 * @export
 * @interface SalonResponse
 */
export interface SalonResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalonResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'timezone': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SalonResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface SalonResponseRequest
 */
export interface SalonResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonResponseRequest
     */
    'salonResponse': string;
}
/**
 * 
 * @export
 * @interface SalonServiceResponse
 */
export interface SalonServiceResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'currency': string;
    /**
     * 
     * @type {boolean}
     * @memberof SalonServiceResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonServiceResponse
     */
    'isBookable': boolean;
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'categoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonServiceResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'staffCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'monthlyBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonServiceResponse
     */
    'averageRating'?: number;
}
/**
 * 
 * @export
 * @interface SalonStaffResponse
 */
export interface SalonStaffResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof SalonStaffResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonStaffResponse
     */
    'workingHours'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalonStaffResponse
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStaffResponse
     */
    'monthlyBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStaffResponse
     */
    'monthlyRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStaffResponse
     */
    'averageRating'?: number;
}
/**
 * 
 * @export
 * @interface SalonStatisticsResponse
 */
export interface SalonStatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'totalStaff': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'activeStaff': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'totalServices': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'activeServices': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'monthlyBookings': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'monthlyRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'averageRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'workResourcesCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalonStatisticsResponse
     */
    'availableWorkResources': number;
}
/**
 * 
 * @export
 * @interface SalonUserAccessResponse
 */
export interface SalonUserAccessResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonUserAccessResponse
     */
    'userRole'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalonUserAccessResponse
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SalonUserAccessResponse
     */
    'canManageSalon': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonUserAccessResponse
     */
    'canManageServices': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonUserAccessResponse
     */
    'canManageBookings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonUserAccessResponse
     */
    'canManageStaff': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonUserAccessResponse
     */
    'canViewReports': boolean;
}
/**
 * 
 * @export
 * @interface SalonWithAccessResponse
 */
export interface SalonWithAccessResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'timezone': string;
    /**
     * 
     * @type {string}
     * @memberof SalonWithAccessResponse
     */
    'userRole'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalonWithAccessResponse
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'canManageSalon': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'canManageServices': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'canManageBookings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'canManageStaff': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWithAccessResponse
     */
    'canViewReports': boolean;
    /**
     * 
     * @type {number}
     * @memberof SalonWithAccessResponse
     */
    'staffCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalonWithAccessResponse
     */
    'servicesCount': number;
    /**
     * 
     * @type {number}
     * @memberof SalonWithAccessResponse
     */
    'activeBookingsCount': number;
}
/**
 * 
 * @export
 * @interface SalonWorkingHoursItemRequest
 */
export interface SalonWorkingHoursItemRequest {
    /**
     * 
     * @type {number}
     * @memberof SalonWorkingHoursItemRequest
     */
    'weekday': number;
    /**
     * 
     * @type {Array<TimeIntervalRequest>}
     * @memberof SalonWorkingHoursItemRequest
     */
    'intervals': Array<TimeIntervalRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWorkingHoursItemRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface SalonWorkingHoursResponse
 */
export interface SalonWorkingHoursResponse {
    /**
     * 
     * @type {string}
     * @memberof SalonWorkingHoursResponse
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SalonWorkingHoursResponse
     */
    'weekday': number;
    /**
     * 
     * @type {string}
     * @memberof SalonWorkingHoursResponse
     */
    'weekdayName': string;
    /**
     * 
     * @type {Array<TimeIntervalResponse>}
     * @memberof SalonWorkingHoursResponse
     */
    'intervals': Array<TimeIntervalResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof SalonWorkingHoursResponse
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface ServiceCategoryPublicResponse
 */
export interface ServiceCategoryPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryPublicResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryPublicResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryPublicResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryPublicResponse
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryPublicResponse
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceCategoryPublicResponse
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface ServiceCategoryResponse
 */
export interface ServiceCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceCategoryResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServiceCategoryResponse
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoryResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ServiceInfo
 */
export interface ServiceInfo {
    /**
     * 
     * @type {string}
     * @memberof ServiceInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceInfo
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceInfo
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfo
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface ServicePerformance
 */
export interface ServicePerformance {
    /**
     * 
     * @type {string}
     * @memberof ServicePerformance
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof ServicePerformance
     */
    'serviceName': string;
    /**
     * 
     * @type {number}
     * @memberof ServicePerformance
     */
    'totalBookings': number;
    /**
     * 
     * @type {number}
     * @memberof ServicePerformance
     */
    'monthlyRevenue': number;
    /**
     * 
     * @type {number}
     * @memberof ServicePerformance
     */
    'averageRating': number;
    /**
     * 
     * @type {number}
     * @memberof ServicePerformance
     */
    'conversionRate': number;
}
/**
 * 
 * @export
 * @interface ServicePublicResponse
 */
export interface ServicePublicResponse {
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServicePublicResponse
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof ServicePublicResponse
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'currency': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServicePublicResponse
     */
    'isBookable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServicePublicResponse
     */
    'requiresDeposit': boolean;
    /**
     * 
     * @type {number}
     * @memberof ServicePublicResponse
     */
    'depositAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServicePublicResponse
     */
    'maxAdvanceBookingDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServicePublicResponse
     */
    'minAdvanceBookingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'cancellationPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'serviceCategoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicePublicResponse
     */
    'serviceCategoryName'?: string;
}
/**
 * 
 * @export
 * @interface ServiceRevenueInfo
 */
export interface ServiceRevenueInfo {
    /**
     * 
     * @type {string}
     * @memberof ServiceRevenueInfo
     */
    'serviceId': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRevenueInfo
     */
    'serviceName': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceRevenueInfo
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceRevenueInfo
     */
    'bookingCount': number;
}
/**
 * 
 * @export
 * @interface ServiceStatsResponse
 */
export interface ServiceStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'totalServices': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'activeServices': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'inactiveServices': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'averagePrice': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'averageDuration': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceStatsResponse
     */
    'totalMonthlyRevenue': number;
    /**
     * 
     * @type {Array<ServicePerformance>}
     * @memberof ServiceStatsResponse
     */
    'topPerformingServices': Array<ServicePerformance>;
    /**
     * 
     * @type {Array<CategoryStats>}
     * @memberof ServiceStatsResponse
     */
    'categoryBreakdown': Array<CategoryStats>;
}
/**
 * 
 * @export
 * @interface ServicesLoVResponse
 */
export interface ServicesLoVResponse {
    /**
     * 
     * @type {string}
     * @memberof ServicesLoVResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServicesLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ServicesLoVResponse
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ServicesLoVResponse
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof ServicesLoVResponse
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'unsorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'sorted'?: boolean;
}
/**
 * 
 * @export
 * @interface StaffLoVResponse
 */
export interface StaffLoVResponse {
    /**
     * 
     * @type {string}
     * @memberof StaffLoVResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StaffLoVResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface StaffMemberPublicResponse
 */
export interface StaffMemberPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof StaffMemberPublicResponse
     */
    'servicePriceOverride'?: number;
    /**
     * 
     * @type {number}
     * @memberof StaffMemberPublicResponse
     */
    'serviceDurationOverride'?: number;
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof StaffMemberPublicResponse
     */
    'salonName': string;
}
/**
 * 
 * @export
 * @interface TimeIntervalPublicResponse
 */
export interface TimeIntervalPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalPublicResponse
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalPublicResponse
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface TimeIntervalRequest
 */
export interface TimeIntervalRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalRequest
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalRequest
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof TimeIntervalRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface TimeIntervalResponse
 */
export interface TimeIntervalResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalResponse
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof TimeIntervalResponse
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof TimeIntervalResponse
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface UpdateBookingReviewRequest
 */
export interface UpdateBookingReviewRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingReviewRequest
     */
    'overallRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingReviewRequest
     */
    'staffRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingReviewRequest
     */
    'serviceRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingReviewRequest
     */
    'cleanlinessRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingReviewRequest
     */
    'atmosphereRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingReviewRequest
     */
    'reviewText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBookingReviewRequest
     */
    'isPublic'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBookingServiceRequest
 */
export interface UpdateBookingServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'categoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'salonId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingServiceRequest
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingServiceRequest
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBookingServiceRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBookingServiceRequest
     */
    'isBookable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBookingServiceRequest
     */
    'requiresDeposit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingServiceRequest
     */
    'depositAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingServiceRequest
     */
    'maxAdvanceBookingDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingServiceRequest
     */
    'minAdvanceBookingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'cancellationPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingServiceRequest
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCustomerNoteRequest
 */
export interface UpdateCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerNoteRequest
     */
    'noteText': string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeRequest
 */
export interface UpdateEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeRequest
     */
    'role': UpdateEmployeeRequestRoleEnum;
}

export const UpdateEmployeeRequestRoleEnum = {
    Owner: 'OWNER',
    Reception: 'RECEPTION',
    Worker: 'WORKER'
} as const;

export type UpdateEmployeeRequestRoleEnum = typeof UpdateEmployeeRequestRoleEnum[keyof typeof UpdateEmployeeRequestRoleEnum];

/**
 * 
 * @export
 * @interface UpdateEmployeeStatusRequest
 */
export interface UpdateEmployeeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeStatusRequest
     */
    'status': UpdateEmployeeStatusRequestStatusEnum;
}

export const UpdateEmployeeStatusRequestStatusEnum = {
    PendingVerification: 'PENDING_VERIFICATION',
    Suspended: 'SUSPENDED',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type UpdateEmployeeStatusRequestStatusEnum = typeof UpdateEmployeeStatusRequestStatusEnum[keyof typeof UpdateEmployeeStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateEmployeeWorkingHoursRequest
 */
export interface UpdateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeeWorkingHoursRequest
     */
    'weekday'?: number;
    /**
     * 
     * @type {Array<WorkingHoursIntervalDto>}
     * @memberof UpdateEmployeeWorkingHoursRequest
     */
    'intervals'?: Array<WorkingHoursIntervalDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmployeeWorkingHoursRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateSalonRequest
 */
export interface UpdateSalonRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalonRequest
     */
    'timezone': string;
}
/**
 * 
 * @export
 * @interface UpdateSalonStatusRequest
 */
export interface UpdateSalonStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSalonStatusRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface UpdateSalonWorkingHoursRequest
 */
export interface UpdateSalonWorkingHoursRequest {
    /**
     * 
     * @type {Array<SalonWorkingHoursItemRequest>}
     * @memberof UpdateSalonWorkingHoursRequest
     */
    'workingHours': Array<SalonWorkingHoursItemRequest>;
}
/**
 * 
 * @export
 * @interface UpdateServiceCategoryRequest
 */
export interface UpdateServiceCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceCategoryRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceCategoryRequest
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceCategoryRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceCategoryRequest
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateServiceCategoryRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceCategoryRequest
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface UpdateWaitingListRequest
 */
export interface UpdateWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'status'?: UpdateWaitingListRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWaitingListRequest
     */
    'timeFrom'?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWaitingListRequest
     */
    'timeTo'?: LocalTime;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'contactNotes'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWaitingListRequest
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'preferredWorkerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaitingListRequest
     */
    'preferredWorkResourceId'?: string;
}

export const UpdateWaitingListRequestStatusEnum = {
    Active: 'ACTIVE',
    Contacted: 'CONTACTED',
    Booked: 'BOOKED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    NoResponse: 'NO_RESPONSE'
} as const;

export type UpdateWaitingListRequestStatusEnum = typeof UpdateWaitingListRequestStatusEnum[keyof typeof UpdateWaitingListRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateWorkingHoursRequest
 */
export interface UpdateWorkingHoursRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkingHoursRequest
     */
    'weekday'?: number;
    /**
     * Čas začátku pracovních hodin
     * @type {string}
     * @memberof UpdateWorkingHoursRequest
     */
    'startTime'?: string;
    /**
     * Čas konce pracovních hodin
     * @type {string}
     * @memberof UpdateWorkingHoursRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkingHoursRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface UserAccessRights
 */
export interface UserAccessRights {
    /**
     * 
     * @type {string}
     * @memberof UserAccessRights
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessRights
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessRights
     */
    'salonName': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessRights
     */
    'role': UserAccessRightsRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageSalon': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageServices': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageStaff': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageCustomers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageBookings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canViewReports': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessRights
     */
    'canManageOwnSchedule': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAccessRights
     */
    'permissions': Array<string>;
}

export const UserAccessRightsRoleEnum = {
    Owner: 'OWNER',
    Reception: 'RECEPTION',
    Worker: 'WORKER'
} as const;

export type UserAccessRightsRoleEnum = typeof UserAccessRightsRoleEnum[keyof typeof UserAccessRightsRoleEnum];

/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'phoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    'isAdmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'status': UserResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {UserAccessRights}
     * @memberof UserResponse
     */
    'accessRights': UserAccessRights;
}

export const UserResponseStatusEnum = {
    PendingVerification: 'PENDING_VERIFICATION',
    Suspended: 'SUSPENDED',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type UserResponseStatusEnum = typeof UserResponseStatusEnum[keyof typeof UserResponseStatusEnum];

/**
 * 
 * @export
 * @interface UserSearchResponse
 */
export interface UserSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'phoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSearchResponse
     */
    'isAdmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSearchResponse
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface WaitingListResponse
 */
export interface WaitingListResponse {
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'status': WaitingListResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'dateTo': string;
    /**
     * 
     * @type {LocalTime}
     * @memberof WaitingListResponse
     */
    'timeFrom'?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof WaitingListResponse
     */
    'timeTo'?: LocalTime;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'contactedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'contactNotes'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaitingListResponse
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof WaitingListResponse
     */
    'customer': CustomerInfo;
    /**
     * 
     * @type {ServiceInfo}
     * @memberof WaitingListResponse
     */
    'service': ServiceInfo;
    /**
     * 
     * @type {SalonInfo}
     * @memberof WaitingListResponse
     */
    'salon': SalonInfo;
    /**
     * 
     * @type {WorkerInfo}
     * @memberof WaitingListResponse
     */
    'preferredWorker'?: WorkerInfo;
    /**
     * 
     * @type {WorkResourceInfo}
     * @memberof WaitingListResponse
     */
    'preferredWorkResource'?: WorkResourceInfo;
    /**
     * 
     * @type {string}
     * @memberof WaitingListResponse
     */
    'resultingBookingId'?: string;
}

export const WaitingListResponseStatusEnum = {
    Active: 'ACTIVE',
    Contacted: 'CONTACTED',
    Booked: 'BOOKED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    NoResponse: 'NO_RESPONSE'
} as const;

export type WaitingListResponseStatusEnum = typeof WaitingListResponseStatusEnum[keyof typeof WaitingListResponseStatusEnum];

/**
 * Informace o pracovišti
 * @export
 * @interface WorkResourceInfo
 */
export interface WorkResourceInfo {
    /**
     * 
     * @type {string}
     * @memberof WorkResourceInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkResourceInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkResourceInfo
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface WorkResourceResponse
 */
export interface WorkResourceResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkResourceResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkResourceResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkResourceResponse
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkResourceResponse
     */
    'isBookable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkResourceResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkResourceResponse
     */
    'assignedStaffCount': number;
}
/**
 * Informace o zaměstnanci
 * @export
 * @interface WorkerInfo
 */
export interface WorkerInfo {
    /**
     * 
     * @type {string}
     * @memberof WorkerInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkerInfo
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface WorkerStats
 */
export interface WorkerStats {
    /**
     * 
     * @type {string}
     * @memberof WorkerStats
     */
    'workerId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkerStats
     */
    'workerName': string;
    /**
     * 
     * @type {number}
     * @memberof WorkerStats
     */
    'bookingCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkerStats
     */
    'revenue': number;
}
/**
 * 
 * @export
 * @interface WorkingHoursIntervalDto
 */
export interface WorkingHoursIntervalDto {
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursIntervalDto
     */
    'id'?: string;
    /**
     * Čas začátku pracovního intervalu
     * @type {string}
     * @memberof WorkingHoursIntervalDto
     */
    'startTime': string;
    /**
     * Čas konce pracovního intervalu
     * @type {string}
     * @memberof WorkingHoursIntervalDto
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursIntervalDto
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface WorkingHoursIntervalResponse
 */
export interface WorkingHoursIntervalResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursIntervalResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursIntervalResponse
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursIntervalResponse
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursIntervalResponse
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface WorkingHoursPublicResponse
 */
export interface WorkingHoursPublicResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursPublicResponse
     */
    'weekday': number;
    /**
     * 
     * @type {Array<TimeIntervalPublicResponse>}
     * @memberof WorkingHoursPublicResponse
     */
    'intervals': Array<TimeIntervalPublicResponse>;
}
/**
 * 
 * @export
 * @interface WorkingHoursResponse
 */
export interface WorkingHoursResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'salonId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'salonName': string;
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursResponse
     */
    'weekday': number;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'weekdayName': string;
    /**
     * Čas začátku pracovních hodin
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'startTime': string;
    /**
     * Čas konce pracovních hodin
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursResponse
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof WorkingHoursResponse
     */
    'updatedBy': string;
}

/**
 * AbsencesApi - axios parameter creator
 * @export
 */
export const AbsencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří novou absenci pro zaměstnance nebo pro všechny zaměstnance
         * @summary Vytvoří novou absenci
         * @param {AppCreateAbsenceDto} appCreateAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence: async (appCreateAbsenceDto: AppCreateAbsenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appCreateAbsenceDto' is not null or undefined
            assertParamExists('createAbsence', 'appCreateAbsenceDto', appCreateAbsenceDto)
            const localVarPath = `/absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appCreateAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže absenci (soft delete - nastaví isActive na false)
         * @summary Smaže absenci
         * @param {string} absenceId ID absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsence: async (absenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('deleteAbsence', 'absenceId', absenceId)
            const localVarPath = `/absences/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam absencí pro vybraný salon v zadaném časovém rozmezí
         * @summary Získá seznam absencí pro salon v časovém rozmezí
         * @param {string} salonId ID salonu
         * @param {string} startDate Datum od ve formátu YYYY-MM-DD
         * @param {string} endDate Datum do ve formátu YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesBySalonAndDateRange: async (salonId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getAbsencesBySalonAndDateRange', 'salonId', salonId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAbsencesBySalonAndDateRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAbsencesBySalonAndDateRange', 'endDate', endDate)
            const localVarPath = `/absences/salon/{salonId}`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam absencí filtrovaných podle typu
         * @summary Získá seznam absencí podle typu
         * @param {GetAbsencesByTypeTypeEnum} type Typ absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByType: async (type: GetAbsencesByTypeTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAbsencesByType', 'type', type)
            const localVarPath = `/absences/type/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele
         * @summary Získá seznam absencí pro konkrétního uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAbsencesByUser', 'userId', userId)
            const localVarPath = `/absences/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele filtrovaných podle typu
         * @summary Získá seznam absencí pro uživatele podle typu
         * @param {string} userId ID uživatele
         * @param {GetAbsencesByUserAndTypeTypeEnum} type Typ absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByUserAndType: async (userId: string, type: GetAbsencesByUserAndTypeTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAbsencesByUserAndType', 'userId', userId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAbsencesByUserAndType', 'type', type)
            const localVarPath = `/absences/user/{userId}/type/{type}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam absencí, které jsou platné (dnes nebo v budoucnosti)
         * @summary Získá seznam všech aktuálních absencí
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAbsences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obnoví smazanou absenci (nastaví isActive na true)
         * @summary Obnoví absenci
         * @param {string} absenceId ID absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAbsence: async (absenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('restoreAbsence', 'absenceId', absenceId)
            const localVarPath = `/absences/{absenceId}/restore`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující absenci
         * @summary Aktualizuje absenci
         * @param {string} absenceId ID absence
         * @param {AppCreateAbsenceDto} appCreateAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsence: async (absenceId: string, appCreateAbsenceDto: AppCreateAbsenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('updateAbsence', 'absenceId', absenceId)
            // verify required parameter 'appCreateAbsenceDto' is not null or undefined
            assertParamExists('updateAbsence', 'appCreateAbsenceDto', appCreateAbsenceDto)
            const localVarPath = `/absences/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appCreateAbsenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbsencesApi - functional programming interface
 * @export
 */
export const AbsencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbsencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří novou absenci pro zaměstnance nebo pro všechny zaměstnance
         * @summary Vytvoří novou absenci
         * @param {AppCreateAbsenceDto} appCreateAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbsence(appCreateAbsenceDto: AppCreateAbsenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbsence(appCreateAbsenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.createAbsence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže absenci (soft delete - nastaví isActive na false)
         * @summary Smaže absenci
         * @param {string} absenceId ID absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAbsence(absenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAbsence(absenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.deleteAbsence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam absencí pro vybraný salon v zadaném časovém rozmezí
         * @summary Získá seznam absencí pro salon v časovém rozmezí
         * @param {string} salonId ID salonu
         * @param {string} startDate Datum od ve formátu YYYY-MM-DD
         * @param {string} endDate Datum do ve formátu YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesBySalonAndDateRange(salonId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesBySalonAndDateRange(salonId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.getAbsencesBySalonAndDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam absencí filtrovaných podle typu
         * @summary Získá seznam absencí podle typu
         * @param {GetAbsencesByTypeTypeEnum} type Typ absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesByType(type: GetAbsencesByTypeTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesByType(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.getAbsencesByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele
         * @summary Získá seznam absencí pro konkrétního uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.getAbsencesByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele filtrovaných podle typu
         * @summary Získá seznam absencí pro uživatele podle typu
         * @param {string} userId ID uživatele
         * @param {GetAbsencesByUserAndTypeTypeEnum} type Typ absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesByUserAndType(userId: string, type: GetAbsencesByUserAndTypeTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesByUserAndType(userId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.getAbsencesByUserAndType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam absencí, které jsou platné (dnes nebo v budoucnosti)
         * @summary Získá seznam všech aktuálních absencí
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAbsences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppAbsenceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAbsences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.getCurrentAbsences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obnoví smazanou absenci (nastaví isActive na true)
         * @summary Obnoví absenci
         * @param {string} absenceId ID absence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreAbsence(absenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreAbsence(absenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.restoreAbsence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující absenci
         * @summary Aktualizuje absenci
         * @param {string} absenceId ID absence
         * @param {AppCreateAbsenceDto} appCreateAbsenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsence(absenceId: string, appCreateAbsenceDto: AppCreateAbsenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppAbsenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsence(absenceId, appCreateAbsenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbsencesApi.updateAbsence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AbsencesApi - factory interface
 * @export
 */
export const AbsencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbsencesApiFp(configuration)
    return {
        /**
         * Vytvoří novou absenci pro zaměstnance nebo pro všechny zaměstnance
         * @summary Vytvoří novou absenci
         * @param {AbsencesApiCreateAbsenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence(requestParameters: AbsencesApiCreateAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto> {
            return localVarFp.createAbsence(requestParameters.appCreateAbsenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže absenci (soft delete - nastaví isActive na false)
         * @summary Smaže absenci
         * @param {AbsencesApiDeleteAbsenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsence(requestParameters: AbsencesApiDeleteAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAbsence(requestParameters.absenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam absencí pro vybraný salon v zadaném časovém rozmezí
         * @summary Získá seznam absencí pro salon v časovém rozmezí
         * @param {AbsencesApiGetAbsencesBySalonAndDateRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesBySalonAndDateRange(requestParameters: AbsencesApiGetAbsencesBySalonAndDateRangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>> {
            return localVarFp.getAbsencesBySalonAndDateRange(requestParameters.salonId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam absencí filtrovaných podle typu
         * @summary Získá seznam absencí podle typu
         * @param {AbsencesApiGetAbsencesByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByType(requestParameters: AbsencesApiGetAbsencesByTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>> {
            return localVarFp.getAbsencesByType(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele
         * @summary Získá seznam absencí pro konkrétního uživatele
         * @param {AbsencesApiGetAbsencesByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByUser(requestParameters: AbsencesApiGetAbsencesByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>> {
            return localVarFp.getAbsencesByUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam absencí pro vybraného uživatele filtrovaných podle typu
         * @summary Získá seznam absencí pro uživatele podle typu
         * @param {AbsencesApiGetAbsencesByUserAndTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesByUserAndType(requestParameters: AbsencesApiGetAbsencesByUserAndTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>> {
            return localVarFp.getAbsencesByUserAndType(requestParameters.userId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam absencí, které jsou platné (dnes nebo v budoucnosti)
         * @summary Získá seznam všech aktuálních absencí
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAbsences(options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>> {
            return localVarFp.getCurrentAbsences(options).then((request) => request(axios, basePath));
        },
        /**
         * Obnoví smazanou absenci (nastaví isActive na true)
         * @summary Obnoví absenci
         * @param {AbsencesApiRestoreAbsenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAbsence(requestParameters: AbsencesApiRestoreAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto> {
            return localVarFp.restoreAbsence(requestParameters.absenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující absenci
         * @summary Aktualizuje absenci
         * @param {AbsencesApiUpdateAbsenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsence(requestParameters: AbsencesApiUpdateAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto> {
            return localVarFp.updateAbsence(requestParameters.absenceId, requestParameters.appCreateAbsenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbsencesApi - interface
 * @export
 * @interface AbsencesApi
 */
export interface AbsencesApiInterface {
    /**
     * Vytvoří novou absenci pro zaměstnance nebo pro všechny zaměstnance
     * @summary Vytvoří novou absenci
     * @param {AbsencesApiCreateAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    createAbsence(requestParameters: AbsencesApiCreateAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto>;

    /**
     * Smaže absenci (soft delete - nastaví isActive na false)
     * @summary Smaže absenci
     * @param {AbsencesApiDeleteAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    deleteAbsence(requestParameters: AbsencesApiDeleteAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrací seznam absencí pro vybraný salon v zadaném časovém rozmezí
     * @summary Získá seznam absencí pro salon v časovém rozmezí
     * @param {AbsencesApiGetAbsencesBySalonAndDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    getAbsencesBySalonAndDateRange(requestParameters: AbsencesApiGetAbsencesBySalonAndDateRangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>>;

    /**
     * Vrací seznam absencí filtrovaných podle typu
     * @summary Získá seznam absencí podle typu
     * @param {AbsencesApiGetAbsencesByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    getAbsencesByType(requestParameters: AbsencesApiGetAbsencesByTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>>;

    /**
     * Vrací seznam absencí pro vybraného uživatele
     * @summary Získá seznam absencí pro konkrétního uživatele
     * @param {AbsencesApiGetAbsencesByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    getAbsencesByUser(requestParameters: AbsencesApiGetAbsencesByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>>;

    /**
     * Vrací seznam absencí pro vybraného uživatele filtrovaných podle typu
     * @summary Získá seznam absencí pro uživatele podle typu
     * @param {AbsencesApiGetAbsencesByUserAndTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    getAbsencesByUserAndType(requestParameters: AbsencesApiGetAbsencesByUserAndTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>>;

    /**
     * Vrací seznam absencí, které jsou platné (dnes nebo v budoucnosti)
     * @summary Získá seznam všech aktuálních absencí
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    getCurrentAbsences(options?: RawAxiosRequestConfig): AxiosPromise<Array<AppAbsenceDto>>;

    /**
     * Obnoví smazanou absenci (nastaví isActive na true)
     * @summary Obnoví absenci
     * @param {AbsencesApiRestoreAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    restoreAbsence(requestParameters: AbsencesApiRestoreAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto>;

    /**
     * Aktualizuje existující absenci
     * @summary Aktualizuje absenci
     * @param {AbsencesApiUpdateAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApiInterface
     */
    updateAbsence(requestParameters: AbsencesApiUpdateAbsenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppAbsenceDto>;

}

/**
 * Request parameters for createAbsence operation in AbsencesApi.
 * @export
 * @interface AbsencesApiCreateAbsenceRequest
 */
export interface AbsencesApiCreateAbsenceRequest {
    /**
     * 
     * @type {AppCreateAbsenceDto}
     * @memberof AbsencesApiCreateAbsence
     */
    readonly appCreateAbsenceDto: AppCreateAbsenceDto
}

/**
 * Request parameters for deleteAbsence operation in AbsencesApi.
 * @export
 * @interface AbsencesApiDeleteAbsenceRequest
 */
export interface AbsencesApiDeleteAbsenceRequest {
    /**
     * ID absence
     * @type {string}
     * @memberof AbsencesApiDeleteAbsence
     */
    readonly absenceId: string
}

/**
 * Request parameters for getAbsencesBySalonAndDateRange operation in AbsencesApi.
 * @export
 * @interface AbsencesApiGetAbsencesBySalonAndDateRangeRequest
 */
export interface AbsencesApiGetAbsencesBySalonAndDateRangeRequest {
    /**
     * ID salonu
     * @type {string}
     * @memberof AbsencesApiGetAbsencesBySalonAndDateRange
     */
    readonly salonId: string

    /**
     * Datum od ve formátu YYYY-MM-DD
     * @type {string}
     * @memberof AbsencesApiGetAbsencesBySalonAndDateRange
     */
    readonly startDate: string

    /**
     * Datum do ve formátu YYYY-MM-DD
     * @type {string}
     * @memberof AbsencesApiGetAbsencesBySalonAndDateRange
     */
    readonly endDate: string
}

/**
 * Request parameters for getAbsencesByType operation in AbsencesApi.
 * @export
 * @interface AbsencesApiGetAbsencesByTypeRequest
 */
export interface AbsencesApiGetAbsencesByTypeRequest {
    /**
     * Typ absence
     * @type {'VACATION' | 'ILLNESS' | 'PRIVATE' | 'BLOCK' | 'CALENDAR_BLOCK'}
     * @memberof AbsencesApiGetAbsencesByType
     */
    readonly type: GetAbsencesByTypeTypeEnum
}

/**
 * Request parameters for getAbsencesByUser operation in AbsencesApi.
 * @export
 * @interface AbsencesApiGetAbsencesByUserRequest
 */
export interface AbsencesApiGetAbsencesByUserRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof AbsencesApiGetAbsencesByUser
     */
    readonly userId: string
}

/**
 * Request parameters for getAbsencesByUserAndType operation in AbsencesApi.
 * @export
 * @interface AbsencesApiGetAbsencesByUserAndTypeRequest
 */
export interface AbsencesApiGetAbsencesByUserAndTypeRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof AbsencesApiGetAbsencesByUserAndType
     */
    readonly userId: string

    /**
     * Typ absence
     * @type {'VACATION' | 'ILLNESS' | 'PRIVATE' | 'BLOCK' | 'CALENDAR_BLOCK'}
     * @memberof AbsencesApiGetAbsencesByUserAndType
     */
    readonly type: GetAbsencesByUserAndTypeTypeEnum
}

/**
 * Request parameters for restoreAbsence operation in AbsencesApi.
 * @export
 * @interface AbsencesApiRestoreAbsenceRequest
 */
export interface AbsencesApiRestoreAbsenceRequest {
    /**
     * ID absence
     * @type {string}
     * @memberof AbsencesApiRestoreAbsence
     */
    readonly absenceId: string
}

/**
 * Request parameters for updateAbsence operation in AbsencesApi.
 * @export
 * @interface AbsencesApiUpdateAbsenceRequest
 */
export interface AbsencesApiUpdateAbsenceRequest {
    /**
     * ID absence
     * @type {string}
     * @memberof AbsencesApiUpdateAbsence
     */
    readonly absenceId: string

    /**
     * 
     * @type {AppCreateAbsenceDto}
     * @memberof AbsencesApiUpdateAbsence
     */
    readonly appCreateAbsenceDto: AppCreateAbsenceDto
}

/**
 * AbsencesApi - object-oriented interface
 * @export
 * @class AbsencesApi
 * @extends {BaseAPI}
 */
export class AbsencesApi extends BaseAPI implements AbsencesApiInterface {
    /**
     * Vytvoří novou absenci pro zaměstnance nebo pro všechny zaměstnance
     * @summary Vytvoří novou absenci
     * @param {AbsencesApiCreateAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public createAbsence(requestParameters: AbsencesApiCreateAbsenceRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).createAbsence(requestParameters.appCreateAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže absenci (soft delete - nastaví isActive na false)
     * @summary Smaže absenci
     * @param {AbsencesApiDeleteAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public deleteAbsence(requestParameters: AbsencesApiDeleteAbsenceRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).deleteAbsence(requestParameters.absenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam absencí pro vybraný salon v zadaném časovém rozmezí
     * @summary Získá seznam absencí pro salon v časovém rozmezí
     * @param {AbsencesApiGetAbsencesBySalonAndDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAbsencesBySalonAndDateRange(requestParameters: AbsencesApiGetAbsencesBySalonAndDateRangeRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).getAbsencesBySalonAndDateRange(requestParameters.salonId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam absencí filtrovaných podle typu
     * @summary Získá seznam absencí podle typu
     * @param {AbsencesApiGetAbsencesByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAbsencesByType(requestParameters: AbsencesApiGetAbsencesByTypeRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).getAbsencesByType(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam absencí pro vybraného uživatele
     * @summary Získá seznam absencí pro konkrétního uživatele
     * @param {AbsencesApiGetAbsencesByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAbsencesByUser(requestParameters: AbsencesApiGetAbsencesByUserRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).getAbsencesByUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam absencí pro vybraného uživatele filtrovaných podle typu
     * @summary Získá seznam absencí pro uživatele podle typu
     * @param {AbsencesApiGetAbsencesByUserAndTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAbsencesByUserAndType(requestParameters: AbsencesApiGetAbsencesByUserAndTypeRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).getAbsencesByUserAndType(requestParameters.userId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam absencí, které jsou platné (dnes nebo v budoucnosti)
     * @summary Získá seznam všech aktuálních absencí
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getCurrentAbsences(options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).getCurrentAbsences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obnoví smazanou absenci (nastaví isActive na true)
     * @summary Obnoví absenci
     * @param {AbsencesApiRestoreAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public restoreAbsence(requestParameters: AbsencesApiRestoreAbsenceRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).restoreAbsence(requestParameters.absenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující absenci
     * @summary Aktualizuje absenci
     * @param {AbsencesApiUpdateAbsenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public updateAbsence(requestParameters: AbsencesApiUpdateAbsenceRequest, options?: RawAxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).updateAbsence(requestParameters.absenceId, requestParameters.appCreateAbsenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAbsencesByTypeTypeEnum = {
    Vacation: 'VACATION',
    Illness: 'ILLNESS',
    Private: 'PRIVATE',
    Block: 'BLOCK',
    CalendarBlock: 'CALENDAR_BLOCK'
} as const;
export type GetAbsencesByTypeTypeEnum = typeof GetAbsencesByTypeTypeEnum[keyof typeof GetAbsencesByTypeTypeEnum];
/**
 * @export
 */
export const GetAbsencesByUserAndTypeTypeEnum = {
    Vacation: 'VACATION',
    Illness: 'ILLNESS',
    Private: 'PRIVATE',
    Block: 'BLOCK',
    CalendarBlock: 'CALENDAR_BLOCK'
} as const;
export type GetAbsencesByUserAndTypeTypeEnum = typeof GetAbsencesByUserAndTypeTypeEnum[keyof typeof GetAbsencesByUserAndTypeTypeEnum];


/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pouze pro ADMIN uživatele
         * @summary Vytvořit a odeslat pozvánku
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (createInvitationRequest: CreateInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationRequest' is not null or undefined
            assertParamExists('createInvitation', 'createInvitationRequest', createInvitationRequest)
            const localVarPath = `/admin/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Otestuje Mailjet API podle oficiální dokumentace
         * @summary Test Mailjet API
         * @param {string} toEmail 
         * @param {string} [toName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMailjet: async (toEmail: string, toName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toEmail' is not null or undefined
            assertParamExists('testMailjet', 'toEmail', toEmail)
            const localVarPath = `/admin/test-mailjet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (toEmail !== undefined) {
                localVarQueryParameter['toEmail'] = toEmail;
            }

            if (toName !== undefined) {
                localVarQueryParameter['toName'] = toName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Pouze pro ADMIN uživatele
         * @summary Vytvořit a odeslat pozvánku
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(createInvitationRequest: CreateInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(createInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Otestuje Mailjet API podle oficiální dokumentace
         * @summary Test Mailjet API
         * @param {string} toEmail 
         * @param {string} [toName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testMailjet(toEmail: string, toName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testMailjet(toEmail, toName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.testMailjet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * Pouze pro ADMIN uživatele
         * @summary Vytvořit a odeslat pozvánku
         * @param {AdminApiCreateInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(requestParameters: AdminApiCreateInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitationResponse> {
            return localVarFp.createInvitation(requestParameters.createInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Otestuje Mailjet API podle oficiální dokumentace
         * @summary Test Mailjet API
         * @param {AdminApiTestMailjetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMailjet(requestParameters: AdminApiTestMailjetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.testMailjet(requestParameters.toEmail, requestParameters.toName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - interface
 * @export
 * @interface AdminApi
 */
export interface AdminApiInterface {
    /**
     * Pouze pro ADMIN uživatele
     * @summary Vytvořit a odeslat pozvánku
     * @param {AdminApiCreateInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    createInvitation(requestParameters: AdminApiCreateInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitationResponse>;

    /**
     * Otestuje Mailjet API podle oficiální dokumentace
     * @summary Test Mailjet API
     * @param {AdminApiTestMailjetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    testMailjet(requestParameters: AdminApiTestMailjetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

}

/**
 * Request parameters for createInvitation operation in AdminApi.
 * @export
 * @interface AdminApiCreateInvitationRequest
 */
export interface AdminApiCreateInvitationRequest {
    /**
     * 
     * @type {CreateInvitationRequest}
     * @memberof AdminApiCreateInvitation
     */
    readonly createInvitationRequest: CreateInvitationRequest
}

/**
 * Request parameters for testMailjet operation in AdminApi.
 * @export
 * @interface AdminApiTestMailjetRequest
 */
export interface AdminApiTestMailjetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiTestMailjet
     */
    readonly toEmail: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiTestMailjet
     */
    readonly toName?: string
}

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI implements AdminApiInterface {
    /**
     * Pouze pro ADMIN uživatele
     * @summary Vytvořit a odeslat pozvánku
     * @param {AdminApiCreateInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public createInvitation(requestParameters: AdminApiCreateInvitationRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).createInvitation(requestParameters.createInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Otestuje Mailjet API podle oficiální dokumentace
     * @summary Test Mailjet API
     * @param {AdminApiTestMailjetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public testMailjet(requestParameters: AdminApiTestMailjetRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).testMailjet(requestParameters.toEmail, requestParameters.toName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Změní heslo aktuálně přihlášeného uživatele
         * @summary Změna hesla
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Přihlásí uživatele pomocí emailu a hesla
         * @summary Přihlášení uživatele
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zaregistruje nového uživatele do systému
         * @summary Registrace nového uživatele
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerRequest: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('register', 'registerRequest', registerRequest)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí informace o aktuálně přihlášeném uživateli nebo 401 pokud není autentifikován
         * @summary Získat informace o aktuálním uživateli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/whoAmI`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Změní heslo aktuálně přihlášeného uživatele
         * @summary Změna hesla
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Přihlásí uživatele pomocí emailu a hesla
         * @summary Přihlášení uživatele
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zaregistruje nového uživatele do systému
         * @summary Registrace nového uživatele
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí informace o aktuálně přihlášeném uživateli nebo 401 pokud není autentifikován
         * @summary Získat informace o aktuálním uživateli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whoAmI(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whoAmI(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.whoAmI']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Změní heslo aktuálně přihlášeného uživatele
         * @summary Změna hesla
         * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.changePassword(requestParameters.changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Přihlásí uživatele pomocí emailu a hesla
         * @summary Přihlášení uživatele
         * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.login(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Zaregistruje nového uživatele do systému
         * @summary Registrace nového uživatele
         * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.register(requestParameters.registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí informace o aktuálně přihlášeném uživateli nebo 401 pokud není autentifikován
         * @summary Získat informace o aktuálním uživateli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoAmI(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.whoAmI(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
    /**
     * Změní heslo aktuálně přihlášeného uživatele
     * @summary Změna hesla
     * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse>;

    /**
     * Přihlásí uživatele pomocí emailu a hesla
     * @summary Přihlášení uživatele
     * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse>;

    /**
     * Zaregistruje nového uživatele do systému
     * @summary Registrace nového uživatele
     * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse>;

    /**
     * Vrátí informace o aktuálně přihlášeném uživateli nebo 401 pokud není autentifikován
     * @summary Získat informace o aktuálním uživateli
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    whoAmI(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse>;

}

/**
 * Request parameters for changePassword operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiChangePasswordRequest
 */
export interface AuthenticationApiChangePasswordRequest {
    /**
     * 
     * @type {ChangePasswordRequest}
     * @memberof AuthenticationApiChangePassword
     */
    readonly changePasswordRequest: ChangePasswordRequest
}

/**
 * Request parameters for login operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiLoginRequest
 */
export interface AuthenticationApiLoginRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof AuthenticationApiLogin
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for register operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiRegisterRequest
 */
export interface AuthenticationApiRegisterRequest {
    /**
     * 
     * @type {RegisterRequest}
     * @memberof AuthenticationApiRegister
     */
    readonly registerRequest: RegisterRequest
}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI implements AuthenticationApiInterface {
    /**
     * Změní heslo aktuálně přihlášeného uživatele
     * @summary Změna hesla
     * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).changePassword(requestParameters.changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Přihlásí uživatele pomocí emailu a hesla
     * @summary Přihlášení uživatele
     * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zaregistruje nového uživatele do systému
     * @summary Registrace nového uživatele
     * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).register(requestParameters.registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí informace o aktuálně přihlášeném uživateli nebo 401 pokud není autentifikován
     * @summary Získat informace o aktuálním uživateli
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public whoAmI(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).whoAmI(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingListApi - axios parameter creator
 * @export
 */
export const BookingListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exportuje rezervace do CSV, Excel nebo PDF formátu
         * @summary Export rezervací
         * @param {AppBookingExportRequest} appBookingExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBookings: async (appBookingExportRequest: AppBookingExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appBookingExportRequest' is not null or undefined
            assertParamExists('exportBookings', 'appBookingExportRequest', appBookingExportRequest)
            const localVarPath = `/api/v1/bookings/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appBookingExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací stránkovaný seznam rezervací s pokročilými filtry a sumarizací
         * @summary Získat stránkovaný seznam rezervací
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání v jménech klientů a služeb
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {number} [page] Číslo stránky (0-based)
         * @param {number} [size] Velikost stránky
         * @param {string} [sortBy] Pole pro řazení
         * @param {string} [sortOrder] Směr řazení (asc/desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingList: async (dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookings/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací sumarizaci rezervací podle stavu a tržeb
         * @summary Získat sumarizaci rezervací
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingSummary1: async (dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookings/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exportuje rezervace pomocí GET parametrů
         * @summary Rychlý export rezervací (GET)
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {string} [format] Formát exportu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickExportBookings: async (dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, format?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookings/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingListApi - functional programming interface
 * @export
 */
export const BookingListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingListApiAxiosParamCreator(configuration)
    return {
        /**
         * Exportuje rezervace do CSV, Excel nebo PDF formátu
         * @summary Export rezervací
         * @param {AppBookingExportRequest} appBookingExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBookings(appBookingExportRequest: AppBookingExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBookings(appBookingExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingListApi.exportBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací stránkovaný seznam rezervací s pokročilými filtry a sumarizací
         * @summary Získat stránkovaný seznam rezervací
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání v jménech klientů a služeb
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {number} [page] Číslo stránky (0-based)
         * @param {number} [size] Velikost stránky
         * @param {string} [sortBy] Pole pro řazení
         * @param {string} [sortOrder] Směr řazení (asc/desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingList(dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppBookingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingList(dateFrom, dateTo, query, state, salonId, workerId, customerId, page, size, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingListApi.getBookingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací sumarizaci rezervací podle stavu a tržeb
         * @summary Získat sumarizaci rezervací
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingSummary1(dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppBookingSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingSummary1(dateFrom, dateTo, query, state, salonId, workerId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingListApi.getBookingSummary1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exportuje rezervace pomocí GET parametrů
         * @summary Rychlý export rezervací (GET)
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {string} [query] Full-text vyhledávání
         * @param {string} [state] Stav rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [customerId] ID zákazníka
         * @param {string} [format] Formát exportu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quickExportBookings(dateFrom?: string, dateTo?: string, query?: string, state?: string, salonId?: string, workerId?: string, customerId?: string, format?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quickExportBookings(dateFrom, dateTo, query, state, salonId, workerId, customerId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingListApi.quickExportBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingListApi - factory interface
 * @export
 */
export const BookingListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingListApiFp(configuration)
    return {
        /**
         * Exportuje rezervace do CSV, Excel nebo PDF formátu
         * @summary Export rezervací
         * @param {BookingListApiExportBookingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBookings(requestParameters: BookingListApiExportBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportBookings(requestParameters.appBookingExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací stránkovaný seznam rezervací s pokročilými filtry a sumarizací
         * @summary Získat stránkovaný seznam rezervací
         * @param {BookingListApiGetBookingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingList(requestParameters: BookingListApiGetBookingListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingListResponse> {
            return localVarFp.getBookingList(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací sumarizaci rezervací podle stavu a tržeb
         * @summary Získat sumarizaci rezervací
         * @param {BookingListApiGetBookingSummary1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingSummary1(requestParameters: BookingListApiGetBookingSummary1Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingSummaryDto> {
            return localVarFp.getBookingSummary1(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Exportuje rezervace pomocí GET parametrů
         * @summary Rychlý export rezervací (GET)
         * @param {BookingListApiQuickExportBookingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickExportBookings(requestParameters: BookingListApiQuickExportBookingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.quickExportBookings(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingListApi - interface
 * @export
 * @interface BookingListApi
 */
export interface BookingListApiInterface {
    /**
     * Exportuje rezervace do CSV, Excel nebo PDF formátu
     * @summary Export rezervací
     * @param {BookingListApiExportBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApiInterface
     */
    exportBookings(requestParameters: BookingListApiExportBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Vrací stránkovaný seznam rezervací s pokročilými filtry a sumarizací
     * @summary Získat stránkovaný seznam rezervací
     * @param {BookingListApiGetBookingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApiInterface
     */
    getBookingList(requestParameters?: BookingListApiGetBookingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingListResponse>;

    /**
     * Vrací sumarizaci rezervací podle stavu a tržeb
     * @summary Získat sumarizaci rezervací
     * @param {BookingListApiGetBookingSummary1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApiInterface
     */
    getBookingSummary1(requestParameters?: BookingListApiGetBookingSummary1Request, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingSummaryDto>;

    /**
     * Exportuje rezervace pomocí GET parametrů
     * @summary Rychlý export rezervací (GET)
     * @param {BookingListApiQuickExportBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApiInterface
     */
    quickExportBookings(requestParameters?: BookingListApiQuickExportBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * Request parameters for exportBookings operation in BookingListApi.
 * @export
 * @interface BookingListApiExportBookingsRequest
 */
export interface BookingListApiExportBookingsRequest {
    /**
     * 
     * @type {AppBookingExportRequest}
     * @memberof BookingListApiExportBookings
     */
    readonly appBookingExportRequest: AppBookingExportRequest
}

/**
 * Request parameters for getBookingList operation in BookingListApi.
 * @export
 * @interface BookingListApiGetBookingListRequest
 */
export interface BookingListApiGetBookingListRequest {
    /**
     * Datum od
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly dateFrom?: string

    /**
     * Datum do
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly dateTo?: string

    /**
     * Full-text vyhledávání v jménech klientů a služeb
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly query?: string

    /**
     * Stav rezervace
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly state?: string

    /**
     * ID salonu
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly salonId?: string

    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly workerId?: string

    /**
     * ID zákazníka
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly customerId?: string

    /**
     * Číslo stránky (0-based)
     * @type {number}
     * @memberof BookingListApiGetBookingList
     */
    readonly page?: number

    /**
     * Velikost stránky
     * @type {number}
     * @memberof BookingListApiGetBookingList
     */
    readonly size?: number

    /**
     * Pole pro řazení
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly sortBy?: string

    /**
     * Směr řazení (asc/desc)
     * @type {string}
     * @memberof BookingListApiGetBookingList
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for getBookingSummary1 operation in BookingListApi.
 * @export
 * @interface BookingListApiGetBookingSummary1Request
 */
export interface BookingListApiGetBookingSummary1Request {
    /**
     * Datum od
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly dateFrom?: string

    /**
     * Datum do
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly dateTo?: string

    /**
     * Full-text vyhledávání
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly query?: string

    /**
     * Stav rezervace
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly state?: string

    /**
     * ID salonu
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly salonId?: string

    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly workerId?: string

    /**
     * ID zákazníka
     * @type {string}
     * @memberof BookingListApiGetBookingSummary1
     */
    readonly customerId?: string
}

/**
 * Request parameters for quickExportBookings operation in BookingListApi.
 * @export
 * @interface BookingListApiQuickExportBookingsRequest
 */
export interface BookingListApiQuickExportBookingsRequest {
    /**
     * Datum od
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly dateFrom?: string

    /**
     * Datum do
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly dateTo?: string

    /**
     * Full-text vyhledávání
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly query?: string

    /**
     * Stav rezervace
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly state?: string

    /**
     * ID salonu
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly salonId?: string

    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly workerId?: string

    /**
     * ID zákazníka
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly customerId?: string

    /**
     * Formát exportu
     * @type {string}
     * @memberof BookingListApiQuickExportBookings
     */
    readonly format?: string
}

/**
 * BookingListApi - object-oriented interface
 * @export
 * @class BookingListApi
 * @extends {BaseAPI}
 */
export class BookingListApi extends BaseAPI implements BookingListApiInterface {
    /**
     * Exportuje rezervace do CSV, Excel nebo PDF formátu
     * @summary Export rezervací
     * @param {BookingListApiExportBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApi
     */
    public exportBookings(requestParameters: BookingListApiExportBookingsRequest, options?: RawAxiosRequestConfig) {
        return BookingListApiFp(this.configuration).exportBookings(requestParameters.appBookingExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací stránkovaný seznam rezervací s pokročilými filtry a sumarizací
     * @summary Získat stránkovaný seznam rezervací
     * @param {BookingListApiGetBookingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApi
     */
    public getBookingList(requestParameters: BookingListApiGetBookingListRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingListApiFp(this.configuration).getBookingList(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací sumarizaci rezervací podle stavu a tržeb
     * @summary Získat sumarizaci rezervací
     * @param {BookingListApiGetBookingSummary1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApi
     */
    public getBookingSummary1(requestParameters: BookingListApiGetBookingSummary1Request = {}, options?: RawAxiosRequestConfig) {
        return BookingListApiFp(this.configuration).getBookingSummary1(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exportuje rezervace pomocí GET parametrů
     * @summary Rychlý export rezervací (GET)
     * @param {BookingListApiQuickExportBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingListApi
     */
    public quickExportBookings(requestParameters: BookingListApiQuickExportBookingsRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingListApiFp(this.configuration).quickExportBookings(requestParameters.dateFrom, requestParameters.dateTo, requestParameters.query, requestParameters.state, requestParameters.salonId, requestParameters.workerId, requestParameters.customerId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingReviewsApi - axios parameter creator
 * @export
 */
export const BookingReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Přidá odpověď salonu na hodnocení
         * @summary Přidá odpověď salonu
         * @param {string} reviewId ID hodnocení
         * @param {SalonResponseRequest} salonResponseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSalonResponse: async (reviewId: string, salonResponseRequest: SalonResponseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('addSalonResponse', 'reviewId', reviewId)
            // verify required parameter 'salonResponseRequest' is not null or undefined
            assertParamExists('addSalonResponse', 'salonResponseRequest', salonResponseRequest)
            const localVarPath = `/reviews/{reviewId}/salon-response`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salonResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schválí hodnocení v procesu moderace
         * @summary Schválí hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveReview: async (reviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('approveReview', 'reviewId', reviewId)
            const localVarPath = `/reviews/{reviewId}/approve`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří nové hodnocení pro dokončenou rezervaci
         * @summary Vytvoří nové hodnocení
         * @param {CreateBookingReviewRequest} createBookingReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReview: async (createBookingReviewRequest: CreateBookingReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingReviewRequest' is not null or undefined
            assertParamExists('createReview', 'createBookingReviewRequest', createBookingReviewRequest)
            const localVarPath = `/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže existující hodnocení
         * @summary Smaže hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview: async (reviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('deleteReview', 'reviewId', reviewId)
            const localVarPath = `/reviews/{reviewId}`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací všechna hodnocení, která ještě nebyla moderována
         * @summary Získá hodnocení čekající na moderaci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingModerationReviews: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reviews/pending-moderation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací hodnocení pro konkrétní rezervaci, pokud existuje
         * @summary Získá hodnocení pro rezervaci
         * @param {string} bookingId ID rezervace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getReviewByBookingId', 'bookingId', bookingId)
            const localVarPath = `/reviews/booking/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací detail konkrétního hodnocení
         * @summary Získá hodnocení podle ID
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewById: async (reviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('getReviewById', 'reviewId', reviewId)
            const localVarPath = `/reviews/{reviewId}`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací agregované statistiky hodnocení pro daný salon
         * @summary Získá statistiky hodnocení pro salon
         * @param {string} salonId ID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonReviewStats: async (salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getSalonReviewStats', 'salonId', salonId)
            const localVarPath = `/reviews/salon/{salonId}/stats`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daný salon
         * @summary Získá hodnocení pro salon
         * @param {string} salonId ID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonReviews: async (salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getSalonReviews', 'salonId', salonId)
            const localVarPath = `/reviews/salon/{salonId}`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací agregované statistiky hodnocení pro daného zaměstnance
         * @summary Získá statistiky hodnocení pro zaměstnance
         * @param {string} workerId ID zaměstnance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerReviewStats: async (workerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('getWorkerReviewStats', 'workerId', workerId)
            const localVarPath = `/reviews/worker/{workerId}/stats`
                .replace(`{${"workerId"}}`, encodeURIComponent(String(workerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daného zaměstnance
         * @summary Získá hodnocení pro zaměstnance
         * @param {string} workerId ID zaměstnance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerReviews: async (workerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('getWorkerReviews', 'workerId', workerId)
            const localVarPath = `/reviews/worker/{workerId}`
                .replace(`{${"workerId"}}`, encodeURIComponent(String(workerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující hodnocení
         * @summary Aktualizuje hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {UpdateBookingReviewRequest} updateBookingReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReview: async (reviewId: string, updateBookingReviewRequest: UpdateBookingReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('updateReview', 'reviewId', reviewId)
            // verify required parameter 'updateBookingReviewRequest' is not null or undefined
            assertParamExists('updateReview', 'updateBookingReviewRequest', updateBookingReviewRequest)
            const localVarPath = `/reviews/{reviewId}`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingReviewsApi - functional programming interface
 * @export
 */
export const BookingReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * Přidá odpověď salonu na hodnocení
         * @summary Přidá odpověď salonu
         * @param {string} reviewId ID hodnocení
         * @param {SalonResponseRequest} salonResponseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSalonResponse(reviewId: string, salonResponseRequest: SalonResponseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSalonResponse(reviewId, salonResponseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.addSalonResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Schválí hodnocení v procesu moderace
         * @summary Schválí hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveReview(reviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveReview(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.approveReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří nové hodnocení pro dokončenou rezervaci
         * @summary Vytvoří nové hodnocení
         * @param {CreateBookingReviewRequest} createBookingReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReview(createBookingReviewRequest: CreateBookingReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReview(createBookingReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.createReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže existující hodnocení
         * @summary Smaže hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReview(reviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReview(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.deleteReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací všechna hodnocení, která ještě nebyla moderována
         * @summary Získá hodnocení čekající na moderaci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingModerationReviews(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingReviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingModerationReviews(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getPendingModerationReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací hodnocení pro konkrétní rezervaci, pokud existuje
         * @summary Získá hodnocení pro rezervaci
         * @param {string} bookingId ID rezervace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getReviewByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací detail konkrétního hodnocení
         * @summary Získá hodnocení podle ID
         * @param {string} reviewId ID hodnocení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewById(reviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewById(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getReviewById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací agregované statistiky hodnocení pro daný salon
         * @summary Získá statistiky hodnocení pro salon
         * @param {string} salonId ID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonReviewStats(salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonReviewStats(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getSalonReviewStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daný salon
         * @summary Získá hodnocení pro salon
         * @param {string} salonId ID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonReviews(salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingReviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonReviews(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getSalonReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací agregované statistiky hodnocení pro daného zaměstnance
         * @summary Získá statistiky hodnocení pro zaměstnance
         * @param {string} workerId ID zaměstnance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkerReviewStats(workerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkerReviewStats(workerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getWorkerReviewStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daného zaměstnance
         * @summary Získá hodnocení pro zaměstnance
         * @param {string} workerId ID zaměstnance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkerReviews(workerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingReviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkerReviews(workerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.getWorkerReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující hodnocení
         * @summary Aktualizuje hodnocení
         * @param {string} reviewId ID hodnocení
         * @param {UpdateBookingReviewRequest} updateBookingReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReview(reviewId: string, updateBookingReviewRequest: UpdateBookingReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReview(reviewId, updateBookingReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingReviewsApi.updateReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingReviewsApi - factory interface
 * @export
 */
export const BookingReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingReviewsApiFp(configuration)
    return {
        /**
         * Přidá odpověď salonu na hodnocení
         * @summary Přidá odpověď salonu
         * @param {BookingReviewsApiAddSalonResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSalonResponse(requestParameters: BookingReviewsApiAddSalonResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.addSalonResponse(requestParameters.reviewId, requestParameters.salonResponseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Schválí hodnocení v procesu moderace
         * @summary Schválí hodnocení
         * @param {BookingReviewsApiApproveReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveReview(requestParameters: BookingReviewsApiApproveReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.approveReview(requestParameters.reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří nové hodnocení pro dokončenou rezervaci
         * @summary Vytvoří nové hodnocení
         * @param {BookingReviewsApiCreateReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReview(requestParameters: BookingReviewsApiCreateReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.createReview(requestParameters.createBookingReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže existující hodnocení
         * @summary Smaže hodnocení
         * @param {BookingReviewsApiDeleteReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview(requestParameters: BookingReviewsApiDeleteReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReview(requestParameters.reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací všechna hodnocení, která ještě nebyla moderována
         * @summary Získá hodnocení čekající na moderaci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingModerationReviews(options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>> {
            return localVarFp.getPendingModerationReviews(options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací hodnocení pro konkrétní rezervaci, pokud existuje
         * @summary Získá hodnocení pro rezervaci
         * @param {BookingReviewsApiGetReviewByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewByBookingId(requestParameters: BookingReviewsApiGetReviewByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.getReviewByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací detail konkrétního hodnocení
         * @summary Získá hodnocení podle ID
         * @param {BookingReviewsApiGetReviewByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewById(requestParameters: BookingReviewsApiGetReviewByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.getReviewById(requestParameters.reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací agregované statistiky hodnocení pro daný salon
         * @summary Získá statistiky hodnocení pro salon
         * @param {BookingReviewsApiGetSalonReviewStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonReviewStats(requestParameters: BookingReviewsApiGetSalonReviewStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewStatsResponse> {
            return localVarFp.getSalonReviewStats(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daný salon
         * @summary Získá hodnocení pro salon
         * @param {BookingReviewsApiGetSalonReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonReviews(requestParameters: BookingReviewsApiGetSalonReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>> {
            return localVarFp.getSalonReviews(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací agregované statistiky hodnocení pro daného zaměstnance
         * @summary Získá statistiky hodnocení pro zaměstnance
         * @param {BookingReviewsApiGetWorkerReviewStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerReviewStats(requestParameters: BookingReviewsApiGetWorkerReviewStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewStatsResponse> {
            return localVarFp.getWorkerReviewStats(requestParameters.workerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací všechna veřejná a schválená hodnocení pro daného zaměstnance
         * @summary Získá hodnocení pro zaměstnance
         * @param {BookingReviewsApiGetWorkerReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerReviews(requestParameters: BookingReviewsApiGetWorkerReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>> {
            return localVarFp.getWorkerReviews(requestParameters.workerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující hodnocení
         * @summary Aktualizuje hodnocení
         * @param {BookingReviewsApiUpdateReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReview(requestParameters: BookingReviewsApiUpdateReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse> {
            return localVarFp.updateReview(requestParameters.reviewId, requestParameters.updateBookingReviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingReviewsApi - interface
 * @export
 * @interface BookingReviewsApi
 */
export interface BookingReviewsApiInterface {
    /**
     * Přidá odpověď salonu na hodnocení
     * @summary Přidá odpověď salonu
     * @param {BookingReviewsApiAddSalonResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    addSalonResponse(requestParameters: BookingReviewsApiAddSalonResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

    /**
     * Schválí hodnocení v procesu moderace
     * @summary Schválí hodnocení
     * @param {BookingReviewsApiApproveReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    approveReview(requestParameters: BookingReviewsApiApproveReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

    /**
     * Vytvoří nové hodnocení pro dokončenou rezervaci
     * @summary Vytvoří nové hodnocení
     * @param {BookingReviewsApiCreateReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    createReview(requestParameters: BookingReviewsApiCreateReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

    /**
     * Smaže existující hodnocení
     * @summary Smaže hodnocení
     * @param {BookingReviewsApiDeleteReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    deleteReview(requestParameters: BookingReviewsApiDeleteReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrací všechna hodnocení, která ještě nebyla moderována
     * @summary Získá hodnocení čekající na moderaci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getPendingModerationReviews(options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>>;

    /**
     * Vrací hodnocení pro konkrétní rezervaci, pokud existuje
     * @summary Získá hodnocení pro rezervaci
     * @param {BookingReviewsApiGetReviewByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getReviewByBookingId(requestParameters: BookingReviewsApiGetReviewByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

    /**
     * Vrací detail konkrétního hodnocení
     * @summary Získá hodnocení podle ID
     * @param {BookingReviewsApiGetReviewByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getReviewById(requestParameters: BookingReviewsApiGetReviewByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

    /**
     * Vrací agregované statistiky hodnocení pro daný salon
     * @summary Získá statistiky hodnocení pro salon
     * @param {BookingReviewsApiGetSalonReviewStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getSalonReviewStats(requestParameters: BookingReviewsApiGetSalonReviewStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewStatsResponse>;

    /**
     * Vrací všechna veřejná a schválená hodnocení pro daný salon
     * @summary Získá hodnocení pro salon
     * @param {BookingReviewsApiGetSalonReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getSalonReviews(requestParameters: BookingReviewsApiGetSalonReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>>;

    /**
     * Vrací agregované statistiky hodnocení pro daného zaměstnance
     * @summary Získá statistiky hodnocení pro zaměstnance
     * @param {BookingReviewsApiGetWorkerReviewStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getWorkerReviewStats(requestParameters: BookingReviewsApiGetWorkerReviewStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewStatsResponse>;

    /**
     * Vrací všechna veřejná a schválená hodnocení pro daného zaměstnance
     * @summary Získá hodnocení pro zaměstnance
     * @param {BookingReviewsApiGetWorkerReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    getWorkerReviews(requestParameters: BookingReviewsApiGetWorkerReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingReviewResponse>>;

    /**
     * Aktualizuje existující hodnocení
     * @summary Aktualizuje hodnocení
     * @param {BookingReviewsApiUpdateReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApiInterface
     */
    updateReview(requestParameters: BookingReviewsApiUpdateReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingReviewResponse>;

}

/**
 * Request parameters for addSalonResponse operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiAddSalonResponseRequest
 */
export interface BookingReviewsApiAddSalonResponseRequest {
    /**
     * ID hodnocení
     * @type {string}
     * @memberof BookingReviewsApiAddSalonResponse
     */
    readonly reviewId: string

    /**
     * 
     * @type {SalonResponseRequest}
     * @memberof BookingReviewsApiAddSalonResponse
     */
    readonly salonResponseRequest: SalonResponseRequest
}

/**
 * Request parameters for approveReview operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiApproveReviewRequest
 */
export interface BookingReviewsApiApproveReviewRequest {
    /**
     * ID hodnocení
     * @type {string}
     * @memberof BookingReviewsApiApproveReview
     */
    readonly reviewId: string
}

/**
 * Request parameters for createReview operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiCreateReviewRequest
 */
export interface BookingReviewsApiCreateReviewRequest {
    /**
     * 
     * @type {CreateBookingReviewRequest}
     * @memberof BookingReviewsApiCreateReview
     */
    readonly createBookingReviewRequest: CreateBookingReviewRequest
}

/**
 * Request parameters for deleteReview operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiDeleteReviewRequest
 */
export interface BookingReviewsApiDeleteReviewRequest {
    /**
     * ID hodnocení
     * @type {string}
     * @memberof BookingReviewsApiDeleteReview
     */
    readonly reviewId: string
}

/**
 * Request parameters for getReviewByBookingId operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetReviewByBookingIdRequest
 */
export interface BookingReviewsApiGetReviewByBookingIdRequest {
    /**
     * ID rezervace
     * @type {string}
     * @memberof BookingReviewsApiGetReviewByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for getReviewById operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetReviewByIdRequest
 */
export interface BookingReviewsApiGetReviewByIdRequest {
    /**
     * ID hodnocení
     * @type {string}
     * @memberof BookingReviewsApiGetReviewById
     */
    readonly reviewId: string
}

/**
 * Request parameters for getSalonReviewStats operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetSalonReviewStatsRequest
 */
export interface BookingReviewsApiGetSalonReviewStatsRequest {
    /**
     * ID salonu
     * @type {string}
     * @memberof BookingReviewsApiGetSalonReviewStats
     */
    readonly salonId: string
}

/**
 * Request parameters for getSalonReviews operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetSalonReviewsRequest
 */
export interface BookingReviewsApiGetSalonReviewsRequest {
    /**
     * ID salonu
     * @type {string}
     * @memberof BookingReviewsApiGetSalonReviews
     */
    readonly salonId: string
}

/**
 * Request parameters for getWorkerReviewStats operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetWorkerReviewStatsRequest
 */
export interface BookingReviewsApiGetWorkerReviewStatsRequest {
    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingReviewsApiGetWorkerReviewStats
     */
    readonly workerId: string
}

/**
 * Request parameters for getWorkerReviews operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiGetWorkerReviewsRequest
 */
export interface BookingReviewsApiGetWorkerReviewsRequest {
    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingReviewsApiGetWorkerReviews
     */
    readonly workerId: string
}

/**
 * Request parameters for updateReview operation in BookingReviewsApi.
 * @export
 * @interface BookingReviewsApiUpdateReviewRequest
 */
export interface BookingReviewsApiUpdateReviewRequest {
    /**
     * ID hodnocení
     * @type {string}
     * @memberof BookingReviewsApiUpdateReview
     */
    readonly reviewId: string

    /**
     * 
     * @type {UpdateBookingReviewRequest}
     * @memberof BookingReviewsApiUpdateReview
     */
    readonly updateBookingReviewRequest: UpdateBookingReviewRequest
}

/**
 * BookingReviewsApi - object-oriented interface
 * @export
 * @class BookingReviewsApi
 * @extends {BaseAPI}
 */
export class BookingReviewsApi extends BaseAPI implements BookingReviewsApiInterface {
    /**
     * Přidá odpověď salonu na hodnocení
     * @summary Přidá odpověď salonu
     * @param {BookingReviewsApiAddSalonResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public addSalonResponse(requestParameters: BookingReviewsApiAddSalonResponseRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).addSalonResponse(requestParameters.reviewId, requestParameters.salonResponseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schválí hodnocení v procesu moderace
     * @summary Schválí hodnocení
     * @param {BookingReviewsApiApproveReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public approveReview(requestParameters: BookingReviewsApiApproveReviewRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).approveReview(requestParameters.reviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří nové hodnocení pro dokončenou rezervaci
     * @summary Vytvoří nové hodnocení
     * @param {BookingReviewsApiCreateReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public createReview(requestParameters: BookingReviewsApiCreateReviewRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).createReview(requestParameters.createBookingReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže existující hodnocení
     * @summary Smaže hodnocení
     * @param {BookingReviewsApiDeleteReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public deleteReview(requestParameters: BookingReviewsApiDeleteReviewRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).deleteReview(requestParameters.reviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací všechna hodnocení, která ještě nebyla moderována
     * @summary Získá hodnocení čekající na moderaci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getPendingModerationReviews(options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getPendingModerationReviews(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací hodnocení pro konkrétní rezervaci, pokud existuje
     * @summary Získá hodnocení pro rezervaci
     * @param {BookingReviewsApiGetReviewByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getReviewByBookingId(requestParameters: BookingReviewsApiGetReviewByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getReviewByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací detail konkrétního hodnocení
     * @summary Získá hodnocení podle ID
     * @param {BookingReviewsApiGetReviewByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getReviewById(requestParameters: BookingReviewsApiGetReviewByIdRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getReviewById(requestParameters.reviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací agregované statistiky hodnocení pro daný salon
     * @summary Získá statistiky hodnocení pro salon
     * @param {BookingReviewsApiGetSalonReviewStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getSalonReviewStats(requestParameters: BookingReviewsApiGetSalonReviewStatsRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getSalonReviewStats(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací všechna veřejná a schválená hodnocení pro daný salon
     * @summary Získá hodnocení pro salon
     * @param {BookingReviewsApiGetSalonReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getSalonReviews(requestParameters: BookingReviewsApiGetSalonReviewsRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getSalonReviews(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací agregované statistiky hodnocení pro daného zaměstnance
     * @summary Získá statistiky hodnocení pro zaměstnance
     * @param {BookingReviewsApiGetWorkerReviewStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getWorkerReviewStats(requestParameters: BookingReviewsApiGetWorkerReviewStatsRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getWorkerReviewStats(requestParameters.workerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací všechna veřejná a schválená hodnocení pro daného zaměstnance
     * @summary Získá hodnocení pro zaměstnance
     * @param {BookingReviewsApiGetWorkerReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public getWorkerReviews(requestParameters: BookingReviewsApiGetWorkerReviewsRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).getWorkerReviews(requestParameters.workerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující hodnocení
     * @summary Aktualizuje hodnocení
     * @param {BookingReviewsApiUpdateReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingReviewsApi
     */
    public updateReview(requestParameters: BookingReviewsApiUpdateReviewRequest, options?: RawAxiosRequestConfig) {
        return BookingReviewsApiFp(this.configuration).updateReview(requestParameters.reviewId, requestParameters.updateBookingReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingServicesApi - axios parameter creator
 * @export
 */
export const BookingServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hromadné smazání více služeb
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteServices: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDeleteServices', 'requestBody', requestBody)
            const localVarPath = `/services/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hromadná aktualizace více služeb
         * @param {BulkUpdateServicesRequest} bulkUpdateServicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateServices: async (bulkUpdateServicesRequest: BulkUpdateServicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateServicesRequest' is not null or undefined
            assertParamExists('bulkUpdateServices', 'bulkUpdateServicesRequest', bulkUpdateServicesRequest)
            const localVarPath = `/services/bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateServicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří novou službu
         * @param {CreateBookingServiceRequest} createBookingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: async (createBookingServiceRequest: CreateBookingServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingServiceRequest' is not null or undefined
            assertParamExists('createService', 'createBookingServiceRequest', createBookingServiceRequest)
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže službu (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteService', 'id', id)
            const localVarPath = `/services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplikuje existující službu
         * @param {DuplicateServiceRequest} duplicateServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateService: async (duplicateServiceRequest: DuplicateServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicateServiceRequest' is not null or undefined
            assertParamExists('duplicateService', 'duplicateServiceRequest', duplicateServiceRequest)
            const localVarPath = `/services/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá konkrétní službu podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceById', 'id', id)
            const localVarPath = `/services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam služeb dostupných pro aktuálního uživatele s možností filtrování
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [category] 
         * @param {boolean} [active] 
         * @param {string} [staff] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {number} [minDuration] 
         * @param {number} [maxDuration] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (page?: number, limit?: number, q?: string, category?: string, active?: boolean, staff?: string, minPrice?: number, maxPrice?: number, minDuration?: number, maxDuration?: number, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (staff !== undefined) {
                localVarQueryParameter['staff'] = staff;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (minDuration !== undefined) {
                localVarQueryParameter['minDuration'] = minDuration;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['maxDuration'] = maxDuration;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje existující službu
         * @param {string} id 
         * @param {UpdateBookingServiceRequest} updateBookingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService: async (id: string, updateBookingServiceRequest: UpdateBookingServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateService', 'id', id)
            // verify required parameter 'updateBookingServiceRequest' is not null or undefined
            assertParamExists('updateService', 'updateBookingServiceRequest', updateBookingServiceRequest)
            const localVarPath = `/services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingServicesApi - functional programming interface
 * @export
 */
export const BookingServicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingServicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více služeb
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteServices(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteServices(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.bulkDeleteServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hromadná aktualizace více služeb
         * @param {BulkUpdateServicesRequest} bulkUpdateServicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateServices(bulkUpdateServicesRequest: BulkUpdateServicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingServiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateServices(bulkUpdateServicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.bulkUpdateServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří novou službu
         * @param {CreateBookingServiceRequest} createBookingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createService(createBookingServiceRequest: CreateBookingServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createService(createBookingServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.createService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže službu (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteService(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteService(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.deleteService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplikuje existující službu
         * @param {DuplicateServiceRequest} duplicateServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateService(duplicateServiceRequest: DuplicateServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateService(duplicateServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.duplicateService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá konkrétní službu podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.getServiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam služeb dostupných pro aktuálního uživatele s možností filtrování
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [category] 
         * @param {boolean} [active] 
         * @param {string} [staff] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {number} [minDuration] 
         * @param {number} [maxDuration] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(page?: number, limit?: number, q?: string, category?: string, active?: boolean, staff?: string, minPrice?: number, maxPrice?: number, minDuration?: number, maxDuration?: number, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBookingServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(page, limit, q, category, active, staff, minPrice, maxPrice, minDuration, maxDuration, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje existující službu
         * @param {string} id 
         * @param {UpdateBookingServiceRequest} updateBookingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateService(id: string, updateBookingServiceRequest: UpdateBookingServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateService(id, updateBookingServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingServicesApi.updateService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingServicesApi - factory interface
 * @export
 */
export const BookingServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingServicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více služeb
         * @param {BookingServicesApiBulkDeleteServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteServices(requestParameters: BookingServicesApiBulkDeleteServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteServices(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hromadná aktualizace více služeb
         * @param {BookingServicesApiBulkUpdateServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateServices(requestParameters: BookingServicesApiBulkUpdateServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingServiceResponse>> {
            return localVarFp.bulkUpdateServices(requestParameters.bulkUpdateServicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří novou službu
         * @param {BookingServicesApiCreateServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService(requestParameters: BookingServicesApiCreateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse> {
            return localVarFp.createService(requestParameters.createBookingServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže službu (soft delete)
         * @param {BookingServicesApiDeleteServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteService(requestParameters: BookingServicesApiDeleteServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteService(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplikuje existující službu
         * @param {BookingServicesApiDuplicateServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateService(requestParameters: BookingServicesApiDuplicateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse> {
            return localVarFp.duplicateService(requestParameters.duplicateServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá konkrétní službu podle ID
         * @param {BookingServicesApiGetServiceByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById(requestParameters: BookingServicesApiGetServiceByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse> {
            return localVarFp.getServiceById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam služeb dostupných pro aktuálního uživatele s možností filtrování
         * @param {BookingServicesApiGetServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(requestParameters: BookingServicesApiGetServicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBookingServiceResponse> {
            return localVarFp.getServices(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.category, requestParameters.active, requestParameters.staff, requestParameters.minPrice, requestParameters.maxPrice, requestParameters.minDuration, requestParameters.maxDuration, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje existující službu
         * @param {BookingServicesApiUpdateServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateService(requestParameters: BookingServicesApiUpdateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse> {
            return localVarFp.updateService(requestParameters.id, requestParameters.updateBookingServiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingServicesApi - interface
 * @export
 * @interface BookingServicesApi
 */
export interface BookingServicesApiInterface {
    /**
     * 
     * @summary Hromadné smazání více služeb
     * @param {BookingServicesApiBulkDeleteServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    bulkDeleteServices(requestParameters: BookingServicesApiBulkDeleteServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Hromadná aktualizace více služeb
     * @param {BookingServicesApiBulkUpdateServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    bulkUpdateServices(requestParameters: BookingServicesApiBulkUpdateServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingServiceResponse>>;

    /**
     * 
     * @summary Vytvoří novou službu
     * @param {BookingServicesApiCreateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    createService(requestParameters: BookingServicesApiCreateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse>;

    /**
     * 
     * @summary Smaže službu (soft delete)
     * @param {BookingServicesApiDeleteServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    deleteService(requestParameters: BookingServicesApiDeleteServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Duplikuje existující službu
     * @param {BookingServicesApiDuplicateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    duplicateService(requestParameters: BookingServicesApiDuplicateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse>;

    /**
     * 
     * @summary Získá konkrétní službu podle ID
     * @param {BookingServicesApiGetServiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    getServiceById(requestParameters: BookingServicesApiGetServiceByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse>;

    /**
     * 
     * @summary Získá seznam služeb dostupných pro aktuálního uživatele s možností filtrování
     * @param {BookingServicesApiGetServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    getServices(requestParameters?: BookingServicesApiGetServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBookingServiceResponse>;

    /**
     * 
     * @summary Aktualizuje existující službu
     * @param {BookingServicesApiUpdateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApiInterface
     */
    updateService(requestParameters: BookingServicesApiUpdateServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingServiceResponse>;

}

/**
 * Request parameters for bulkDeleteServices operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiBulkDeleteServicesRequest
 */
export interface BookingServicesApiBulkDeleteServicesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingServicesApiBulkDeleteServices
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for bulkUpdateServices operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiBulkUpdateServicesRequest
 */
export interface BookingServicesApiBulkUpdateServicesRequest {
    /**
     * 
     * @type {BulkUpdateServicesRequest}
     * @memberof BookingServicesApiBulkUpdateServices
     */
    readonly bulkUpdateServicesRequest: BulkUpdateServicesRequest
}

/**
 * Request parameters for createService operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiCreateServiceRequest
 */
export interface BookingServicesApiCreateServiceRequest {
    /**
     * 
     * @type {CreateBookingServiceRequest}
     * @memberof BookingServicesApiCreateService
     */
    readonly createBookingServiceRequest: CreateBookingServiceRequest
}

/**
 * Request parameters for deleteService operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiDeleteServiceRequest
 */
export interface BookingServicesApiDeleteServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiDeleteService
     */
    readonly id: string
}

/**
 * Request parameters for duplicateService operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiDuplicateServiceRequest
 */
export interface BookingServicesApiDuplicateServiceRequest {
    /**
     * 
     * @type {DuplicateServiceRequest}
     * @memberof BookingServicesApiDuplicateService
     */
    readonly duplicateServiceRequest: DuplicateServiceRequest
}

/**
 * Request parameters for getServiceById operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiGetServiceByIdRequest
 */
export interface BookingServicesApiGetServiceByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServiceById
     */
    readonly id: string
}

/**
 * Request parameters for getServices operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiGetServicesRequest
 */
export interface BookingServicesApiGetServicesRequest {
    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServices
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServices
     */
    readonly category?: string

    /**
     * 
     * @type {boolean}
     * @memberof BookingServicesApiGetServices
     */
    readonly active?: boolean

    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServices
     */
    readonly staff?: string

    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly minPrice?: number

    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly maxPrice?: number

    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly minDuration?: number

    /**
     * 
     * @type {number}
     * @memberof BookingServicesApiGetServices
     */
    readonly maxDuration?: number

    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServices
     */
    readonly sortBy?: string

    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiGetServices
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for updateService operation in BookingServicesApi.
 * @export
 * @interface BookingServicesApiUpdateServiceRequest
 */
export interface BookingServicesApiUpdateServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingServicesApiUpdateService
     */
    readonly id: string

    /**
     * 
     * @type {UpdateBookingServiceRequest}
     * @memberof BookingServicesApiUpdateService
     */
    readonly updateBookingServiceRequest: UpdateBookingServiceRequest
}

/**
 * BookingServicesApi - object-oriented interface
 * @export
 * @class BookingServicesApi
 * @extends {BaseAPI}
 */
export class BookingServicesApi extends BaseAPI implements BookingServicesApiInterface {
    /**
     * 
     * @summary Hromadné smazání více služeb
     * @param {BookingServicesApiBulkDeleteServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public bulkDeleteServices(requestParameters: BookingServicesApiBulkDeleteServicesRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).bulkDeleteServices(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hromadná aktualizace více služeb
     * @param {BookingServicesApiBulkUpdateServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public bulkUpdateServices(requestParameters: BookingServicesApiBulkUpdateServicesRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).bulkUpdateServices(requestParameters.bulkUpdateServicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří novou službu
     * @param {BookingServicesApiCreateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public createService(requestParameters: BookingServicesApiCreateServiceRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).createService(requestParameters.createBookingServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže službu (soft delete)
     * @param {BookingServicesApiDeleteServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public deleteService(requestParameters: BookingServicesApiDeleteServiceRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).deleteService(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplikuje existující službu
     * @param {BookingServicesApiDuplicateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public duplicateService(requestParameters: BookingServicesApiDuplicateServiceRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).duplicateService(requestParameters.duplicateServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá konkrétní službu podle ID
     * @param {BookingServicesApiGetServiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public getServiceById(requestParameters: BookingServicesApiGetServiceByIdRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).getServiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam služeb dostupných pro aktuálního uživatele s možností filtrování
     * @param {BookingServicesApiGetServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public getServices(requestParameters: BookingServicesApiGetServicesRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).getServices(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.category, requestParameters.active, requestParameters.staff, requestParameters.minPrice, requestParameters.maxPrice, requestParameters.minDuration, requestParameters.maxDuration, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje existující službu
     * @param {BookingServicesApiUpdateServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServicesApi
     */
    public updateService(requestParameters: BookingServicesApiUpdateServiceRequest, options?: RawAxiosRequestConfig) {
        return BookingServicesApiFp(this.configuration).updateService(requestParameters.id, requestParameters.updateBookingServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingsApi - axios parameter creator
 * @export
 */
export const BookingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrací detail konkrétní rezervace podle ID
         * @summary Získá detail rezervace
         * @param {string} id ID rezervace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBookingById', 'id', id)
            const localVarPath = `/bookings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací sumarizaci rezervací pro konkrétní den nebo interval včetně počtu rezervací, tržeb, nových zákazníků a čekací listiny
         * @summary Získá sumarizaci rezervací pro den nebo interval
         * @param {string} [date] Datum pro sumarizaci (použije se, pokud není zadán dateFrom)
         * @param {string} [dateFrom] Datum od (volitelné)
         * @param {string} [dateTo] Datum do (volitelné)
         * @param {string} [salonId] ID salonu (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingSummary: async (date?: string, dateFrom?: string, dateTo?: string, salonId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bookings/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam všech rezervací s možností filtrování
         * @summary Získá seznam rezervací
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [serviceId] ID služby
         * @param {string} [date] Konkrétní datum
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {GetBookingsStateEnum} [state] Stav rezervace
         * @param {GetBookingsSourceEnum} [source] Zdroj rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [customerId] ID zákazníka
         * @param {string} [sortBy] Pole pro řazení
         * @param {string} [sortOrder] Směr řazení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: async (workerId?: string, serviceId?: string, date?: string, dateFrom?: string, dateTo?: string, state?: GetBookingsStateEnum, source?: GetBookingsSourceEnum, salonId?: string, customerId?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingsApi - functional programming interface
 * @export
 */
export const BookingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrací detail konkrétní rezervace podle ID
         * @summary Získá detail rezervace
         * @param {string} id ID rezervace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getBookingById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací sumarizaci rezervací pro konkrétní den nebo interval včetně počtu rezervací, tržeb, nových zákazníků a čekací listiny
         * @summary Získá sumarizaci rezervací pro den nebo interval
         * @param {string} [date] Datum pro sumarizaci (použije se, pokud není zadán dateFrom)
         * @param {string} [dateFrom] Datum od (volitelné)
         * @param {string} [dateTo] Datum do (volitelné)
         * @param {string} [salonId] ID salonu (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingSummary(date?: string, dateFrom?: string, dateTo?: string, salonId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingSummary(date, dateFrom, dateTo, salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getBookingSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam všech rezervací s možností filtrování
         * @summary Získá seznam rezervací
         * @param {string} [workerId] ID zaměstnance
         * @param {string} [serviceId] ID služby
         * @param {string} [date] Konkrétní datum
         * @param {string} [dateFrom] Datum od
         * @param {string} [dateTo] Datum do
         * @param {GetBookingsStateEnum} [state] Stav rezervace
         * @param {GetBookingsSourceEnum} [source] Zdroj rezervace
         * @param {string} [salonId] ID salonu
         * @param {string} [customerId] ID zákazníka
         * @param {string} [sortBy] Pole pro řazení
         * @param {string} [sortOrder] Směr řazení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookings(workerId?: string, serviceId?: string, date?: string, dateFrom?: string, dateTo?: string, state?: GetBookingsStateEnum, source?: GetBookingsSourceEnum, salonId?: string, customerId?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookings(workerId, serviceId, date, dateFrom, dateTo, state, source, salonId, customerId, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingsApi - factory interface
 * @export
 */
export const BookingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingsApiFp(configuration)
    return {
        /**
         * Vrací detail konkrétní rezervace podle ID
         * @summary Získá detail rezervace
         * @param {BookingsApiGetBookingByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingById(requestParameters: BookingsApiGetBookingByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingDto> {
            return localVarFp.getBookingById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací sumarizaci rezervací pro konkrétní den nebo interval včetně počtu rezervací, tržeb, nových zákazníků a čekací listiny
         * @summary Získá sumarizaci rezervací pro den nebo interval
         * @param {BookingsApiGetBookingSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingSummary(requestParameters: BookingsApiGetBookingSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BookingSummaryDto> {
            return localVarFp.getBookingSummary(requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam všech rezervací s možností filtrování
         * @summary Získá seznam rezervací
         * @param {BookingsApiGetBookingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings(requestParameters: BookingsApiGetBookingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingDto>> {
            return localVarFp.getBookings(requestParameters.workerId, requestParameters.serviceId, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.state, requestParameters.source, requestParameters.salonId, requestParameters.customerId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingsApi - interface
 * @export
 * @interface BookingsApi
 */
export interface BookingsApiInterface {
    /**
     * Vrací detail konkrétní rezervace podle ID
     * @summary Získá detail rezervace
     * @param {BookingsApiGetBookingByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApiInterface
     */
    getBookingById(requestParameters: BookingsApiGetBookingByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingDto>;

    /**
     * Vrací sumarizaci rezervací pro konkrétní den nebo interval včetně počtu rezervací, tržeb, nových zákazníků a čekací listiny
     * @summary Získá sumarizaci rezervací pro den nebo interval
     * @param {BookingsApiGetBookingSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApiInterface
     */
    getBookingSummary(requestParameters?: BookingsApiGetBookingSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingSummaryDto>;

    /**
     * Vrací seznam všech rezervací s možností filtrování
     * @summary Získá seznam rezervací
     * @param {BookingsApiGetBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApiInterface
     */
    getBookings(requestParameters?: BookingsApiGetBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingDto>>;

}

/**
 * Request parameters for getBookingById operation in BookingsApi.
 * @export
 * @interface BookingsApiGetBookingByIdRequest
 */
export interface BookingsApiGetBookingByIdRequest {
    /**
     * ID rezervace
     * @type {string}
     * @memberof BookingsApiGetBookingById
     */
    readonly id: string
}

/**
 * Request parameters for getBookingSummary operation in BookingsApi.
 * @export
 * @interface BookingsApiGetBookingSummaryRequest
 */
export interface BookingsApiGetBookingSummaryRequest {
    /**
     * Datum pro sumarizaci (použije se, pokud není zadán dateFrom)
     * @type {string}
     * @memberof BookingsApiGetBookingSummary
     */
    readonly date?: string

    /**
     * Datum od (volitelné)
     * @type {string}
     * @memberof BookingsApiGetBookingSummary
     */
    readonly dateFrom?: string

    /**
     * Datum do (volitelné)
     * @type {string}
     * @memberof BookingsApiGetBookingSummary
     */
    readonly dateTo?: string

    /**
     * ID salonu (volitelné)
     * @type {string}
     * @memberof BookingsApiGetBookingSummary
     */
    readonly salonId?: string
}

/**
 * Request parameters for getBookings operation in BookingsApi.
 * @export
 * @interface BookingsApiGetBookingsRequest
 */
export interface BookingsApiGetBookingsRequest {
    /**
     * ID zaměstnance
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly workerId?: string

    /**
     * ID služby
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly serviceId?: string

    /**
     * Konkrétní datum
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly date?: string

    /**
     * Datum od
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly dateFrom?: string

    /**
     * Datum do
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly dateTo?: string

    /**
     * Stav rezervace
     * @type {'DRAFT' | 'PENDING' | 'CONFIRMED' | 'IN_SERVICE' | 'DONE' | 'NO_SHOW' | 'CANCELED'}
     * @memberof BookingsApiGetBookings
     */
    readonly state?: GetBookingsStateEnum

    /**
     * Zdroj rezervace
     * @type {'ONLINE' | 'PHONE' | 'WALKIN' | 'APP'}
     * @memberof BookingsApiGetBookings
     */
    readonly source?: GetBookingsSourceEnum

    /**
     * ID salonu
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly salonId?: string

    /**
     * ID zákazníka
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly customerId?: string

    /**
     * Pole pro řazení
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly sortBy?: string

    /**
     * Směr řazení
     * @type {string}
     * @memberof BookingsApiGetBookings
     */
    readonly sortOrder?: string
}

/**
 * BookingsApi - object-oriented interface
 * @export
 * @class BookingsApi
 * @extends {BaseAPI}
 */
export class BookingsApi extends BaseAPI implements BookingsApiInterface {
    /**
     * Vrací detail konkrétní rezervace podle ID
     * @summary Získá detail rezervace
     * @param {BookingsApiGetBookingByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public getBookingById(requestParameters: BookingsApiGetBookingByIdRequest, options?: RawAxiosRequestConfig) {
        return BookingsApiFp(this.configuration).getBookingById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací sumarizaci rezervací pro konkrétní den nebo interval včetně počtu rezervací, tržeb, nových zákazníků a čekací listiny
     * @summary Získá sumarizaci rezervací pro den nebo interval
     * @param {BookingsApiGetBookingSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public getBookingSummary(requestParameters: BookingsApiGetBookingSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingsApiFp(this.configuration).getBookingSummary(requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam všech rezervací s možností filtrování
     * @summary Získá seznam rezervací
     * @param {BookingsApiGetBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public getBookings(requestParameters: BookingsApiGetBookingsRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingsApiFp(this.configuration).getBookings(requestParameters.workerId, requestParameters.serviceId, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.state, requestParameters.source, requestParameters.salonId, requestParameters.customerId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetBookingsStateEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    InService: 'IN_SERVICE',
    Done: 'DONE',
    NoShow: 'NO_SHOW',
    Canceled: 'CANCELED'
} as const;
export type GetBookingsStateEnum = typeof GetBookingsStateEnum[keyof typeof GetBookingsStateEnum];
/**
 * @export
 */
export const GetBookingsSourceEnum = {
    Online: 'ONLINE',
    Phone: 'PHONE',
    Walkin: 'WALKIN',
    App: 'APP'
} as const;
export type GetBookingsSourceEnum = typeof GetBookingsSourceEnum[keyof typeof GetBookingsSourceEnum];


/**
 * BookingsWriteApi - axios parameter creator
 * @export
 */
export const BookingsWriteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Změní stav rezervace na CANCELED. Nelze zrušit již zrušenou nebo dokončenou rezervaci.
         * @summary Zruší rezervaci
         * @param {string} bookingId ID rezervace ke zrušení
         * @param {CancelBookingRequest} cancelBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking: async (bookingId: string, cancelBookingRequest: CancelBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('cancelBooking', 'bookingId', bookingId)
            // verify required parameter 'cancelBookingRequest' is not null or undefined
            assertParamExists('cancelBooking', 'cancelBookingRequest', cancelBookingRequest)
            const localVarPath = `/bookings/{bookingId}/cancel`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zkontroluje, zda je možné vytvořit rezervaci pro zadané parametry bez skutečného vytvoření rezervace
         * @summary Ověří možnost vytvoření rezervace
         * @param {AppBookingCheckRequest} appBookingCheckRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBookingAvailability: async (appBookingCheckRequest: AppBookingCheckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appBookingCheckRequest' is not null or undefined
            assertParamExists('checkBookingAvailability', 'appBookingCheckRequest', appBookingCheckRequest)
            const localVarPath = `/bookings/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appBookingCheckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří novou rezervaci pro přihlášeného uživatele
         * @summary Vytvoří novou rezervaci
         * @param {AppCreateBookingRequest} appCreateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking1: async (appCreateBookingRequest: AppCreateBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appCreateBookingRequest' is not null or undefined
            assertParamExists('createBooking1', 'appCreateBookingRequest', appCreateBookingRequest)
            const localVarPath = `/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appCreateBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Přesune existující rezervaci na nové datum a čas s validací dostupnosti
         * @summary Přesune rezervaci na nové datum a čas
         * @param {string} bookingId ID rezervace k přesunutí
         * @param {MoveBookingRequest} moveBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBooking: async (bookingId: string, moveBookingRequest: MoveBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('moveBooking', 'bookingId', bookingId)
            // verify required parameter 'moveBookingRequest' is not null or undefined
            assertParamExists('moveBooking', 'moveBookingRequest', moveBookingRequest)
            const localVarPath = `/bookings/{bookingId}/move`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingsWriteApi - functional programming interface
 * @export
 */
export const BookingsWriteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingsWriteApiAxiosParamCreator(configuration)
    return {
        /**
         * Změní stav rezervace na CANCELED. Nelze zrušit již zrušenou nebo dokončenou rezervaci.
         * @summary Zruší rezervaci
         * @param {string} bookingId ID rezervace ke zrušení
         * @param {CancelBookingRequest} cancelBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBooking(bookingId: string, cancelBookingRequest: CancelBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBooking(bookingId, cancelBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsWriteApi.cancelBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zkontroluje, zda je možné vytvořit rezervaci pro zadané parametry bez skutečného vytvoření rezervace
         * @summary Ověří možnost vytvoření rezervace
         * @param {AppBookingCheckRequest} appBookingCheckRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkBookingAvailability(appBookingCheckRequest: AppBookingCheckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppBookingCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkBookingAvailability(appBookingCheckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsWriteApi.checkBookingAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří novou rezervaci pro přihlášeného uživatele
         * @summary Vytvoří novou rezervaci
         * @param {AppCreateBookingRequest} appCreateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBooking1(appCreateBookingRequest: AppCreateBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppCreateBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBooking1(appCreateBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsWriteApi.createBooking1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Přesune existující rezervaci na nové datum a čas s validací dostupnosti
         * @summary Přesune rezervaci na nové datum a čas
         * @param {string} bookingId ID rezervace k přesunutí
         * @param {MoveBookingRequest} moveBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveBooking(bookingId: string, moveBookingRequest: MoveBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveBooking(bookingId, moveBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsWriteApi.moveBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingsWriteApi - factory interface
 * @export
 */
export const BookingsWriteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingsWriteApiFp(configuration)
    return {
        /**
         * Změní stav rezervace na CANCELED. Nelze zrušit již zrušenou nebo dokončenou rezervaci.
         * @summary Zruší rezervaci
         * @param {BookingsWriteApiCancelBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking(requestParameters: BookingsWriteApiCancelBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelBookingResponse> {
            return localVarFp.cancelBooking(requestParameters.bookingId, requestParameters.cancelBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Zkontroluje, zda je možné vytvořit rezervaci pro zadané parametry bez skutečného vytvoření rezervace
         * @summary Ověří možnost vytvoření rezervace
         * @param {BookingsWriteApiCheckBookingAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBookingAvailability(requestParameters: BookingsWriteApiCheckBookingAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingCheckResponse> {
            return localVarFp.checkBookingAvailability(requestParameters.appBookingCheckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří novou rezervaci pro přihlášeného uživatele
         * @summary Vytvoří novou rezervaci
         * @param {BookingsWriteApiCreateBooking1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking1(requestParameters: BookingsWriteApiCreateBooking1Request, options?: RawAxiosRequestConfig): AxiosPromise<AppCreateBookingResponse> {
            return localVarFp.createBooking1(requestParameters.appCreateBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Přesune existující rezervaci na nové datum a čas s validací dostupnosti
         * @summary Přesune rezervaci na nové datum a čas
         * @param {BookingsWriteApiMoveBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBooking(requestParameters: BookingsWriteApiMoveBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoveBookingResponse> {
            return localVarFp.moveBooking(requestParameters.bookingId, requestParameters.moveBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingsWriteApi - interface
 * @export
 * @interface BookingsWriteApi
 */
export interface BookingsWriteApiInterface {
    /**
     * Změní stav rezervace na CANCELED. Nelze zrušit již zrušenou nebo dokončenou rezervaci.
     * @summary Zruší rezervaci
     * @param {BookingsWriteApiCancelBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApiInterface
     */
    cancelBooking(requestParameters: BookingsWriteApiCancelBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelBookingResponse>;

    /**
     * Zkontroluje, zda je možné vytvořit rezervaci pro zadané parametry bez skutečného vytvoření rezervace
     * @summary Ověří možnost vytvoření rezervace
     * @param {BookingsWriteApiCheckBookingAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApiInterface
     */
    checkBookingAvailability(requestParameters: BookingsWriteApiCheckBookingAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppBookingCheckResponse>;

    /**
     * Vytvoří novou rezervaci pro přihlášeného uživatele
     * @summary Vytvoří novou rezervaci
     * @param {BookingsWriteApiCreateBooking1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApiInterface
     */
    createBooking1(requestParameters: BookingsWriteApiCreateBooking1Request, options?: RawAxiosRequestConfig): AxiosPromise<AppCreateBookingResponse>;

    /**
     * Přesune existující rezervaci na nové datum a čas s validací dostupnosti
     * @summary Přesune rezervaci na nové datum a čas
     * @param {BookingsWriteApiMoveBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApiInterface
     */
    moveBooking(requestParameters: BookingsWriteApiMoveBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoveBookingResponse>;

}

/**
 * Request parameters for cancelBooking operation in BookingsWriteApi.
 * @export
 * @interface BookingsWriteApiCancelBookingRequest
 */
export interface BookingsWriteApiCancelBookingRequest {
    /**
     * ID rezervace ke zrušení
     * @type {string}
     * @memberof BookingsWriteApiCancelBooking
     */
    readonly bookingId: string

    /**
     * 
     * @type {CancelBookingRequest}
     * @memberof BookingsWriteApiCancelBooking
     */
    readonly cancelBookingRequest: CancelBookingRequest
}

/**
 * Request parameters for checkBookingAvailability operation in BookingsWriteApi.
 * @export
 * @interface BookingsWriteApiCheckBookingAvailabilityRequest
 */
export interface BookingsWriteApiCheckBookingAvailabilityRequest {
    /**
     * 
     * @type {AppBookingCheckRequest}
     * @memberof BookingsWriteApiCheckBookingAvailability
     */
    readonly appBookingCheckRequest: AppBookingCheckRequest
}

/**
 * Request parameters for createBooking1 operation in BookingsWriteApi.
 * @export
 * @interface BookingsWriteApiCreateBooking1Request
 */
export interface BookingsWriteApiCreateBooking1Request {
    /**
     * 
     * @type {AppCreateBookingRequest}
     * @memberof BookingsWriteApiCreateBooking1
     */
    readonly appCreateBookingRequest: AppCreateBookingRequest
}

/**
 * Request parameters for moveBooking operation in BookingsWriteApi.
 * @export
 * @interface BookingsWriteApiMoveBookingRequest
 */
export interface BookingsWriteApiMoveBookingRequest {
    /**
     * ID rezervace k přesunutí
     * @type {string}
     * @memberof BookingsWriteApiMoveBooking
     */
    readonly bookingId: string

    /**
     * 
     * @type {MoveBookingRequest}
     * @memberof BookingsWriteApiMoveBooking
     */
    readonly moveBookingRequest: MoveBookingRequest
}

/**
 * BookingsWriteApi - object-oriented interface
 * @export
 * @class BookingsWriteApi
 * @extends {BaseAPI}
 */
export class BookingsWriteApi extends BaseAPI implements BookingsWriteApiInterface {
    /**
     * Změní stav rezervace na CANCELED. Nelze zrušit již zrušenou nebo dokončenou rezervaci.
     * @summary Zruší rezervaci
     * @param {BookingsWriteApiCancelBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApi
     */
    public cancelBooking(requestParameters: BookingsWriteApiCancelBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingsWriteApiFp(this.configuration).cancelBooking(requestParameters.bookingId, requestParameters.cancelBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zkontroluje, zda je možné vytvořit rezervaci pro zadané parametry bez skutečného vytvoření rezervace
     * @summary Ověří možnost vytvoření rezervace
     * @param {BookingsWriteApiCheckBookingAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApi
     */
    public checkBookingAvailability(requestParameters: BookingsWriteApiCheckBookingAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return BookingsWriteApiFp(this.configuration).checkBookingAvailability(requestParameters.appBookingCheckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří novou rezervaci pro přihlášeného uživatele
     * @summary Vytvoří novou rezervaci
     * @param {BookingsWriteApiCreateBooking1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApi
     */
    public createBooking1(requestParameters: BookingsWriteApiCreateBooking1Request, options?: RawAxiosRequestConfig) {
        return BookingsWriteApiFp(this.configuration).createBooking1(requestParameters.appCreateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Přesune existující rezervaci na nové datum a čas s validací dostupnosti
     * @summary Přesune rezervaci na nové datum a čas
     * @param {BookingsWriteApiMoveBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsWriteApi
     */
    public moveBooking(requestParameters: BookingsWriteApiMoveBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingsWriteApiFp(this.configuration).moveBooking(requestParameters.bookingId, requestParameters.moveBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří nového zákazníka v organizaci přihlášeného uživatele
         * @summary Vytvoří nového zákazníka
         * @param {AppCreateCustomerRequest} appCreateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (appCreateCustomerRequest: AppCreateCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appCreateCustomerRequest' is not null or undefined
            assertParamExists('createCustomer', 'appCreateCustomerRequest', appCreateCustomerRequest)
            const localVarPath = `/api/app/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appCreateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří novou poznámku k zákazníkovi
         * @summary Vytvořit novou poznámku
         * @param {string} customerId 
         * @param {CreateCustomerNoteRequest} createCustomerNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerNote: async (customerId: string, createCustomerNoteRequest: CreateCustomerNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createCustomerNote', 'customerId', customerId)
            // verify required parameter 'createCustomerNoteRequest' is not null or undefined
            assertParamExists('createCustomerNote', 'createCustomerNoteRequest', createCustomerNoteRequest)
            const localVarPath = `/api/app/customers/{customerId}/notes`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže přílohu z poznámky
         * @summary Smazat přílohu
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (customerId: string, noteId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteAttachment', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteAttachment', 'noteId', noteId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}/attachments/{attachmentId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže zákazníka z databáze včetně všech jeho rezervací (hard delete s cascade)
         * @summary Smaže zákazníka
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomer', 'customerId', customerId)
            const localVarPath = `/api/app/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže poznámku včetně všech jejích příloh
         * @summary Smazat poznámku
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerNote: async (customerId: string, noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerNote', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteCustomerNote', 'noteId', noteId)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací URL obrázku přílohy z Hetzner S3
         * @summary Získat URL přílohy
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (customerId: string, noteId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('downloadAttachment', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('downloadAttachment', 'noteId', noteId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}/attachments/{attachmentId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací detail zákazníka se statistikami a historií návštěv včetně hodnocení
         * @summary Získat detail zákazníka
         * @param {string} customerId ID zákazníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetail: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerDetail', 'customerId', customerId)
            const localVarPath = `/api/app/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací detail konkrétní poznámky včetně metadat o přílohách
         * @summary Získat detail poznámky
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNote: async (customerId: string, noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerNote', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('getCustomerNote', 'noteId', noteId)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam všech poznámek včetně metadat o přílohách
         * @summary Získat všechny poznámky k zákazníkovi
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNotes: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerNotes', 'customerId', customerId)
            const localVarPath = `/api/app/customers/{customerId}/notes`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací stránkovaný seznam zákazníků s možností vyhledávání a řazení
         * @summary Získat stránkovaný seznam zákazníků
         * @param {string} [query] Full-text vyhledávání v jménech zákazníků, emailu a telefonu
         * @param {number} [page] Číslo stránky (1-based)
         * @param {number} [size] Velikost stránky
         * @param {string} [sortBy] Pole pro řazení (firstName, lastName, email, phone)
         * @param {string} [sortOrder] Směr řazení (asc/desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (query?: string, page?: number, size?: number, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existujícího zákazníka
         * @summary Aktualizuje zákazníka
         * @param {string} customerId 
         * @param {AppUpdateCustomerRequest} appUpdateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (customerId: string, appUpdateCustomerRequest: AppUpdateCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomer', 'customerId', customerId)
            // verify required parameter 'appUpdateCustomerRequest' is not null or undefined
            assertParamExists('updateCustomer', 'appUpdateCustomerRequest', appUpdateCustomerRequest)
            const localVarPath = `/api/app/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appUpdateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující poznámku
         * @summary Aktualizovat poznámku
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {UpdateCustomerNoteRequest} updateCustomerNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerNote: async (customerId: string, noteId: string, updateCustomerNoteRequest: UpdateCustomerNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomerNote', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('updateCustomerNote', 'noteId', noteId)
            // verify required parameter 'updateCustomerNoteRequest' is not null or undefined
            assertParamExists('updateCustomerNote', 'updateCustomerNoteRequest', updateCustomerNoteRequest)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nahraje obrázek jako přílohu k poznámce (max 10 MB, podporované formáty: JPEG, PNG, GIF, WEBP)
         * @summary Nahrát přílohu k poznámce
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (customerId: string, noteId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('uploadAttachment', 'customerId', customerId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('uploadAttachment', 'noteId', noteId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAttachment', 'file', file)
            const localVarPath = `/api/app/customers/{customerId}/notes/{noteId}/attachments`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří nového zákazníka v organizaci přihlášeného uživatele
         * @summary Vytvoří nového zákazníka
         * @param {AppCreateCustomerRequest} appCreateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(appCreateCustomerRequest: AppCreateCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(appCreateCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří novou poznámku k zákazníkovi
         * @summary Vytvořit novou poznámku
         * @param {string} customerId 
         * @param {CreateCustomerNoteRequest} createCustomerNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerNote(customerId: string, createCustomerNoteRequest: CreateCustomerNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerNote(customerId, createCustomerNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createCustomerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže přílohu z poznámky
         * @summary Smazat přílohu
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(customerId: string, noteId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(customerId, noteId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.deleteAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže zákazníka z databáze včetně všech jeho rezervací (hard delete s cascade)
         * @summary Smaže zákazníka
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.deleteCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže poznámku včetně všech jejích příloh
         * @summary Smazat poznámku
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerNote(customerId: string, noteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerNote(customerId, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.deleteCustomerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací URL obrázku přílohy z Hetzner S3
         * @summary Získat URL přílohy
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(customerId: string, noteId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(customerId, noteId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.downloadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací detail zákazníka se statistikami a historií návštěv včetně hodnocení
         * @summary Získat detail zákazníka
         * @param {string} customerId ID zákazníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetail(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetail(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomerDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací detail konkrétní poznámky včetně metadat o přílohách
         * @summary Získat detail poznámky
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerNote(customerId: string, noteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerNote(customerId, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam všech poznámek včetně metadat o přílohách
         * @summary Získat všechny poznámky k zákazníkovi
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerNotes(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerNotes(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomerNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací stránkovaný seznam zákazníků s možností vyhledávání a řazení
         * @summary Získat stránkovaný seznam zákazníků
         * @param {string} [query] Full-text vyhledávání v jménech zákazníků, emailu a telefonu
         * @param {number} [page] Číslo stránky (1-based)
         * @param {number} [size] Velikost stránky
         * @param {string} [sortBy] Pole pro řazení (firstName, lastName, email, phone)
         * @param {string} [sortOrder] Směr řazení (asc/desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(query?: string, page?: number, size?: number, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(query, page, size, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existujícího zákazníka
         * @summary Aktualizuje zákazníka
         * @param {string} customerId 
         * @param {AppUpdateCustomerRequest} appUpdateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(customerId: string, appUpdateCustomerRequest: AppUpdateCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(customerId, appUpdateCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující poznámku
         * @summary Aktualizovat poznámku
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {UpdateCustomerNoteRequest} updateCustomerNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerNote(customerId: string, noteId: string, updateCustomerNoteRequest: UpdateCustomerNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerNote(customerId, noteId, updateCustomerNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateCustomerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nahraje obrázek jako přílohu k poznámce (max 10 MB, podporované formáty: JPEG, PNG, GIF, WEBP)
         * @summary Nahrát přílohu k poznámce
         * @param {string} customerId 
         * @param {string} noteId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(customerId: string, noteId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(customerId, noteId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.uploadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * Vytvoří nového zákazníka v organizaci přihlášeného uživatele
         * @summary Vytvoří nového zákazníka
         * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(requestParameters: CustomerApiCreateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.createCustomer(requestParameters.appCreateCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří novou poznámku k zákazníkovi
         * @summary Vytvořit novou poznámku
         * @param {CustomerApiCreateCustomerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerNote(requestParameters: CustomerApiCreateCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse> {
            return localVarFp.createCustomerNote(requestParameters.customerId, requestParameters.createCustomerNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže přílohu z poznámky
         * @summary Smazat přílohu
         * @param {CustomerApiDeleteAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(requestParameters: CustomerApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže zákazníka z databáze včetně všech jeho rezervací (hard delete s cascade)
         * @summary Smaže zákazníka
         * @param {CustomerApiDeleteCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(requestParameters: CustomerApiDeleteCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomer(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže poznámku včetně všech jejích příloh
         * @summary Smazat poznámku
         * @param {CustomerApiDeleteCustomerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerNote(requestParameters: CustomerApiDeleteCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomerNote(requestParameters.customerId, requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací URL obrázku přílohy z Hetzner S3
         * @summary Získat URL přílohy
         * @param {CustomerApiDownloadAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(requestParameters: CustomerApiDownloadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.downloadAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací detail zákazníka se statistikami a historií návštěv včetně hodnocení
         * @summary Získat detail zákazníka
         * @param {CustomerApiGetCustomerDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetail(requestParameters: CustomerApiGetCustomerDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailResponse> {
            return localVarFp.getCustomerDetail(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací detail konkrétní poznámky včetně metadat o přílohách
         * @summary Získat detail poznámky
         * @param {CustomerApiGetCustomerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNote(requestParameters: CustomerApiGetCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse> {
            return localVarFp.getCustomerNote(requestParameters.customerId, requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam všech poznámek včetně metadat o přílohách
         * @summary Získat všechny poznámky k zákazníkovi
         * @param {CustomerApiGetCustomerNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNotes(requestParameters: CustomerApiGetCustomerNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteListResponse> {
            return localVarFp.getCustomerNotes(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací stránkovaný seznam zákazníků s možností vyhledávání a řazení
         * @summary Získat stránkovaný seznam zákazníků
         * @param {CustomerApiGetCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(requestParameters: CustomerApiGetCustomersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CustomerListResponse> {
            return localVarFp.getCustomers(requestParameters.query, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existujícího zákazníka
         * @summary Aktualizuje zákazníka
         * @param {CustomerApiUpdateCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(requestParameters: CustomerApiUpdateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.updateCustomer(requestParameters.customerId, requestParameters.appUpdateCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující poznámku
         * @summary Aktualizovat poznámku
         * @param {CustomerApiUpdateCustomerNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerNote(requestParameters: CustomerApiUpdateCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse> {
            return localVarFp.updateCustomerNote(requestParameters.customerId, requestParameters.noteId, requestParameters.updateCustomerNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Nahraje obrázek jako přílohu k poznámce (max 10 MB, podporované formáty: JPEG, PNG, GIF, WEBP)
         * @summary Nahrát přílohu k poznámce
         * @param {CustomerApiUploadAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(requestParameters: CustomerApiUploadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentMetadataResponse> {
            return localVarFp.uploadAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - interface
 * @export
 * @interface CustomerApi
 */
export interface CustomerApiInterface {
    /**
     * Vytvoří nového zákazníka v organizaci přihlášeného uživatele
     * @summary Vytvoří nového zákazníka
     * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    createCustomer(requestParameters: CustomerApiCreateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto>;

    /**
     * Vytvoří novou poznámku k zákazníkovi
     * @summary Vytvořit novou poznámku
     * @param {CustomerApiCreateCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    createCustomerNote(requestParameters: CustomerApiCreateCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse>;

    /**
     * Smaže přílohu z poznámky
     * @summary Smazat přílohu
     * @param {CustomerApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    deleteAttachment(requestParameters: CustomerApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže zákazníka z databáze včetně všech jeho rezervací (hard delete s cascade)
     * @summary Smaže zákazníka
     * @param {CustomerApiDeleteCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    deleteCustomer(requestParameters: CustomerApiDeleteCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže poznámku včetně všech jejích příloh
     * @summary Smazat poznámku
     * @param {CustomerApiDeleteCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    deleteCustomerNote(requestParameters: CustomerApiDeleteCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrací URL obrázku přílohy z Hetzner S3
     * @summary Získat URL přílohy
     * @param {CustomerApiDownloadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    downloadAttachment(requestParameters: CustomerApiDownloadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * Vrací detail zákazníka se statistikami a historií návštěv včetně hodnocení
     * @summary Získat detail zákazníka
     * @param {CustomerApiGetCustomerDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    getCustomerDetail(requestParameters: CustomerApiGetCustomerDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailResponse>;

    /**
     * Vrací detail konkrétní poznámky včetně metadat o přílohách
     * @summary Získat detail poznámky
     * @param {CustomerApiGetCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    getCustomerNote(requestParameters: CustomerApiGetCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse>;

    /**
     * Vrací seznam všech poznámek včetně metadat o přílohách
     * @summary Získat všechny poznámky k zákazníkovi
     * @param {CustomerApiGetCustomerNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    getCustomerNotes(requestParameters: CustomerApiGetCustomerNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteListResponse>;

    /**
     * Vrací stránkovaný seznam zákazníků s možností vyhledávání a řazení
     * @summary Získat stránkovaný seznam zákazníků
     * @param {CustomerApiGetCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    getCustomers(requestParameters?: CustomerApiGetCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerListResponse>;

    /**
     * Aktualizuje existujícího zákazníka
     * @summary Aktualizuje zákazníka
     * @param {CustomerApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    updateCustomer(requestParameters: CustomerApiUpdateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto>;

    /**
     * Aktualizuje existující poznámku
     * @summary Aktualizovat poznámku
     * @param {CustomerApiUpdateCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    updateCustomerNote(requestParameters: CustomerApiUpdateCustomerNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteResponse>;

    /**
     * Nahraje obrázek jako přílohu k poznámce (max 10 MB, podporované formáty: JPEG, PNG, GIF, WEBP)
     * @summary Nahrát přílohu k poznámce
     * @param {CustomerApiUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApiInterface
     */
    uploadAttachment(requestParameters: CustomerApiUploadAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentMetadataResponse>;

}

/**
 * Request parameters for createCustomer operation in CustomerApi.
 * @export
 * @interface CustomerApiCreateCustomerRequest
 */
export interface CustomerApiCreateCustomerRequest {
    /**
     * 
     * @type {AppCreateCustomerRequest}
     * @memberof CustomerApiCreateCustomer
     */
    readonly appCreateCustomerRequest: AppCreateCustomerRequest
}

/**
 * Request parameters for createCustomerNote operation in CustomerApi.
 * @export
 * @interface CustomerApiCreateCustomerNoteRequest
 */
export interface CustomerApiCreateCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiCreateCustomerNote
     */
    readonly customerId: string

    /**
     * 
     * @type {CreateCustomerNoteRequest}
     * @memberof CustomerApiCreateCustomerNote
     */
    readonly createCustomerNoteRequest: CreateCustomerNoteRequest
}

/**
 * Request parameters for deleteAttachment operation in CustomerApi.
 * @export
 * @interface CustomerApiDeleteAttachmentRequest
 */
export interface CustomerApiDeleteAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteAttachment
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteAttachment
     */
    readonly noteId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteAttachment
     */
    readonly attachmentId: string
}

/**
 * Request parameters for deleteCustomer operation in CustomerApi.
 * @export
 * @interface CustomerApiDeleteCustomerRequest
 */
export interface CustomerApiDeleteCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteCustomer
     */
    readonly customerId: string
}

/**
 * Request parameters for deleteCustomerNote operation in CustomerApi.
 * @export
 * @interface CustomerApiDeleteCustomerNoteRequest
 */
export interface CustomerApiDeleteCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteCustomerNote
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeleteCustomerNote
     */
    readonly noteId: string
}

/**
 * Request parameters for downloadAttachment operation in CustomerApi.
 * @export
 * @interface CustomerApiDownloadAttachmentRequest
 */
export interface CustomerApiDownloadAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiDownloadAttachment
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiDownloadAttachment
     */
    readonly noteId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiDownloadAttachment
     */
    readonly attachmentId: string
}

/**
 * Request parameters for getCustomerDetail operation in CustomerApi.
 * @export
 * @interface CustomerApiGetCustomerDetailRequest
 */
export interface CustomerApiGetCustomerDetailRequest {
    /**
     * ID zákazníka
     * @type {string}
     * @memberof CustomerApiGetCustomerDetail
     */
    readonly customerId: string
}

/**
 * Request parameters for getCustomerNote operation in CustomerApi.
 * @export
 * @interface CustomerApiGetCustomerNoteRequest
 */
export interface CustomerApiGetCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetCustomerNote
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetCustomerNote
     */
    readonly noteId: string
}

/**
 * Request parameters for getCustomerNotes operation in CustomerApi.
 * @export
 * @interface CustomerApiGetCustomerNotesRequest
 */
export interface CustomerApiGetCustomerNotesRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetCustomerNotes
     */
    readonly customerId: string
}

/**
 * Request parameters for getCustomers operation in CustomerApi.
 * @export
 * @interface CustomerApiGetCustomersRequest
 */
export interface CustomerApiGetCustomersRequest {
    /**
     * Full-text vyhledávání v jménech zákazníků, emailu a telefonu
     * @type {string}
     * @memberof CustomerApiGetCustomers
     */
    readonly query?: string

    /**
     * Číslo stránky (1-based)
     * @type {number}
     * @memberof CustomerApiGetCustomers
     */
    readonly page?: number

    /**
     * Velikost stránky
     * @type {number}
     * @memberof CustomerApiGetCustomers
     */
    readonly size?: number

    /**
     * Pole pro řazení (firstName, lastName, email, phone)
     * @type {string}
     * @memberof CustomerApiGetCustomers
     */
    readonly sortBy?: string

    /**
     * Směr řazení (asc/desc)
     * @type {string}
     * @memberof CustomerApiGetCustomers
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for updateCustomer operation in CustomerApi.
 * @export
 * @interface CustomerApiUpdateCustomerRequest
 */
export interface CustomerApiUpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUpdateCustomer
     */
    readonly customerId: string

    /**
     * 
     * @type {AppUpdateCustomerRequest}
     * @memberof CustomerApiUpdateCustomer
     */
    readonly appUpdateCustomerRequest: AppUpdateCustomerRequest
}

/**
 * Request parameters for updateCustomerNote operation in CustomerApi.
 * @export
 * @interface CustomerApiUpdateCustomerNoteRequest
 */
export interface CustomerApiUpdateCustomerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUpdateCustomerNote
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiUpdateCustomerNote
     */
    readonly noteId: string

    /**
     * 
     * @type {UpdateCustomerNoteRequest}
     * @memberof CustomerApiUpdateCustomerNote
     */
    readonly updateCustomerNoteRequest: UpdateCustomerNoteRequest
}

/**
 * Request parameters for uploadAttachment operation in CustomerApi.
 * @export
 * @interface CustomerApiUploadAttachmentRequest
 */
export interface CustomerApiUploadAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUploadAttachment
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiUploadAttachment
     */
    readonly noteId: string

    /**
     * 
     * @type {File}
     * @memberof CustomerApiUploadAttachment
     */
    readonly file: File
}

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI implements CustomerApiInterface {
    /**
     * Vytvoří nového zákazníka v organizaci přihlášeného uživatele
     * @summary Vytvoří nového zákazníka
     * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createCustomer(requestParameters: CustomerApiCreateCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createCustomer(requestParameters.appCreateCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří novou poznámku k zákazníkovi
     * @summary Vytvořit novou poznámku
     * @param {CustomerApiCreateCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createCustomerNote(requestParameters: CustomerApiCreateCustomerNoteRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createCustomerNote(requestParameters.customerId, requestParameters.createCustomerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže přílohu z poznámky
     * @summary Smazat přílohu
     * @param {CustomerApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteAttachment(requestParameters: CustomerApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže zákazníka z databáze včetně všech jeho rezervací (hard delete s cascade)
     * @summary Smaže zákazníka
     * @param {CustomerApiDeleteCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteCustomer(requestParameters: CustomerApiDeleteCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteCustomer(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže poznámku včetně všech jejích příloh
     * @summary Smazat poznámku
     * @param {CustomerApiDeleteCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deleteCustomerNote(requestParameters: CustomerApiDeleteCustomerNoteRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deleteCustomerNote(requestParameters.customerId, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací URL obrázku přílohy z Hetzner S3
     * @summary Získat URL přílohy
     * @param {CustomerApiDownloadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public downloadAttachment(requestParameters: CustomerApiDownloadAttachmentRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).downloadAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací detail zákazníka se statistikami a historií návštěv včetně hodnocení
     * @summary Získat detail zákazníka
     * @param {CustomerApiGetCustomerDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerDetail(requestParameters: CustomerApiGetCustomerDetailRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerDetail(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací detail konkrétní poznámky včetně metadat o přílohách
     * @summary Získat detail poznámky
     * @param {CustomerApiGetCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerNote(requestParameters: CustomerApiGetCustomerNoteRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerNote(requestParameters.customerId, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam všech poznámek včetně metadat o přílohách
     * @summary Získat všechny poznámky k zákazníkovi
     * @param {CustomerApiGetCustomerNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerNotes(requestParameters: CustomerApiGetCustomerNotesRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerNotes(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací stránkovaný seznam zákazníků s možností vyhledávání a řazení
     * @summary Získat stránkovaný seznam zákazníků
     * @param {CustomerApiGetCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomers(requestParameters: CustomerApiGetCustomersRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomers(requestParameters.query, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existujícího zákazníka
     * @summary Aktualizuje zákazníka
     * @param {CustomerApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateCustomer(requestParameters: CustomerApiUpdateCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateCustomer(requestParameters.customerId, requestParameters.appUpdateCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující poznámku
     * @summary Aktualizovat poznámku
     * @param {CustomerApiUpdateCustomerNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateCustomerNote(requestParameters: CustomerApiUpdateCustomerNoteRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateCustomerNote(requestParameters.customerId, requestParameters.noteId, requestParameters.updateCustomerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nahraje obrázek jako přílohu k poznámce (max 10 MB, podporované formáty: JPEG, PNG, GIF, WEBP)
     * @summary Nahrát přílohu k poznámce
     * @param {CustomerApiUploadAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public uploadAttachment(requestParameters: CustomerApiUploadAttachmentRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).uploadAttachment(requestParameters.customerId, requestParameters.noteId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeWorkingHoursApi - axios parameter creator
 * @export
 */
export const EmployeeWorkingHoursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteEmployeeWorkingHours: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDeleteEmployeeWorkingHours', 'requestBody', requestBody)
            const localVarPath = `/employees/working-hours/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hromadná aktualizace pracovních hodin pro zaměstnance
         * @param {BulkUpdateEmployeeWorkingHoursRequest} bulkUpdateEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateEmployeeWorkingHours: async (bulkUpdateEmployeeWorkingHoursRequest: BulkUpdateEmployeeWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateEmployeeWorkingHoursRequest' is not null or undefined
            assertParamExists('bulkUpdateEmployeeWorkingHours', 'bulkUpdateEmployeeWorkingHoursRequest', bulkUpdateEmployeeWorkingHoursRequest)
            const localVarPath = `/employees/working-hours/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateEmployeeWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny pro zaměstnance
         * @param {CreateEmployeeWorkingHoursRequest} createEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeWorkingHours: async (createEmployeeWorkingHoursRequest: CreateEmployeeWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeWorkingHoursRequest' is not null or undefined
            assertParamExists('createEmployeeWorkingHours', 'createEmployeeWorkingHoursRequest', createEmployeeWorkingHoursRequest)
            const localVarPath = `/employees/working-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllWorkingHoursByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAllWorkingHoursByUser', 'userId', userId)
            const localVarPath = `/employees/working-hours/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže pracovní hodiny zaměstnance (soft delete)
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployeeWorkingHours: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmployeeWorkingHours', 'id', id)
            const localVarPath = `/employees/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveWorkingHoursByUser1: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getActiveWorkingHoursByUser1', 'userId', userId)
            const localVarPath = `/employees/working-hours/user/{userId}/active`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin zaměstnanců s možností filtrování
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [limit] Počet položek na stránku (výchozí: 20)
         * @param {string} [userId] ID uživatele
         * @param {string} [salonId] ID salonu
         * @param {number} [weekday] Den v týdnu (1-7)
         * @param {boolean} [isActive] Aktivní pracovní hodiny
         * @param {string} [sortBy] Řazení podle (výchozí: weekday)
         * @param {string} [sortOrder] Směr řazení (asc/desc, výchozí: asc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHours1: async (page?: number, limit?: number, userId?: string, salonId?: string, weekday?: number, isActive?: boolean, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees/working-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (weekday !== undefined) {
                localVarQueryParameter['weekday'] = weekday;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance podle ID
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHoursById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmployeeWorkingHoursById', 'id', id)
            const localVarPath = `/employees/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUser1: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkingHoursByUser1', 'userId', userId)
            const localVarPath = `/employees/working-hours/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {string} userId ID uživatele
         * @param {number} weekday Den v týdnu (1-7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUserAndWeekday1: async (userId: string, weekday: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkingHoursByUserAndWeekday1', 'userId', userId)
            // verify required parameter 'weekday' is not null or undefined
            assertParamExists('getWorkingHoursByUserAndWeekday1', 'weekday', weekday)
            const localVarPath = `/employees/working-hours/user/{userId}/weekday/{weekday}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"weekday"}}`, encodeURIComponent(String(weekday)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá přehled pracovních hodin pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursSummaryByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkingHoursSummaryByUser', 'userId', userId)
            const localVarPath = `/employees/working-hours/user/{userId}/summary`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny zaměstnance
         * @param {string} id ID pracovních hodin
         * @param {UpdateEmployeeWorkingHoursRequest} updateEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeWorkingHours1: async (id: string, updateEmployeeWorkingHoursRequest: UpdateEmployeeWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmployeeWorkingHours1', 'id', id)
            // verify required parameter 'updateEmployeeWorkingHoursRequest' is not null or undefined
            assertParamExists('updateEmployeeWorkingHours1', 'updateEmployeeWorkingHoursRequest', updateEmployeeWorkingHoursRequest)
            const localVarPath = `/employees/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeWorkingHoursApi - functional programming interface
 * @export
 */
export const EmployeeWorkingHoursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeWorkingHoursApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteEmployeeWorkingHours(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteEmployeeWorkingHours(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.bulkDeleteEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hromadná aktualizace pracovních hodin pro zaměstnance
         * @param {BulkUpdateEmployeeWorkingHoursRequest} bulkUpdateEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateEmployeeWorkingHours(bulkUpdateEmployeeWorkingHoursRequest: BulkUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateEmployeeWorkingHours(bulkUpdateEmployeeWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.bulkUpdateEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny pro zaměstnance
         * @param {CreateEmployeeWorkingHoursRequest} createEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmployeeWorkingHours(createEmployeeWorkingHoursRequest: CreateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmployeeWorkingHours(createEmployeeWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.createEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllWorkingHoursByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllWorkingHoursByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.deleteAllWorkingHoursByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže pracovní hodiny zaměstnance (soft delete)
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployeeWorkingHours(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployeeWorkingHours(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.deleteEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveWorkingHoursByUser1(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveWorkingHoursByUser1(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getActiveWorkingHoursByUser1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin zaměstnanců s možností filtrování
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [limit] Počet položek na stránku (výchozí: 20)
         * @param {string} [userId] ID uživatele
         * @param {string} [salonId] ID salonu
         * @param {number} [weekday] Den v týdnu (1-7)
         * @param {boolean} [isActive] Aktivní pracovní hodiny
         * @param {string} [sortBy] Řazení podle (výchozí: weekday)
         * @param {string} [sortOrder] Směr řazení (asc/desc, výchozí: asc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeWorkingHours1(page?: number, limit?: number, userId?: string, salonId?: string, weekday?: number, isActive?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEmployeeWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeWorkingHours1(page, limit, userId, salonId, weekday, isActive, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getEmployeeWorkingHours1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance podle ID
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeWorkingHoursById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeWorkingHoursById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getEmployeeWorkingHoursById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursByUser1(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursByUser1(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getWorkingHoursByUser1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {string} userId ID uživatele
         * @param {number} weekday Den v týdnu (1-7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursByUserAndWeekday1(userId: string, weekday: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursByUserAndWeekday1(userId, weekday, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getWorkingHoursByUserAndWeekday1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá přehled pracovních hodin pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursSummaryByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkingHoursSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursSummaryByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.getWorkingHoursSummaryByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny zaměstnance
         * @param {string} id ID pracovních hodin
         * @param {UpdateEmployeeWorkingHoursRequest} updateEmployeeWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeWorkingHours1(id: string, updateEmployeeWorkingHoursRequest: UpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeWorkingHours1(id, updateEmployeeWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeWorkingHoursApi.updateEmployeeWorkingHours1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeWorkingHoursApi - factory interface
 * @export
 */
export const EmployeeWorkingHoursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeWorkingHoursApiFp(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteEmployeeWorkingHours(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hromadná aktualizace pracovních hodin pro zaměstnance
         * @param {EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>> {
            return localVarFp.bulkUpdateEmployeeWorkingHours(requestParameters.bulkUpdateEmployeeWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny pro zaměstnance
         * @param {EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse> {
            return localVarFp.createEmployeeWorkingHours(requestParameters.createEmployeeWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže všechny pracovní hodiny pro uživatele
         * @param {EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllWorkingHoursByUser(requestParameters: EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAllWorkingHoursByUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže pracovní hodiny zaměstnance (soft delete)
         * @param {EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmployeeWorkingHours(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>> {
            return localVarFp.getActiveWorkingHoursByUser1(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin zaměstnanců s možností filtrování
         * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHours1(requestParameters: EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageEmployeeWorkingHoursResponse> {
            return localVarFp.getEmployeeWorkingHours1(requestParameters.page, requestParameters.limit, requestParameters.userId, requestParameters.salonId, requestParameters.weekday, requestParameters.isActive, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance podle ID
         * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHoursById(requestParameters: EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse> {
            return localVarFp.getEmployeeWorkingHoursById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {EmployeeWorkingHoursApiGetWorkingHoursByUser1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUser1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>> {
            return localVarFp.getWorkingHoursByUser1(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUserAndWeekday1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse> {
            return localVarFp.getWorkingHoursByUserAndWeekday1(requestParameters.userId, requestParameters.weekday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá přehled pracovních hodin pro uživatele
         * @param {EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursSummaryByUser(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursSummaryResponse> {
            return localVarFp.getWorkingHoursSummaryByUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny zaměstnance
         * @param {EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeWorkingHours1(requestParameters: EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse> {
            return localVarFp.updateEmployeeWorkingHours1(requestParameters.id, requestParameters.updateEmployeeWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeWorkingHoursApi - interface
 * @export
 * @interface EmployeeWorkingHoursApi
 */
export interface EmployeeWorkingHoursApiInterface {
    /**
     * 
     * @summary Hromadné smazání více pracovních hodin
     * @param {EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    bulkDeleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Hromadná aktualizace pracovních hodin pro zaměstnance
     * @param {EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    bulkUpdateEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>>;

    /**
     * 
     * @summary Vytvoří nové pracovní hodiny pro zaměstnance
     * @param {EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    createEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse>;

    /**
     * 
     * @summary Smaže všechny pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    deleteAllWorkingHoursByUser(requestParameters: EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Smaže pracovní hodiny zaměstnance (soft delete)
     * @param {EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    deleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Získá aktivní pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getActiveWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>>;

    /**
     * 
     * @summary Získá seznam pracovních hodin zaměstnanců s možností filtrování
     * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getEmployeeWorkingHours1(requestParameters?: EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request, options?: RawAxiosRequestConfig): AxiosPromise<PageEmployeeWorkingHoursResponse>;

    /**
     * 
     * @summary Získá pracovní hodiny zaměstnance podle ID
     * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getEmployeeWorkingHoursById(requestParameters: EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse>;

    /**
     * 
     * @summary Získá všechny pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiGetWorkingHoursByUser1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUser1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeWorkingHoursResponse>>;

    /**
     * 
     * @summary Získá pracovní hodiny pro konkrétní den v týdnu
     * @param {EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getWorkingHoursByUserAndWeekday1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse>;

    /**
     * 
     * @summary Získá přehled pracovních hodin pro uživatele
     * @param {EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    getWorkingHoursSummaryByUser(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursSummaryResponse>;

    /**
     * 
     * @summary Aktualizuje existující pracovní hodiny zaměstnance
     * @param {EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApiInterface
     */
    updateEmployeeWorkingHours1(requestParameters: EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeWorkingHoursResponse>;

}

/**
 * Request parameters for bulkDeleteEmployeeWorkingHours operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest
 */
export interface EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHours
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for bulkUpdateEmployeeWorkingHours operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest
 */
export interface EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {BulkUpdateEmployeeWorkingHoursRequest}
     * @memberof EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHours
     */
    readonly bulkUpdateEmployeeWorkingHoursRequest: BulkUpdateEmployeeWorkingHoursRequest
}

/**
 * Request parameters for createEmployeeWorkingHours operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest
 */
export interface EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {CreateEmployeeWorkingHoursRequest}
     * @memberof EmployeeWorkingHoursApiCreateEmployeeWorkingHours
     */
    readonly createEmployeeWorkingHoursRequest: CreateEmployeeWorkingHoursRequest
}

/**
 * Request parameters for deleteAllWorkingHoursByUser operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest
 */
export interface EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiDeleteAllWorkingHoursByUser
     */
    readonly userId: string
}

/**
 * Request parameters for deleteEmployeeWorkingHours operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest
 */
export interface EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof EmployeeWorkingHoursApiDeleteEmployeeWorkingHours
     */
    readonly id: string
}

/**
 * Request parameters for getActiveWorkingHoursByUser1 operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request
 */
export interface EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request {
    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1
     */
    readonly userId: string
}

/**
 * Request parameters for getEmployeeWorkingHours1 operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request
 */
export interface EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request {
    /**
     * Číslo stránky (výchozí: 0)
     * @type {number}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly page?: number

    /**
     * Počet položek na stránku (výchozí: 20)
     * @type {number}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly limit?: number

    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly userId?: string

    /**
     * ID salonu
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly salonId?: string

    /**
     * Den v týdnu (1-7)
     * @type {number}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly weekday?: number

    /**
     * Aktivní pracovní hodiny
     * @type {boolean}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly isActive?: boolean

    /**
     * Řazení podle (výchozí: weekday)
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly sortBy?: string

    /**
     * Směr řazení (asc/desc, výchozí: asc)
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHours1
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for getEmployeeWorkingHoursById operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest
 */
export interface EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetEmployeeWorkingHoursById
     */
    readonly id: string
}

/**
 * Request parameters for getWorkingHoursByUser1 operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetWorkingHoursByUser1Request
 */
export interface EmployeeWorkingHoursApiGetWorkingHoursByUser1Request {
    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetWorkingHoursByUser1
     */
    readonly userId: string
}

/**
 * Request parameters for getWorkingHoursByUserAndWeekday1 operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request
 */
export interface EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request {
    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1
     */
    readonly userId: string

    /**
     * Den v týdnu (1-7)
     * @type {number}
     * @memberof EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1
     */
    readonly weekday: number
}

/**
 * Request parameters for getWorkingHoursSummaryByUser operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest
 */
export interface EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof EmployeeWorkingHoursApiGetWorkingHoursSummaryByUser
     */
    readonly userId: string
}

/**
 * Request parameters for updateEmployeeWorkingHours1 operation in EmployeeWorkingHoursApi.
 * @export
 * @interface EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request
 */
export interface EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1
     */
    readonly id: string

    /**
     * 
     * @type {UpdateEmployeeWorkingHoursRequest}
     * @memberof EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1
     */
    readonly updateEmployeeWorkingHoursRequest: UpdateEmployeeWorkingHoursRequest
}

/**
 * EmployeeWorkingHoursApi - object-oriented interface
 * @export
 * @class EmployeeWorkingHoursApi
 * @extends {BaseAPI}
 */
export class EmployeeWorkingHoursApi extends BaseAPI implements EmployeeWorkingHoursApiInterface {
    /**
     * 
     * @summary Hromadné smazání více pracovních hodin
     * @param {EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public bulkDeleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).bulkDeleteEmployeeWorkingHours(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hromadná aktualizace pracovních hodin pro zaměstnance
     * @param {EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public bulkUpdateEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiBulkUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).bulkUpdateEmployeeWorkingHours(requestParameters.bulkUpdateEmployeeWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří nové pracovní hodiny pro zaměstnance
     * @param {EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public createEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiCreateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).createEmployeeWorkingHours(requestParameters.createEmployeeWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže všechny pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public deleteAllWorkingHoursByUser(requestParameters: EmployeeWorkingHoursApiDeleteAllWorkingHoursByUserRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).deleteAllWorkingHoursByUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže pracovní hodiny zaměstnance (soft delete)
     * @param {EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public deleteEmployeeWorkingHours(requestParameters: EmployeeWorkingHoursApiDeleteEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).deleteEmployeeWorkingHours(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá aktivní pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getActiveWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetActiveWorkingHoursByUser1Request, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getActiveWorkingHoursByUser1(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam pracovních hodin zaměstnanců s možností filtrování
     * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getEmployeeWorkingHours1(requestParameters: EmployeeWorkingHoursApiGetEmployeeWorkingHours1Request = {}, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getEmployeeWorkingHours1(requestParameters.page, requestParameters.limit, requestParameters.userId, requestParameters.salonId, requestParameters.weekday, requestParameters.isActive, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny zaměstnance podle ID
     * @param {EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getEmployeeWorkingHoursById(requestParameters: EmployeeWorkingHoursApiGetEmployeeWorkingHoursByIdRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getEmployeeWorkingHoursById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá všechny pracovní hodiny pro uživatele
     * @param {EmployeeWorkingHoursApiGetWorkingHoursByUser1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getWorkingHoursByUser1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUser1Request, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getWorkingHoursByUser1(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny pro konkrétní den v týdnu
     * @param {EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getWorkingHoursByUserAndWeekday1(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursByUserAndWeekday1Request, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getWorkingHoursByUserAndWeekday1(requestParameters.userId, requestParameters.weekday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá přehled pracovních hodin pro uživatele
     * @param {EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public getWorkingHoursSummaryByUser(requestParameters: EmployeeWorkingHoursApiGetWorkingHoursSummaryByUserRequest, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).getWorkingHoursSummaryByUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje existující pracovní hodiny zaměstnance
     * @param {EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeWorkingHoursApi
     */
    public updateEmployeeWorkingHours1(requestParameters: EmployeeWorkingHoursApiUpdateEmployeeWorkingHours1Request, options?: RawAxiosRequestConfig) {
        return EmployeeWorkingHoursApiFp(this.configuration).updateEmployeeWorkingHours1(requestParameters.id, requestParameters.updateEmployeeWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeesApi - axios parameter creator
 * @export
 */
export const EmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Přiřadí službu zaměstnanci
         * @param {string} id 
         * @param {AssignServiceRequest} assignServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignServiceToEmployee: async (id: string, assignServiceRequest: AssignServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignServiceToEmployee', 'id', id)
            // verify required parameter 'assignServiceRequest' is not null or undefined
            assertParamExists('assignServiceToEmployee', 'assignServiceRequest', assignServiceRequest)
            const localVarPath = `/employees/{id}/services`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přiřadí existujícího uživatele k zaměstnanci
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectUserToEmployee: async (id: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('connectUserToEmployee', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('connectUserToEmployee', 'userId', userId)
            const localVarPath = `/employees/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří nového zaměstnance
         * @param {CreateEmployeeRequest} createEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployee: async (createEmployeeRequest: CreateEmployeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeRequest' is not null or undefined
            assertParamExists('createEmployee', 'createEmployeeRequest', createEmployeeRequest)
            const localVarPath = `/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří nového uživatele a přiřadí ho k zaměstnanci
         * @param {string} id 
         * @param {CreateUserForEmployeeRequest} createUserForEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserForEmployee: async (id: string, createUserForEmployeeRequest: CreateUserForEmployeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createUserForEmployee', 'id', id)
            // verify required parameter 'createUserForEmployeeRequest' is not null or undefined
            assertParamExists('createUserForEmployee', 'createUserForEmployeeRequest', createUserForEmployeeRequest)
            const localVarPath = `/employees/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserForEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže zaměstnance (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmployee', 'id', id)
            const localVarPath = `/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odpojí uživatele od zaměstnance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUserFromEmployee: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disconnectUserFromEmployee', 'id', id)
            const localVarPath = `/employees/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exportuje seznam zaměstnanců
         * @param {string} [format] 
         * @param {string} [status] 
         * @param {string} [salonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEmployees: async (format?: string, status?: string, salonId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá konkrétního zaměstnance podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmployeeById', 'id', id)
            const localVarPath = `/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam služeb, které může zaměstnanec poskytovat
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeServices: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmployeeServices', 'id', id)
            const localVarPath = `/employees/{id}/services`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá souhrnné statistiky zaměstnanců
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHours: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmployeeWorkingHours', 'id', id)
            const localVarPath = `/employees/{id}/working-hours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam všech zaměstnanců s možností filtrování
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [status] 
         * @param {string} [employmentType] 
         * @param {string} [salonId] 
         * @param {string} [role] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees: async (page?: number, limit?: number, q?: string, status?: string, employmentType?: string, salonId?: string, role?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (employmentType !== undefined) {
                localVarQueryParameter['employmentType'] = employmentType;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odebere službu od zaměstnance
         * @param {string} id 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeServiceFromEmployee: async (id: string, serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeServiceFromEmployee', 'id', id)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('removeServiceFromEmployee', 'serviceId', serviceId)
            const localVarPath = `/employees/{id}/services/{serviceId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vyhledá uživatele podle emailu pro přiřazení k zaměstnanci
         * @param {string} email 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (email: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('searchUsers', 'email', email)
            const localVarPath = `/employees/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje existujícího zaměstnance
         * @param {string} id 
         * @param {UpdateEmployeeRequest} updateEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee: async (id: string, updateEmployeeRequest: UpdateEmployeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmployee', 'id', id)
            // verify required parameter 'updateEmployeeRequest' is not null or undefined
            assertParamExists('updateEmployee', 'updateEmployeeRequest', updateEmployeeRequest)
            const localVarPath = `/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Změní status zaměstnance (aktivní/neaktivní)
         * @param {string} id 
         * @param {UpdateEmployeeStatusRequest} updateEmployeeStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeStatus: async (id: string, updateEmployeeStatusRequest: UpdateEmployeeStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmployeeStatus', 'id', id)
            // verify required parameter 'updateEmployeeStatusRequest' is not null or undefined
            assertParamExists('updateEmployeeStatus', 'updateEmployeeStatusRequest', updateEmployeeStatusRequest)
            const localVarPath = `/employees/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny zaměstnance
         * @param {string} id 
         * @param {UpdateWorkingHoursRequest} updateWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeWorkingHours: async (id: string, updateWorkingHoursRequest: UpdateWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmployeeWorkingHours', 'id', id)
            // verify required parameter 'updateWorkingHoursRequest' is not null or undefined
            assertParamExists('updateEmployeeWorkingHours', 'updateWorkingHoursRequest', updateWorkingHoursRequest)
            const localVarPath = `/employees/{id}/working-hours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeesApi - functional programming interface
 * @export
 */
export const EmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Přiřadí službu zaměstnanci
         * @param {string} id 
         * @param {AssignServiceRequest} assignServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignServiceToEmployee(id: string, assignServiceRequest: AssignServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignServiceToEmployee(id, assignServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.assignServiceToEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přiřadí existujícího uživatele k zaměstnanci
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectUserToEmployee(id: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectUserToEmployee(id, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.connectUserToEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří nového zaměstnance
         * @param {CreateEmployeeRequest} createEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmployee(createEmployeeRequest: CreateEmployeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmployee(createEmployeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.createEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří nového uživatele a přiřadí ho k zaměstnanci
         * @param {string} id 
         * @param {CreateUserForEmployeeRequest} createUserForEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserForEmployee(id: string, createUserForEmployeeRequest: CreateUserForEmployeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserForEmployee(id, createUserForEmployeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.createUserForEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže zaměstnance (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployee(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.deleteEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odpojí uživatele od zaměstnance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectUserFromEmployee(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectUserFromEmployee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.disconnectUserFromEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exportuje seznam zaměstnanců
         * @param {string} [format] 
         * @param {string} [status] 
         * @param {string} [salonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEmployees(format?: string, status?: string, salonId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEmployees(format, status, salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.exportEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá konkrétního zaměstnance podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployeeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam služeb, které může zaměstnanec poskytovat
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeServices(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeServiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeServices(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployeeServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá souhrnné statistiky zaměstnanců
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployeeStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeWorkingHours(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeWorkingHours(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam všech zaměstnanců s možností filtrování
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [status] 
         * @param {string} [employmentType] 
         * @param {string} [salonId] 
         * @param {string} [role] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployees(page?: number, limit?: number, q?: string, status?: string, employmentType?: string, salonId?: string, role?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployees(page, limit, q, status, employmentType, salonId, role, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odebere službu od zaměstnance
         * @param {string} id 
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeServiceFromEmployee(id: string, serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeServiceFromEmployee(id, serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.removeServiceFromEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vyhledá uživatele podle emailu pro přiřazení k zaměstnanci
         * @param {string} email 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(email: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSearchResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(email, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje existujícího zaměstnance
         * @param {string} id 
         * @param {UpdateEmployeeRequest} updateEmployeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployee(id: string, updateEmployeeRequest: UpdateEmployeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployee(id, updateEmployeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.updateEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Změní status zaměstnance (aktivní/neaktivní)
         * @param {string} id 
         * @param {UpdateEmployeeStatusRequest} updateEmployeeStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeStatus(id: string, updateEmployeeStatusRequest: UpdateEmployeeStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeStatus(id, updateEmployeeStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.updateEmployeeStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny zaměstnance
         * @param {string} id 
         * @param {UpdateWorkingHoursRequest} updateWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeWorkingHours(id: string, updateWorkingHoursRequest: UpdateWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeWorkingHours(id, updateWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.updateEmployeeWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeesApi - factory interface
 * @export
 */
export const EmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeesApiFp(configuration)
    return {
        /**
         * 
         * @summary Přiřadí službu zaměstnanci
         * @param {EmployeesApiAssignServiceToEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignServiceToEmployee(requestParameters: EmployeesApiAssignServiceToEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeServiceResponse> {
            return localVarFp.assignServiceToEmployee(requestParameters.id, requestParameters.assignServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přiřadí existujícího uživatele k zaměstnanci
         * @param {EmployeesApiConnectUserToEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectUserToEmployee(requestParameters: EmployeesApiConnectUserToEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponse> {
            return localVarFp.connectUserToEmployee(requestParameters.id, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří nového zaměstnance
         * @param {EmployeesApiCreateEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployee(requestParameters: EmployeesApiCreateEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse> {
            return localVarFp.createEmployee(requestParameters.createEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří nového uživatele a přiřadí ho k zaměstnanci
         * @param {EmployeesApiCreateUserForEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserForEmployee(requestParameters: EmployeesApiCreateUserForEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponse> {
            return localVarFp.createUserForEmployee(requestParameters.id, requestParameters.createUserForEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže zaměstnance (soft delete)
         * @param {EmployeesApiDeleteEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee(requestParameters: EmployeesApiDeleteEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmployee(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odpojí uživatele od zaměstnance
         * @param {EmployeesApiDisconnectUserFromEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectUserFromEmployee(requestParameters: EmployeesApiDisconnectUserFromEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disconnectUserFromEmployee(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exportuje seznam zaměstnanců
         * @param {EmployeesApiExportEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEmployees(requestParameters: EmployeesApiExportEmployeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportEmployees(requestParameters.format, requestParameters.status, requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá konkrétního zaměstnance podle ID
         * @param {EmployeesApiGetEmployeeByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeById(requestParameters: EmployeesApiGetEmployeeByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDetailResponse> {
            return localVarFp.getEmployeeById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam služeb, které může zaměstnanec poskytovat
         * @param {EmployeesApiGetEmployeeServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeServices(requestParameters: EmployeesApiGetEmployeeServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeServiceResponse>> {
            return localVarFp.getEmployeeServices(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá souhrnné statistiky zaměstnanců
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats(options?: RawAxiosRequestConfig): AxiosPromise<EmployeeStatsResponse> {
            return localVarFp.getEmployeeStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny zaměstnance
         * @param {EmployeesApiGetEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkingHours(requestParameters: EmployeesApiGetEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>> {
            return localVarFp.getEmployeeWorkingHours(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam všech zaměstnanců s možností filtrování
         * @param {EmployeesApiGetEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees(requestParameters: EmployeesApiGetEmployeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseEmployeeResponse> {
            return localVarFp.getEmployees(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.status, requestParameters.employmentType, requestParameters.salonId, requestParameters.role, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odebere službu od zaměstnance
         * @param {EmployeesApiRemoveServiceFromEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeServiceFromEmployee(requestParameters: EmployeesApiRemoveServiceFromEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeServiceFromEmployee(requestParameters.id, requestParameters.serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vyhledá uživatele podle emailu pro přiřazení k zaměstnanci
         * @param {EmployeesApiSearchUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(requestParameters: EmployeesApiSearchUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSearchResponse>> {
            return localVarFp.searchUsers(requestParameters.email, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje existujícího zaměstnance
         * @param {EmployeesApiUpdateEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee(requestParameters: EmployeesApiUpdateEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse> {
            return localVarFp.updateEmployee(requestParameters.id, requestParameters.updateEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Změní status zaměstnance (aktivní/neaktivní)
         * @param {EmployeesApiUpdateEmployeeStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeStatus(requestParameters: EmployeesApiUpdateEmployeeStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse> {
            return localVarFp.updateEmployeeStatus(requestParameters.id, requestParameters.updateEmployeeStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny zaměstnance
         * @param {EmployeesApiUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeWorkingHours(requestParameters: EmployeesApiUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>> {
            return localVarFp.updateEmployeeWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeesApi - interface
 * @export
 * @interface EmployeesApi
 */
export interface EmployeesApiInterface {
    /**
     * 
     * @summary Přiřadí službu zaměstnanci
     * @param {EmployeesApiAssignServiceToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    assignServiceToEmployee(requestParameters: EmployeesApiAssignServiceToEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeServiceResponse>;

    /**
     * 
     * @summary Přiřadí existujícího uživatele k zaměstnanci
     * @param {EmployeesApiConnectUserToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    connectUserToEmployee(requestParameters: EmployeesApiConnectUserToEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponse>;

    /**
     * 
     * @summary Vytvoří nového zaměstnance
     * @param {EmployeesApiCreateEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    createEmployee(requestParameters: EmployeesApiCreateEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse>;

    /**
     * 
     * @summary Vytvoří nového uživatele a přiřadí ho k zaměstnanci
     * @param {EmployeesApiCreateUserForEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    createUserForEmployee(requestParameters: EmployeesApiCreateUserForEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponse>;

    /**
     * 
     * @summary Smaže zaměstnance (soft delete)
     * @param {EmployeesApiDeleteEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    deleteEmployee(requestParameters: EmployeesApiDeleteEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Odpojí uživatele od zaměstnance
     * @param {EmployeesApiDisconnectUserFromEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    disconnectUserFromEmployee(requestParameters: EmployeesApiDisconnectUserFromEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Exportuje seznam zaměstnanců
     * @param {EmployeesApiExportEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    exportEmployees(requestParameters?: EmployeesApiExportEmployeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Získá konkrétního zaměstnance podle ID
     * @param {EmployeesApiGetEmployeeByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    getEmployeeById(requestParameters: EmployeesApiGetEmployeeByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeDetailResponse>;

    /**
     * 
     * @summary Získá seznam služeb, které může zaměstnanec poskytovat
     * @param {EmployeesApiGetEmployeeServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    getEmployeeServices(requestParameters: EmployeesApiGetEmployeeServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeServiceResponse>>;

    /**
     * 
     * @summary Získá souhrnné statistiky zaměstnanců
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    getEmployeeStats(options?: RawAxiosRequestConfig): AxiosPromise<EmployeeStatsResponse>;

    /**
     * 
     * @summary Získá pracovní hodiny zaměstnance
     * @param {EmployeesApiGetEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    getEmployeeWorkingHours(requestParameters: EmployeesApiGetEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>>;

    /**
     * 
     * @summary Získá seznam všech zaměstnanců s možností filtrování
     * @param {EmployeesApiGetEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    getEmployees(requestParameters?: EmployeesApiGetEmployeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseEmployeeResponse>;

    /**
     * 
     * @summary Odebere službu od zaměstnance
     * @param {EmployeesApiRemoveServiceFromEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    removeServiceFromEmployee(requestParameters: EmployeesApiRemoveServiceFromEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Vyhledá uživatele podle emailu pro přiřazení k zaměstnanci
     * @param {EmployeesApiSearchUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    searchUsers(requestParameters: EmployeesApiSearchUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSearchResponse>>;

    /**
     * 
     * @summary Aktualizuje existujícího zaměstnance
     * @param {EmployeesApiUpdateEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    updateEmployee(requestParameters: EmployeesApiUpdateEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse>;

    /**
     * 
     * @summary Změní status zaměstnance (aktivní/neaktivní)
     * @param {EmployeesApiUpdateEmployeeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    updateEmployeeStatus(requestParameters: EmployeesApiUpdateEmployeeStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse>;

    /**
     * 
     * @summary Aktualizuje pracovní hodiny zaměstnance
     * @param {EmployeesApiUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApiInterface
     */
    updateEmployeeWorkingHours(requestParameters: EmployeesApiUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>>;

}

/**
 * Request parameters for assignServiceToEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiAssignServiceToEmployeeRequest
 */
export interface EmployeesApiAssignServiceToEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiAssignServiceToEmployee
     */
    readonly id: string

    /**
     * 
     * @type {AssignServiceRequest}
     * @memberof EmployeesApiAssignServiceToEmployee
     */
    readonly assignServiceRequest: AssignServiceRequest
}

/**
 * Request parameters for connectUserToEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiConnectUserToEmployeeRequest
 */
export interface EmployeesApiConnectUserToEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiConnectUserToEmployee
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiConnectUserToEmployee
     */
    readonly userId: string
}

/**
 * Request parameters for createEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiCreateEmployeeRequest
 */
export interface EmployeesApiCreateEmployeeRequest {
    /**
     * 
     * @type {CreateEmployeeRequest}
     * @memberof EmployeesApiCreateEmployee
     */
    readonly createEmployeeRequest: CreateEmployeeRequest
}

/**
 * Request parameters for createUserForEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiCreateUserForEmployeeRequest
 */
export interface EmployeesApiCreateUserForEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiCreateUserForEmployee
     */
    readonly id: string

    /**
     * 
     * @type {CreateUserForEmployeeRequest}
     * @memberof EmployeesApiCreateUserForEmployee
     */
    readonly createUserForEmployeeRequest: CreateUserForEmployeeRequest
}

/**
 * Request parameters for deleteEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiDeleteEmployeeRequest
 */
export interface EmployeesApiDeleteEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiDeleteEmployee
     */
    readonly id: string
}

/**
 * Request parameters for disconnectUserFromEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiDisconnectUserFromEmployeeRequest
 */
export interface EmployeesApiDisconnectUserFromEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiDisconnectUserFromEmployee
     */
    readonly id: string
}

/**
 * Request parameters for exportEmployees operation in EmployeesApi.
 * @export
 * @interface EmployeesApiExportEmployeesRequest
 */
export interface EmployeesApiExportEmployeesRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiExportEmployees
     */
    readonly format?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiExportEmployees
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiExportEmployees
     */
    readonly salonId?: string
}

/**
 * Request parameters for getEmployeeById operation in EmployeesApi.
 * @export
 * @interface EmployeesApiGetEmployeeByIdRequest
 */
export interface EmployeesApiGetEmployeeByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployeeById
     */
    readonly id: string
}

/**
 * Request parameters for getEmployeeServices operation in EmployeesApi.
 * @export
 * @interface EmployeesApiGetEmployeeServicesRequest
 */
export interface EmployeesApiGetEmployeeServicesRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployeeServices
     */
    readonly id: string
}

/**
 * Request parameters for getEmployeeWorkingHours operation in EmployeesApi.
 * @export
 * @interface EmployeesApiGetEmployeeWorkingHoursRequest
 */
export interface EmployeesApiGetEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployeeWorkingHours
     */
    readonly id: string
}

/**
 * Request parameters for getEmployees operation in EmployeesApi.
 * @export
 * @interface EmployeesApiGetEmployeesRequest
 */
export interface EmployeesApiGetEmployeesRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeesApiGetEmployees
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof EmployeesApiGetEmployees
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly employmentType?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly salonId?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly role?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly sortBy?: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiGetEmployees
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for removeServiceFromEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiRemoveServiceFromEmployeeRequest
 */
export interface EmployeesApiRemoveServiceFromEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiRemoveServiceFromEmployee
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof EmployeesApiRemoveServiceFromEmployee
     */
    readonly serviceId: string
}

/**
 * Request parameters for searchUsers operation in EmployeesApi.
 * @export
 * @interface EmployeesApiSearchUsersRequest
 */
export interface EmployeesApiSearchUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiSearchUsers
     */
    readonly email: string

    /**
     * 
     * @type {number}
     * @memberof EmployeesApiSearchUsers
     */
    readonly limit?: number
}

/**
 * Request parameters for updateEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiUpdateEmployeeRequest
 */
export interface EmployeesApiUpdateEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiUpdateEmployee
     */
    readonly id: string

    /**
     * 
     * @type {UpdateEmployeeRequest}
     * @memberof EmployeesApiUpdateEmployee
     */
    readonly updateEmployeeRequest: UpdateEmployeeRequest
}

/**
 * Request parameters for updateEmployeeStatus operation in EmployeesApi.
 * @export
 * @interface EmployeesApiUpdateEmployeeStatusRequest
 */
export interface EmployeesApiUpdateEmployeeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiUpdateEmployeeStatus
     */
    readonly id: string

    /**
     * 
     * @type {UpdateEmployeeStatusRequest}
     * @memberof EmployeesApiUpdateEmployeeStatus
     */
    readonly updateEmployeeStatusRequest: UpdateEmployeeStatusRequest
}

/**
 * Request parameters for updateEmployeeWorkingHours operation in EmployeesApi.
 * @export
 * @interface EmployeesApiUpdateEmployeeWorkingHoursRequest
 */
export interface EmployeesApiUpdateEmployeeWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiUpdateEmployeeWorkingHours
     */
    readonly id: string

    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof EmployeesApiUpdateEmployeeWorkingHours
     */
    readonly updateWorkingHoursRequest: UpdateWorkingHoursRequest
}

/**
 * EmployeesApi - object-oriented interface
 * @export
 * @class EmployeesApi
 * @extends {BaseAPI}
 */
export class EmployeesApi extends BaseAPI implements EmployeesApiInterface {
    /**
     * 
     * @summary Přiřadí službu zaměstnanci
     * @param {EmployeesApiAssignServiceToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public assignServiceToEmployee(requestParameters: EmployeesApiAssignServiceToEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).assignServiceToEmployee(requestParameters.id, requestParameters.assignServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přiřadí existujícího uživatele k zaměstnanci
     * @param {EmployeesApiConnectUserToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public connectUserToEmployee(requestParameters: EmployeesApiConnectUserToEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).connectUserToEmployee(requestParameters.id, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří nového zaměstnance
     * @param {EmployeesApiCreateEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createEmployee(requestParameters: EmployeesApiCreateEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createEmployee(requestParameters.createEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří nového uživatele a přiřadí ho k zaměstnanci
     * @param {EmployeesApiCreateUserForEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createUserForEmployee(requestParameters: EmployeesApiCreateUserForEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createUserForEmployee(requestParameters.id, requestParameters.createUserForEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže zaměstnance (soft delete)
     * @param {EmployeesApiDeleteEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public deleteEmployee(requestParameters: EmployeesApiDeleteEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).deleteEmployee(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odpojí uživatele od zaměstnance
     * @param {EmployeesApiDisconnectUserFromEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public disconnectUserFromEmployee(requestParameters: EmployeesApiDisconnectUserFromEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).disconnectUserFromEmployee(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exportuje seznam zaměstnanců
     * @param {EmployeesApiExportEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public exportEmployees(requestParameters: EmployeesApiExportEmployeesRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).exportEmployees(requestParameters.format, requestParameters.status, requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá konkrétního zaměstnance podle ID
     * @param {EmployeesApiGetEmployeeByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployeeById(requestParameters: EmployeesApiGetEmployeeByIdRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployeeById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam služeb, které může zaměstnanec poskytovat
     * @param {EmployeesApiGetEmployeeServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployeeServices(requestParameters: EmployeesApiGetEmployeeServicesRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployeeServices(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá souhrnné statistiky zaměstnanců
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployeeStats(options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployeeStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny zaměstnance
     * @param {EmployeesApiGetEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployeeWorkingHours(requestParameters: EmployeesApiGetEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployeeWorkingHours(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam všech zaměstnanců s možností filtrování
     * @param {EmployeesApiGetEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployees(requestParameters: EmployeesApiGetEmployeesRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployees(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.status, requestParameters.employmentType, requestParameters.salonId, requestParameters.role, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odebere službu od zaměstnance
     * @param {EmployeesApiRemoveServiceFromEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public removeServiceFromEmployee(requestParameters: EmployeesApiRemoveServiceFromEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).removeServiceFromEmployee(requestParameters.id, requestParameters.serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vyhledá uživatele podle emailu pro přiřazení k zaměstnanci
     * @param {EmployeesApiSearchUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public searchUsers(requestParameters: EmployeesApiSearchUsersRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).searchUsers(requestParameters.email, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje existujícího zaměstnance
     * @param {EmployeesApiUpdateEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateEmployee(requestParameters: EmployeesApiUpdateEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateEmployee(requestParameters.id, requestParameters.updateEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Změní status zaměstnance (aktivní/neaktivní)
     * @param {EmployeesApiUpdateEmployeeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateEmployeeStatus(requestParameters: EmployeesApiUpdateEmployeeStatusRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateEmployeeStatus(requestParameters.id, requestParameters.updateEmployeeStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje pracovní hodiny zaměstnance
     * @param {EmployeesApiUpdateEmployeeWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateEmployeeWorkingHours(requestParameters: EmployeesApiUpdateEmployeeWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateEmployeeWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalonDataControllerApi - axios parameter creator
 * @export
 */
export const SalonDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/salon-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalonDataControllerApi - functional programming interface
 * @export
 */
export const SalonDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalonDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonDataControllerApi.getSalonData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalonDataControllerApi - factory interface
 * @export
 */
export const SalonDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalonDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonData(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getSalonData(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalonDataControllerApi - interface
 * @export
 * @interface SalonDataControllerApi
 */
export interface SalonDataControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonDataControllerApiInterface
     */
    getSalonData(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * SalonDataControllerApi - object-oriented interface
 * @export
 * @class SalonDataControllerApi
 * @extends {BaseAPI}
 */
export class SalonDataControllerApi extends BaseAPI implements SalonDataControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonDataControllerApi
     */
    public getSalonData(options?: RawAxiosRequestConfig) {
        return SalonDataControllerApiFp(this.configuration).getSalonData(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalonsApi - axios parameter creator
 * @export
 */
export const SalonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvoří nový salon (pouze pro OWNER/ADMIN)
         * @param {CreateSalonRequest} createSalonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalon: async (createSalonRequest: CreateSalonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSalonRequest' is not null or undefined
            assertParamExists('createSalon', 'createSalonRequest', createSalonRequest)
            const localVarPath = `/salons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže salon (pouze pro OWNER/ADMIN)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalon: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalon', 'id', id)
            const localVarPath = `/salons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam salonů s detaily práv pro aktuálního uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySalons: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/salons/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá detail salonu (pokud má uživatel přístup)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalonById', 'id', id)
            const localVarPath = `/salons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam služeb salonu
         * @param {string} id 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [category] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonServices: async (id: string, page?: number, limit?: number, q?: string, category?: string, active?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalonServices', 'id', id)
            const localVarPath = `/salons/{id}/services`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam zaměstnanců salonu
         * @param {string} id 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [role] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonStaff: async (id: string, page?: number, limit?: number, q?: string, role?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalonStaff', 'id', id)
            const localVarPath = `/salons/{id}/staff`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá statistiky salonu
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonStatistics: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalonStatistics', 'id', id)
            const localVarPath = `/salons/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny salonu
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonWorkingHours: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalonWorkingHours', 'id', id)
            const localVarPath = `/salons/{id}/working-hours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam salonů dostupných pro aktuálního uživatele
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [city] 
         * @param {boolean} [active] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalons: async (page?: number, limit?: number, q?: string, city?: string, active?: boolean, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/salons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje salon (podle práv uživatele)
         * @param {string} id 
         * @param {UpdateSalonRequest} updateSalonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalon: async (id: string, updateSalonRequest: UpdateSalonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalon', 'id', id)
            // verify required parameter 'updateSalonRequest' is not null or undefined
            assertParamExists('updateSalon', 'updateSalonRequest', updateSalonRequest)
            const localVarPath = `/salons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Změní status salonu (aktivní/neaktivní)
         * @param {string} id 
         * @param {UpdateSalonStatusRequest} updateSalonStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalonStatus: async (id: string, updateSalonStatusRequest: UpdateSalonStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalonStatus', 'id', id)
            // verify required parameter 'updateSalonStatusRequest' is not null or undefined
            assertParamExists('updateSalonStatus', 'updateSalonStatusRequest', updateSalonStatusRequest)
            const localVarPath = `/salons/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalonStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny salonu
         * @param {string} id 
         * @param {UpdateSalonWorkingHoursRequest} updateSalonWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalonWorkingHours: async (id: string, updateSalonWorkingHoursRequest: UpdateSalonWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalonWorkingHours', 'id', id)
            // verify required parameter 'updateSalonWorkingHoursRequest' is not null or undefined
            assertParamExists('updateSalonWorkingHours', 'updateSalonWorkingHoursRequest', updateSalonWorkingHoursRequest)
            const localVarPath = `/salons/{id}/working-hours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalonWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalonsApi - functional programming interface
 * @export
 */
export const SalonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvoří nový salon (pouze pro OWNER/ADMIN)
         * @param {CreateSalonRequest} createSalonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalon(createSalonRequest: CreateSalonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalon(createSalonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.createSalon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže salon (pouze pro OWNER/ADMIN)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalon(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalon(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.deleteSalon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam salonů s detaily práv pro aktuálního uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySalons(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalonWithAccessResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySalons(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getMySalons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá detail salonu (pokud má uživatel přístup)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalonById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam služeb salonu
         * @param {string} id 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [category] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonServices(id: string, page?: number, limit?: number, q?: string, category?: string, active?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseSalonServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonServices(id, page, limit, q, category, active, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalonServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam zaměstnanců salonu
         * @param {string} id 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [role] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonStaff(id: string, page?: number, limit?: number, q?: string, role?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseSalonStaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonStaff(id, page, limit, q, role, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalonStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá statistiky salonu
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonStatistics(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonStatistics(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalonStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny salonu
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonWorkingHours(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalonWorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonWorkingHours(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalonWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam salonů dostupných pro aktuálního uživatele
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [q] 
         * @param {string} [city] 
         * @param {boolean} [active] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalons(page?: number, limit?: number, q?: string, city?: string, active?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseSalonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalons(page, limit, q, city, active, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.getSalons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje salon (podle práv uživatele)
         * @param {string} id 
         * @param {UpdateSalonRequest} updateSalonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalon(id: string, updateSalonRequest: UpdateSalonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalon(id, updateSalonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.updateSalon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Změní status salonu (aktivní/neaktivní)
         * @param {string} id 
         * @param {UpdateSalonStatusRequest} updateSalonStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalonStatus(id: string, updateSalonStatusRequest: UpdateSalonStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalonStatus(id, updateSalonStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.updateSalonStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny salonu
         * @param {string} id 
         * @param {UpdateSalonWorkingHoursRequest} updateSalonWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalonWorkingHours(id: string, updateSalonWorkingHoursRequest: UpdateSalonWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalonWorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalonWorkingHours(id, updateSalonWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalonsApi.updateSalonWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalonsApi - factory interface
 * @export
 */
export const SalonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalonsApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvoří nový salon (pouze pro OWNER/ADMIN)
         * @param {SalonsApiCreateSalonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalon(requestParameters: SalonsApiCreateSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse> {
            return localVarFp.createSalon(requestParameters.createSalonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže salon (pouze pro OWNER/ADMIN)
         * @param {SalonsApiDeleteSalonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalon(requestParameters: SalonsApiDeleteSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSalon(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam salonů s detaily práv pro aktuálního uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySalons(options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWithAccessResponse>> {
            return localVarFp.getMySalons(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá detail salonu (pokud má uživatel přístup)
         * @param {SalonsApiGetSalonByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonById(requestParameters: SalonsApiGetSalonByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonDetailResponse> {
            return localVarFp.getSalonById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam služeb salonu
         * @param {SalonsApiGetSalonServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonServices(requestParameters: SalonsApiGetSalonServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonServiceResponse> {
            return localVarFp.getSalonServices(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.category, requestParameters.active, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam zaměstnanců salonu
         * @param {SalonsApiGetSalonStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonStaff(requestParameters: SalonsApiGetSalonStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonStaffResponse> {
            return localVarFp.getSalonStaff(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.role, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá statistiky salonu
         * @param {SalonsApiGetSalonStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonStatistics(requestParameters: SalonsApiGetSalonStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonStatisticsResponse> {
            return localVarFp.getSalonStatistics(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny salonu
         * @param {SalonsApiGetSalonWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonWorkingHours(requestParameters: SalonsApiGetSalonWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWorkingHoursResponse>> {
            return localVarFp.getSalonWorkingHours(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam salonů dostupných pro aktuálního uživatele
         * @param {SalonsApiGetSalonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalons(requestParameters: SalonsApiGetSalonsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonResponse> {
            return localVarFp.getSalons(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.city, requestParameters.active, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje salon (podle práv uživatele)
         * @param {SalonsApiUpdateSalonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalon(requestParameters: SalonsApiUpdateSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse> {
            return localVarFp.updateSalon(requestParameters.id, requestParameters.updateSalonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Změní status salonu (aktivní/neaktivní)
         * @param {SalonsApiUpdateSalonStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalonStatus(requestParameters: SalonsApiUpdateSalonStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse> {
            return localVarFp.updateSalonStatus(requestParameters.id, requestParameters.updateSalonStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje pracovní hodiny salonu
         * @param {SalonsApiUpdateSalonWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalonWorkingHours(requestParameters: SalonsApiUpdateSalonWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWorkingHoursResponse>> {
            return localVarFp.updateSalonWorkingHours(requestParameters.id, requestParameters.updateSalonWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalonsApi - interface
 * @export
 * @interface SalonsApi
 */
export interface SalonsApiInterface {
    /**
     * 
     * @summary Vytvoří nový salon (pouze pro OWNER/ADMIN)
     * @param {SalonsApiCreateSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    createSalon(requestParameters: SalonsApiCreateSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse>;

    /**
     * 
     * @summary Smaže salon (pouze pro OWNER/ADMIN)
     * @param {SalonsApiDeleteSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    deleteSalon(requestParameters: SalonsApiDeleteSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Získá seznam salonů s detaily práv pro aktuálního uživatele
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getMySalons(options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWithAccessResponse>>;

    /**
     * 
     * @summary Získá detail salonu (pokud má uživatel přístup)
     * @param {SalonsApiGetSalonByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalonById(requestParameters: SalonsApiGetSalonByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonDetailResponse>;

    /**
     * 
     * @summary Získá seznam služeb salonu
     * @param {SalonsApiGetSalonServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalonServices(requestParameters: SalonsApiGetSalonServicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonServiceResponse>;

    /**
     * 
     * @summary Získá seznam zaměstnanců salonu
     * @param {SalonsApiGetSalonStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalonStaff(requestParameters: SalonsApiGetSalonStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonStaffResponse>;

    /**
     * 
     * @summary Získá statistiky salonu
     * @param {SalonsApiGetSalonStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalonStatistics(requestParameters: SalonsApiGetSalonStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonStatisticsResponse>;

    /**
     * 
     * @summary Získá pracovní hodiny salonu
     * @param {SalonsApiGetSalonWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalonWorkingHours(requestParameters: SalonsApiGetSalonWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWorkingHoursResponse>>;

    /**
     * 
     * @summary Získá seznam salonů dostupných pro aktuálního uživatele
     * @param {SalonsApiGetSalonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    getSalons(requestParameters?: SalonsApiGetSalonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseSalonResponse>;

    /**
     * 
     * @summary Aktualizuje salon (podle práv uživatele)
     * @param {SalonsApiUpdateSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    updateSalon(requestParameters: SalonsApiUpdateSalonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse>;

    /**
     * 
     * @summary Změní status salonu (aktivní/neaktivní)
     * @param {SalonsApiUpdateSalonStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    updateSalonStatus(requestParameters: SalonsApiUpdateSalonStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonResponse>;

    /**
     * 
     * @summary Aktualizuje pracovní hodiny salonu
     * @param {SalonsApiUpdateSalonWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApiInterface
     */
    updateSalonWorkingHours(requestParameters: SalonsApiUpdateSalonWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SalonWorkingHoursResponse>>;

}

/**
 * Request parameters for createSalon operation in SalonsApi.
 * @export
 * @interface SalonsApiCreateSalonRequest
 */
export interface SalonsApiCreateSalonRequest {
    /**
     * 
     * @type {CreateSalonRequest}
     * @memberof SalonsApiCreateSalon
     */
    readonly createSalonRequest: CreateSalonRequest
}

/**
 * Request parameters for deleteSalon operation in SalonsApi.
 * @export
 * @interface SalonsApiDeleteSalonRequest
 */
export interface SalonsApiDeleteSalonRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiDeleteSalon
     */
    readonly id: string
}

/**
 * Request parameters for getSalonById operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonByIdRequest
 */
export interface SalonsApiGetSalonByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonById
     */
    readonly id: string
}

/**
 * Request parameters for getSalonServices operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonServicesRequest
 */
export interface SalonsApiGetSalonServicesRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonServices
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalonServices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalonServices
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonServices
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonServices
     */
    readonly category?: string

    /**
     * 
     * @type {boolean}
     * @memberof SalonsApiGetSalonServices
     */
    readonly active?: boolean
}

/**
 * Request parameters for getSalonStaff operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonStaffRequest
 */
export interface SalonsApiGetSalonStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly role?: string

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonStaff
     */
    readonly status?: string
}

/**
 * Request parameters for getSalonStatistics operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonStatisticsRequest
 */
export interface SalonsApiGetSalonStatisticsRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonStatistics
     */
    readonly id: string
}

/**
 * Request parameters for getSalonWorkingHours operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonWorkingHoursRequest
 */
export interface SalonsApiGetSalonWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalonWorkingHours
     */
    readonly id: string
}

/**
 * Request parameters for getSalons operation in SalonsApi.
 * @export
 * @interface SalonsApiGetSalonsRequest
 */
export interface SalonsApiGetSalonsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalons
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SalonsApiGetSalons
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalons
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalons
     */
    readonly city?: string

    /**
     * 
     * @type {boolean}
     * @memberof SalonsApiGetSalons
     */
    readonly active?: boolean

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalons
     */
    readonly sortBy?: string

    /**
     * 
     * @type {string}
     * @memberof SalonsApiGetSalons
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for updateSalon operation in SalonsApi.
 * @export
 * @interface SalonsApiUpdateSalonRequest
 */
export interface SalonsApiUpdateSalonRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiUpdateSalon
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSalonRequest}
     * @memberof SalonsApiUpdateSalon
     */
    readonly updateSalonRequest: UpdateSalonRequest
}

/**
 * Request parameters for updateSalonStatus operation in SalonsApi.
 * @export
 * @interface SalonsApiUpdateSalonStatusRequest
 */
export interface SalonsApiUpdateSalonStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiUpdateSalonStatus
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSalonStatusRequest}
     * @memberof SalonsApiUpdateSalonStatus
     */
    readonly updateSalonStatusRequest: UpdateSalonStatusRequest
}

/**
 * Request parameters for updateSalonWorkingHours operation in SalonsApi.
 * @export
 * @interface SalonsApiUpdateSalonWorkingHoursRequest
 */
export interface SalonsApiUpdateSalonWorkingHoursRequest {
    /**
     * 
     * @type {string}
     * @memberof SalonsApiUpdateSalonWorkingHours
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSalonWorkingHoursRequest}
     * @memberof SalonsApiUpdateSalonWorkingHours
     */
    readonly updateSalonWorkingHoursRequest: UpdateSalonWorkingHoursRequest
}

/**
 * SalonsApi - object-oriented interface
 * @export
 * @class SalonsApi
 * @extends {BaseAPI}
 */
export class SalonsApi extends BaseAPI implements SalonsApiInterface {
    /**
     * 
     * @summary Vytvoří nový salon (pouze pro OWNER/ADMIN)
     * @param {SalonsApiCreateSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public createSalon(requestParameters: SalonsApiCreateSalonRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).createSalon(requestParameters.createSalonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže salon (pouze pro OWNER/ADMIN)
     * @param {SalonsApiDeleteSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public deleteSalon(requestParameters: SalonsApiDeleteSalonRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).deleteSalon(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam salonů s detaily práv pro aktuálního uživatele
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getMySalons(options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getMySalons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá detail salonu (pokud má uživatel přístup)
     * @param {SalonsApiGetSalonByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalonById(requestParameters: SalonsApiGetSalonByIdRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalonById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam služeb salonu
     * @param {SalonsApiGetSalonServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalonServices(requestParameters: SalonsApiGetSalonServicesRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalonServices(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.category, requestParameters.active, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam zaměstnanců salonu
     * @param {SalonsApiGetSalonStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalonStaff(requestParameters: SalonsApiGetSalonStaffRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalonStaff(requestParameters.id, requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.role, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá statistiky salonu
     * @param {SalonsApiGetSalonStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalonStatistics(requestParameters: SalonsApiGetSalonStatisticsRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalonStatistics(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny salonu
     * @param {SalonsApiGetSalonWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalonWorkingHours(requestParameters: SalonsApiGetSalonWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalonWorkingHours(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam salonů dostupných pro aktuálního uživatele
     * @param {SalonsApiGetSalonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public getSalons(requestParameters: SalonsApiGetSalonsRequest = {}, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).getSalons(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.city, requestParameters.active, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje salon (podle práv uživatele)
     * @param {SalonsApiUpdateSalonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public updateSalon(requestParameters: SalonsApiUpdateSalonRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).updateSalon(requestParameters.id, requestParameters.updateSalonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Změní status salonu (aktivní/neaktivní)
     * @param {SalonsApiUpdateSalonStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public updateSalonStatus(requestParameters: SalonsApiUpdateSalonStatusRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).updateSalonStatus(requestParameters.id, requestParameters.updateSalonStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje pracovní hodiny salonu
     * @param {SalonsApiUpdateSalonWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalonsApi
     */
    public updateSalonWorkingHours(requestParameters: SalonsApiUpdateSalonWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return SalonsApiFp(this.configuration).updateSalonWorkingHours(requestParameters.id, requestParameters.updateSalonWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceCategoriesApi - axios parameter creator
 * @export
 */
export const ServiceCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvoří novou kategorii služeb
         * @param {CreateServiceCategoryRequest} createServiceCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (createServiceCategoryRequest: CreateServiceCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createServiceCategoryRequest' is not null or undefined
            assertParamExists('createCategory', 'createServiceCategoryRequest', createServiceCategoryRequest)
            const localVarPath = `/services/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createServiceCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže kategorii (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCategory', 'id', id)
            const localVarPath = `/services/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam všech kategorií služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá konkrétní kategorii podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryById', 'id', id)
            const localVarPath = `/services/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje existující kategorii
         * @param {string} id 
         * @param {UpdateServiceCategoryRequest} updateServiceCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (id: string, updateServiceCategoryRequest: UpdateServiceCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategory', 'id', id)
            // verify required parameter 'updateServiceCategoryRequest' is not null or undefined
            assertParamExists('updateCategory', 'updateServiceCategoryRequest', updateServiceCategoryRequest)
            const localVarPath = `/services/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateServiceCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceCategoriesApi - functional programming interface
 * @export
 */
export const ServiceCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvoří novou kategorii služeb
         * @param {CreateServiceCategoryRequest} createServiceCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(createServiceCategoryRequest: CreateServiceCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(createServiceCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceCategoriesApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže kategorii (soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceCategoriesApi.deleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam všech kategorií služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceCategoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceCategoriesApi.getAllCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá konkrétní kategorii podle ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceCategoriesApi.getCategoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje existující kategorii
         * @param {string} id 
         * @param {UpdateServiceCategoryRequest} updateServiceCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(id: string, updateServiceCategoryRequest: UpdateServiceCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(id, updateServiceCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceCategoriesApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceCategoriesApi - factory interface
 * @export
 */
export const ServiceCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvoří novou kategorii služeb
         * @param {ServiceCategoriesApiCreateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(requestParameters: ServiceCategoriesApiCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse> {
            return localVarFp.createCategory(requestParameters.createServiceCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže kategorii (soft delete)
         * @param {ServiceCategoriesApiDeleteCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(requestParameters: ServiceCategoriesApiDeleteCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam všech kategorií služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceCategoryResponse>> {
            return localVarFp.getAllCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá konkrétní kategorii podle ID
         * @param {ServiceCategoriesApiGetCategoryByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(requestParameters: ServiceCategoriesApiGetCategoryByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse> {
            return localVarFp.getCategoryById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje existující kategorii
         * @param {ServiceCategoriesApiUpdateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(requestParameters: ServiceCategoriesApiUpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse> {
            return localVarFp.updateCategory(requestParameters.id, requestParameters.updateServiceCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceCategoriesApi - interface
 * @export
 * @interface ServiceCategoriesApi
 */
export interface ServiceCategoriesApiInterface {
    /**
     * 
     * @summary Vytvoří novou kategorii služeb
     * @param {ServiceCategoriesApiCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApiInterface
     */
    createCategory(requestParameters: ServiceCategoriesApiCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse>;

    /**
     * 
     * @summary Smaže kategorii (soft delete)
     * @param {ServiceCategoriesApiDeleteCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApiInterface
     */
    deleteCategory(requestParameters: ServiceCategoriesApiDeleteCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Získá seznam všech kategorií služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApiInterface
     */
    getAllCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceCategoryResponse>>;

    /**
     * 
     * @summary Získá konkrétní kategorii podle ID
     * @param {ServiceCategoriesApiGetCategoryByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApiInterface
     */
    getCategoryById(requestParameters: ServiceCategoriesApiGetCategoryByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse>;

    /**
     * 
     * @summary Aktualizuje existující kategorii
     * @param {ServiceCategoriesApiUpdateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApiInterface
     */
    updateCategory(requestParameters: ServiceCategoriesApiUpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceCategoryResponse>;

}

/**
 * Request parameters for createCategory operation in ServiceCategoriesApi.
 * @export
 * @interface ServiceCategoriesApiCreateCategoryRequest
 */
export interface ServiceCategoriesApiCreateCategoryRequest {
    /**
     * 
     * @type {CreateServiceCategoryRequest}
     * @memberof ServiceCategoriesApiCreateCategory
     */
    readonly createServiceCategoryRequest: CreateServiceCategoryRequest
}

/**
 * Request parameters for deleteCategory operation in ServiceCategoriesApi.
 * @export
 * @interface ServiceCategoriesApiDeleteCategoryRequest
 */
export interface ServiceCategoriesApiDeleteCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoriesApiDeleteCategory
     */
    readonly id: string
}

/**
 * Request parameters for getCategoryById operation in ServiceCategoriesApi.
 * @export
 * @interface ServiceCategoriesApiGetCategoryByIdRequest
 */
export interface ServiceCategoriesApiGetCategoryByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoriesApiGetCategoryById
     */
    readonly id: string
}

/**
 * Request parameters for updateCategory operation in ServiceCategoriesApi.
 * @export
 * @interface ServiceCategoriesApiUpdateCategoryRequest
 */
export interface ServiceCategoriesApiUpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceCategoriesApiUpdateCategory
     */
    readonly id: string

    /**
     * 
     * @type {UpdateServiceCategoryRequest}
     * @memberof ServiceCategoriesApiUpdateCategory
     */
    readonly updateServiceCategoryRequest: UpdateServiceCategoryRequest
}

/**
 * ServiceCategoriesApi - object-oriented interface
 * @export
 * @class ServiceCategoriesApi
 * @extends {BaseAPI}
 */
export class ServiceCategoriesApi extends BaseAPI implements ServiceCategoriesApiInterface {
    /**
     * 
     * @summary Vytvoří novou kategorii služeb
     * @param {ServiceCategoriesApiCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApi
     */
    public createCategory(requestParameters: ServiceCategoriesApiCreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return ServiceCategoriesApiFp(this.configuration).createCategory(requestParameters.createServiceCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže kategorii (soft delete)
     * @param {ServiceCategoriesApiDeleteCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApi
     */
    public deleteCategory(requestParameters: ServiceCategoriesApiDeleteCategoryRequest, options?: RawAxiosRequestConfig) {
        return ServiceCategoriesApiFp(this.configuration).deleteCategory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam všech kategorií služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApi
     */
    public getAllCategories(options?: RawAxiosRequestConfig) {
        return ServiceCategoriesApiFp(this.configuration).getAllCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá konkrétní kategorii podle ID
     * @param {ServiceCategoriesApiGetCategoryByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApi
     */
    public getCategoryById(requestParameters: ServiceCategoriesApiGetCategoryByIdRequest, options?: RawAxiosRequestConfig) {
        return ServiceCategoriesApiFp(this.configuration).getCategoryById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje existující kategorii
     * @param {ServiceCategoriesApiUpdateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceCategoriesApi
     */
    public updateCategory(requestParameters: ServiceCategoriesApiUpdateCategoryRequest, options?: RawAxiosRequestConfig) {
        return ServiceCategoriesApiFp(this.configuration).updateCategory(requestParameters.id, requestParameters.updateServiceCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceStatisticsApi - axios parameter creator
 * @export
 */
export const ServiceStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Získá statistiky pro konkrétní kategorii
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryStats: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getCategoryStats', 'categoryId', categoryId)
            const localVarPath = `/services/stats/category/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá detailní výkonnostní statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerformanceStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services/stats/performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá celkové statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatisticsApi - functional programming interface
 * @export
 */
export const ServiceStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Získá statistiky pro konkrétní kategorii
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryStats(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryStats(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceStatisticsApi.getCategoryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá detailní výkonnostní statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerformanceStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePerformance>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerformanceStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceStatisticsApi.getPerformanceStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá celkové statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceStatisticsApi.getServiceStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceStatisticsApi - factory interface
 * @export
 */
export const ServiceStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Získá statistiky pro konkrétní kategorii
         * @param {ServiceStatisticsApiGetCategoryStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryStats(requestParameters: ServiceStatisticsApiGetCategoryStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryStats> {
            return localVarFp.getCategoryStats(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá detailní výkonnostní statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerformanceStats(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePerformance>> {
            return localVarFp.getPerformanceStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá celkové statistiky služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStats(options?: RawAxiosRequestConfig): AxiosPromise<ServiceStatsResponse> {
            return localVarFp.getServiceStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatisticsApi - interface
 * @export
 * @interface ServiceStatisticsApi
 */
export interface ServiceStatisticsApiInterface {
    /**
     * 
     * @summary Získá statistiky pro konkrétní kategorii
     * @param {ServiceStatisticsApiGetCategoryStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApiInterface
     */
    getCategoryStats(requestParameters: ServiceStatisticsApiGetCategoryStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryStats>;

    /**
     * 
     * @summary Získá detailní výkonnostní statistiky služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApiInterface
     */
    getPerformanceStats(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePerformance>>;

    /**
     * 
     * @summary Získá celkové statistiky služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApiInterface
     */
    getServiceStats(options?: RawAxiosRequestConfig): AxiosPromise<ServiceStatsResponse>;

}

/**
 * Request parameters for getCategoryStats operation in ServiceStatisticsApi.
 * @export
 * @interface ServiceStatisticsApiGetCategoryStatsRequest
 */
export interface ServiceStatisticsApiGetCategoryStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceStatisticsApiGetCategoryStats
     */
    readonly categoryId: string
}

/**
 * ServiceStatisticsApi - object-oriented interface
 * @export
 * @class ServiceStatisticsApi
 * @extends {BaseAPI}
 */
export class ServiceStatisticsApi extends BaseAPI implements ServiceStatisticsApiInterface {
    /**
     * 
     * @summary Získá statistiky pro konkrétní kategorii
     * @param {ServiceStatisticsApiGetCategoryStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApi
     */
    public getCategoryStats(requestParameters: ServiceStatisticsApiGetCategoryStatsRequest, options?: RawAxiosRequestConfig) {
        return ServiceStatisticsApiFp(this.configuration).getCategoryStats(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá detailní výkonnostní statistiky služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApi
     */
    public getPerformanceStats(options?: RawAxiosRequestConfig) {
        return ServiceStatisticsApiFp(this.configuration).getPerformanceStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá celkové statistiky služeb
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatisticsApi
     */
    public getServiceStats(options?: RawAxiosRequestConfig) {
        return ServiceStatisticsApiFp(this.configuration).getServiceStats(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServicesLoVApi - axios parameter creator
 * @export
 */
export const ServicesLoVApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrací seznam pouze aktivních služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam aktivních služeb pro LoV
         * @param {string} salonId UUID salonu
         * @param {string} [workerId] UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveServicesLoV: async (salonId: string, workerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getActiveServicesLoV', 'salonId', salonId)
            const localVarPath = `/services/lov/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam všech služeb pro LoV
         * @param {string} salonId UUID salonu
         * @param {string} [workerId] UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServicesLoV: async (salonId: string, workerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getAllServicesLoV', 'salonId', salonId)
            const localVarPath = `/services/lov`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServicesLoVApi - functional programming interface
 * @export
 */
export const ServicesLoVApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServicesLoVApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrací seznam pouze aktivních služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam aktivních služeb pro LoV
         * @param {string} salonId UUID salonu
         * @param {string} [workerId] UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveServicesLoV(salonId: string, workerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicesLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveServicesLoV(salonId, workerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicesLoVApi.getActiveServicesLoV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam všech služeb pro LoV
         * @param {string} salonId UUID salonu
         * @param {string} [workerId] UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllServicesLoV(salonId: string, workerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicesLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllServicesLoV(salonId, workerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicesLoVApi.getAllServicesLoV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServicesLoVApi - factory interface
 * @export
 */
export const ServicesLoVApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServicesLoVApiFp(configuration)
    return {
        /**
         * Vrací seznam pouze aktivních služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam aktivních služeb pro LoV
         * @param {ServicesLoVApiGetActiveServicesLoVRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveServicesLoV(requestParameters: ServicesLoVApiGetActiveServicesLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicesLoVResponse>> {
            return localVarFp.getActiveServicesLoV(requestParameters.salonId, requestParameters.workerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
         * @summary Získá seznam všech služeb pro LoV
         * @param {ServicesLoVApiGetAllServicesLoVRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServicesLoV(requestParameters: ServicesLoVApiGetAllServicesLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicesLoVResponse>> {
            return localVarFp.getAllServicesLoV(requestParameters.salonId, requestParameters.workerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServicesLoVApi - interface
 * @export
 * @interface ServicesLoVApi
 */
export interface ServicesLoVApiInterface {
    /**
     * Vrací seznam pouze aktivních služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
     * @summary Získá seznam aktivních služeb pro LoV
     * @param {ServicesLoVApiGetActiveServicesLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesLoVApiInterface
     */
    getActiveServicesLoV(requestParameters: ServicesLoVApiGetActiveServicesLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicesLoVResponse>>;

    /**
     * Vrací seznam služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
     * @summary Získá seznam všech služeb pro LoV
     * @param {ServicesLoVApiGetAllServicesLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesLoVApiInterface
     */
    getAllServicesLoV(requestParameters: ServicesLoVApiGetAllServicesLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicesLoVResponse>>;

}

/**
 * Request parameters for getActiveServicesLoV operation in ServicesLoVApi.
 * @export
 * @interface ServicesLoVApiGetActiveServicesLoVRequest
 */
export interface ServicesLoVApiGetActiveServicesLoVRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof ServicesLoVApiGetActiveServicesLoV
     */
    readonly salonId: string

    /**
     * UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
     * @type {string}
     * @memberof ServicesLoVApiGetActiveServicesLoV
     */
    readonly workerId?: string
}

/**
 * Request parameters for getAllServicesLoV operation in ServicesLoVApi.
 * @export
 * @interface ServicesLoVApiGetAllServicesLoVRequest
 */
export interface ServicesLoVApiGetAllServicesLoVRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof ServicesLoVApiGetAllServicesLoV
     */
    readonly salonId: string

    /**
     * UUID zaměstnance pro filtrování pouze jeho služeb (volitelné)
     * @type {string}
     * @memberof ServicesLoVApiGetAllServicesLoV
     */
    readonly workerId?: string
}

/**
 * ServicesLoVApi - object-oriented interface
 * @export
 * @class ServicesLoVApi
 * @extends {BaseAPI}
 */
export class ServicesLoVApi extends BaseAPI implements ServicesLoVApiInterface {
    /**
     * Vrací seznam pouze aktivních služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
     * @summary Získá seznam aktivních služeb pro LoV
     * @param {ServicesLoVApiGetActiveServicesLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesLoVApi
     */
    public getActiveServicesLoV(requestParameters: ServicesLoVApiGetActiveServicesLoVRequest, options?: RawAxiosRequestConfig) {
        return ServicesLoVApiFp(this.configuration).getActiveServicesLoV(requestParameters.salonId, requestParameters.workerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam služeb salonu s ID a názvem, seřazené podle názvu. Lze filtrovat podle zaměstnance.
     * @summary Získá seznam všech služeb pro LoV
     * @param {ServicesLoVApiGetAllServicesLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesLoVApi
     */
    public getAllServicesLoV(requestParameters: ServicesLoVApiGetAllServicesLoVRequest, options?: RawAxiosRequestConfig) {
        return ServicesLoVApiFp(this.configuration).getAllServicesLoV(requestParameters.salonId, requestParameters.workerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SiteApi - axios parameter creator
 * @export
 */
export const SiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Veřejný endpoint pro vytvoření rezervace zákazníkem
         * @summary Vytvoří novou rezervaci
         * @param {CreateBookingRequest} createBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking: async (createBookingRequest: CreateBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingRequest' is not null or undefined
            assertParamExists('createBooking', 'createBookingRequest', createBookingRequest)
            const localVarPath = `/site/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný endpoint pro získání dostupných časových slotů pro konkrétního zaměstnance, službu, pracoviště a datum
         * @summary Získá volné časové sloty pro rezervaci
         * @param {string} salonId UUID salonu
         * @param {string} workerId UUID zaměstnance
         * @param {string} serviceId UUID služby
         * @param {string} date Datum ve formátu YYYY-MM-DD
         * @param {string} [workResourceId] UUID pracoviště (volitelné - pokud není zadáno, použije se primární pracoviště zaměstnance)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlots: async (salonId: string, workerId: string, serviceId: string, date: string, workResourceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getAvailableSlots', 'salonId', salonId)
            // verify required parameter 'workerId' is not null or undefined
            assertParamExists('getAvailableSlots', 'workerId', workerId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getAvailableSlots', 'serviceId', serviceId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAvailableSlots', 'date', date)
            const localVarPath = `/site/slots/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (workerId !== undefined) {
                localVarQueryParameter['workerId'] = workerId;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (workResourceId !== undefined) {
                localVarQueryParameter['workResourceId'] = workResourceId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný endpoint pro získání základních informací o salonu pomocí unikátního slug
         * @summary Získá základní detaily salonu podle slug
         * @param {string} slug Unikátní slug salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonBySlug: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getSalonBySlug', 'slug', slug)
            const localVarPath = `/site/salons/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný debug endpoint pro kontrolu pracovních hodin
         * @summary Debug endpoint pro kontrolu pracovních hodin salonu
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonWorkingHoursDebug: async (salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getSalonWorkingHoursDebug', 'salonId', salonId)
            const localVarPath = `/site/debug/salons/{salonId}/working-hours`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní kategorii
         * @summary Získá služby pro kategorii podle UUID
         * @param {string} categoryId UUID kategorie služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesByCategoryId: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getServicesByCategoryId', 'categoryId', categoryId)
            const localVarPath = `/site/categories/{categoryId}/services`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní salon
         * @summary Získá služby pro salon podle UUID
         * @param {string} salonId UUID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesBySalonId: async (salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getServicesBySalonId', 'salonId', salonId)
            const localVarPath = `/site/salons/{salonId}/services`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Veřejný endpoint pro získání všech aktivních zaměstnanců, kteří mají schopnost poskytovat konkrétní službu
         * @summary Získá zaměstnance, kteří mohou realizovat vybranou službu
         * @param {string} serviceId UUID služby
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffMembersByServiceId: async (serviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getStaffMembersByServiceId', 'serviceId', serviceId)
            const localVarPath = `/site/services/{serviceId}/staff`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SiteApi - functional programming interface
 * @export
 */
export const SiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SiteApiAxiosParamCreator(configuration)
    return {
        /**
         * Veřejný endpoint pro vytvoření rezervace zákazníkem
         * @summary Vytvoří novou rezervaci
         * @param {CreateBookingRequest} createBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBooking(createBookingRequest: CreateBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBooking(createBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.createBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný endpoint pro získání dostupných časových slotů pro konkrétního zaměstnance, službu, pracoviště a datum
         * @summary Získá volné časové sloty pro rezervaci
         * @param {string} salonId UUID salonu
         * @param {string} workerId UUID zaměstnance
         * @param {string} serviceId UUID služby
         * @param {string} date Datum ve formátu YYYY-MM-DD
         * @param {string} [workResourceId] UUID pracoviště (volitelné - pokud není zadáno, použije se primární pracoviště zaměstnance)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSlots(salonId: string, workerId: string, serviceId: string, date: string, workResourceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableSlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSlots(salonId, workerId, serviceId, date, workResourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getAvailableSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný endpoint pro získání základních informací o salonu pomocí unikátního slug
         * @summary Získá základní detaily salonu podle slug
         * @param {string} slug Unikátní slug salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonBySlug(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalonPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonBySlug(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getSalonBySlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný debug endpoint pro kontrolu pracovních hodin
         * @summary Debug endpoint pro kontrolu pracovních hodin salonu
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalonWorkingHoursDebug(salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalonWorkingHoursDebug(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getSalonWorkingHoursDebug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní kategorii
         * @summary Získá služby pro kategorii podle UUID
         * @param {string} categoryId UUID kategorie služeb
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicesByCategoryId(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePublicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicesByCategoryId(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getServicesByCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní salon
         * @summary Získá služby pro salon podle UUID
         * @param {string} salonId UUID salonu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicesBySalonId(salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServicePublicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicesBySalonId(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getServicesBySalonId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Veřejný endpoint pro získání všech aktivních zaměstnanců, kteří mají schopnost poskytovat konkrétní službu
         * @summary Získá zaměstnance, kteří mohou realizovat vybranou službu
         * @param {string} serviceId UUID služby
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffMembersByServiceId(serviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaffMemberPublicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffMembersByServiceId(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SiteApi.getStaffMembersByServiceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SiteApi - factory interface
 * @export
 */
export const SiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SiteApiFp(configuration)
    return {
        /**
         * Veřejný endpoint pro vytvoření rezervace zákazníkem
         * @summary Vytvoří novou rezervaci
         * @param {SiteApiCreateBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking(requestParameters: SiteApiCreateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingResponse> {
            return localVarFp.createBooking(requestParameters.createBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný endpoint pro získání dostupných časových slotů pro konkrétního zaměstnance, službu, pracoviště a datum
         * @summary Získá volné časové sloty pro rezervaci
         * @param {SiteApiGetAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlots(requestParameters: SiteApiGetAvailableSlotsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailableSlotsResponse> {
            return localVarFp.getAvailableSlots(requestParameters.salonId, requestParameters.workerId, requestParameters.serviceId, requestParameters.date, requestParameters.workResourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný endpoint pro získání základních informací o salonu pomocí unikátního slug
         * @summary Získá základní detaily salonu podle slug
         * @param {SiteApiGetSalonBySlugRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonBySlug(requestParameters: SiteApiGetSalonBySlugRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonPublicResponse> {
            return localVarFp.getSalonBySlug(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný debug endpoint pro kontrolu pracovních hodin
         * @summary Debug endpoint pro kontrolu pracovních hodin salonu
         * @param {SiteApiGetSalonWorkingHoursDebugRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalonWorkingHoursDebug(requestParameters: SiteApiGetSalonWorkingHoursDebugRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getSalonWorkingHoursDebug(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní kategorii
         * @summary Získá služby pro kategorii podle UUID
         * @param {SiteApiGetServicesByCategoryIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesByCategoryId(requestParameters: SiteApiGetServicesByCategoryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePublicResponse>> {
            return localVarFp.getServicesByCategoryId(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní salon
         * @summary Získá služby pro salon podle UUID
         * @param {SiteApiGetServicesBySalonIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesBySalonId(requestParameters: SiteApiGetServicesBySalonIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePublicResponse>> {
            return localVarFp.getServicesBySalonId(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Veřejný endpoint pro získání všech aktivních zaměstnanců, kteří mají schopnost poskytovat konkrétní službu
         * @summary Získá zaměstnance, kteří mohou realizovat vybranou službu
         * @param {SiteApiGetStaffMembersByServiceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffMembersByServiceId(requestParameters: SiteApiGetStaffMembersByServiceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffMemberPublicResponse>> {
            return localVarFp.getStaffMembersByServiceId(requestParameters.serviceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SiteApi - interface
 * @export
 * @interface SiteApi
 */
export interface SiteApiInterface {
    /**
     * Veřejný endpoint pro vytvoření rezervace zákazníkem
     * @summary Vytvoří novou rezervaci
     * @param {SiteApiCreateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    createBooking(requestParameters: SiteApiCreateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingResponse>;

    /**
     * Veřejný endpoint pro získání dostupných časových slotů pro konkrétního zaměstnance, službu, pracoviště a datum
     * @summary Získá volné časové sloty pro rezervaci
     * @param {SiteApiGetAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getAvailableSlots(requestParameters: SiteApiGetAvailableSlotsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailableSlotsResponse>;

    /**
     * Veřejný endpoint pro získání základních informací o salonu pomocí unikátního slug
     * @summary Získá základní detaily salonu podle slug
     * @param {SiteApiGetSalonBySlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getSalonBySlug(requestParameters: SiteApiGetSalonBySlugRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalonPublicResponse>;

    /**
     * Veřejný debug endpoint pro kontrolu pracovních hodin
     * @summary Debug endpoint pro kontrolu pracovních hodin salonu
     * @param {SiteApiGetSalonWorkingHoursDebugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getSalonWorkingHoursDebug(requestParameters: SiteApiGetSalonWorkingHoursDebugRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }>;

    /**
     * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní kategorii
     * @summary Získá služby pro kategorii podle UUID
     * @param {SiteApiGetServicesByCategoryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getServicesByCategoryId(requestParameters: SiteApiGetServicesByCategoryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePublicResponse>>;

    /**
     * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní salon
     * @summary Získá služby pro salon podle UUID
     * @param {SiteApiGetServicesBySalonIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getServicesBySalonId(requestParameters: SiteApiGetServicesBySalonIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServicePublicResponse>>;

    /**
     * Veřejný endpoint pro získání všech aktivních zaměstnanců, kteří mají schopnost poskytovat konkrétní službu
     * @summary Získá zaměstnance, kteří mohou realizovat vybranou službu
     * @param {SiteApiGetStaffMembersByServiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApiInterface
     */
    getStaffMembersByServiceId(requestParameters: SiteApiGetStaffMembersByServiceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffMemberPublicResponse>>;

}

/**
 * Request parameters for createBooking operation in SiteApi.
 * @export
 * @interface SiteApiCreateBookingRequest
 */
export interface SiteApiCreateBookingRequest {
    /**
     * 
     * @type {CreateBookingRequest}
     * @memberof SiteApiCreateBooking
     */
    readonly createBookingRequest: CreateBookingRequest
}

/**
 * Request parameters for getAvailableSlots operation in SiteApi.
 * @export
 * @interface SiteApiGetAvailableSlotsRequest
 */
export interface SiteApiGetAvailableSlotsRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof SiteApiGetAvailableSlots
     */
    readonly salonId: string

    /**
     * UUID zaměstnance
     * @type {string}
     * @memberof SiteApiGetAvailableSlots
     */
    readonly workerId: string

    /**
     * UUID služby
     * @type {string}
     * @memberof SiteApiGetAvailableSlots
     */
    readonly serviceId: string

    /**
     * Datum ve formátu YYYY-MM-DD
     * @type {string}
     * @memberof SiteApiGetAvailableSlots
     */
    readonly date: string

    /**
     * UUID pracoviště (volitelné - pokud není zadáno, použije se primární pracoviště zaměstnance)
     * @type {string}
     * @memberof SiteApiGetAvailableSlots
     */
    readonly workResourceId?: string
}

/**
 * Request parameters for getSalonBySlug operation in SiteApi.
 * @export
 * @interface SiteApiGetSalonBySlugRequest
 */
export interface SiteApiGetSalonBySlugRequest {
    /**
     * Unikátní slug salonu
     * @type {string}
     * @memberof SiteApiGetSalonBySlug
     */
    readonly slug: string
}

/**
 * Request parameters for getSalonWorkingHoursDebug operation in SiteApi.
 * @export
 * @interface SiteApiGetSalonWorkingHoursDebugRequest
 */
export interface SiteApiGetSalonWorkingHoursDebugRequest {
    /**
     * 
     * @type {string}
     * @memberof SiteApiGetSalonWorkingHoursDebug
     */
    readonly salonId: string
}

/**
 * Request parameters for getServicesByCategoryId operation in SiteApi.
 * @export
 * @interface SiteApiGetServicesByCategoryIdRequest
 */
export interface SiteApiGetServicesByCategoryIdRequest {
    /**
     * UUID kategorie služeb
     * @type {string}
     * @memberof SiteApiGetServicesByCategoryId
     */
    readonly categoryId: string
}

/**
 * Request parameters for getServicesBySalonId operation in SiteApi.
 * @export
 * @interface SiteApiGetServicesBySalonIdRequest
 */
export interface SiteApiGetServicesBySalonIdRequest {
    /**
     * UUID salonu
     * @type {string}
     * @memberof SiteApiGetServicesBySalonId
     */
    readonly salonId: string
}

/**
 * Request parameters for getStaffMembersByServiceId operation in SiteApi.
 * @export
 * @interface SiteApiGetStaffMembersByServiceIdRequest
 */
export interface SiteApiGetStaffMembersByServiceIdRequest {
    /**
     * UUID služby
     * @type {string}
     * @memberof SiteApiGetStaffMembersByServiceId
     */
    readonly serviceId: string
}

/**
 * SiteApi - object-oriented interface
 * @export
 * @class SiteApi
 * @extends {BaseAPI}
 */
export class SiteApi extends BaseAPI implements SiteApiInterface {
    /**
     * Veřejný endpoint pro vytvoření rezervace zákazníkem
     * @summary Vytvoří novou rezervaci
     * @param {SiteApiCreateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public createBooking(requestParameters: SiteApiCreateBookingRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).createBooking(requestParameters.createBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný endpoint pro získání dostupných časových slotů pro konkrétního zaměstnance, službu, pracoviště a datum
     * @summary Získá volné časové sloty pro rezervaci
     * @param {SiteApiGetAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getAvailableSlots(requestParameters: SiteApiGetAvailableSlotsRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getAvailableSlots(requestParameters.salonId, requestParameters.workerId, requestParameters.serviceId, requestParameters.date, requestParameters.workResourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný endpoint pro získání základních informací o salonu pomocí unikátního slug
     * @summary Získá základní detaily salonu podle slug
     * @param {SiteApiGetSalonBySlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getSalonBySlug(requestParameters: SiteApiGetSalonBySlugRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getSalonBySlug(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný debug endpoint pro kontrolu pracovních hodin
     * @summary Debug endpoint pro kontrolu pracovních hodin salonu
     * @param {SiteApiGetSalonWorkingHoursDebugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getSalonWorkingHoursDebug(requestParameters: SiteApiGetSalonWorkingHoursDebugRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getSalonWorkingHoursDebug(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní kategorii
     * @summary Získá služby pro kategorii podle UUID
     * @param {SiteApiGetServicesByCategoryIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getServicesByCategoryId(requestParameters: SiteApiGetServicesByCategoryIdRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getServicesByCategoryId(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný endpoint pro získání všech aktivních služeb pro konkrétní salon
     * @summary Získá služby pro salon podle UUID
     * @param {SiteApiGetServicesBySalonIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getServicesBySalonId(requestParameters: SiteApiGetServicesBySalonIdRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getServicesBySalonId(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Veřejný endpoint pro získání všech aktivních zaměstnanců, kteří mají schopnost poskytovat konkrétní službu
     * @summary Získá zaměstnance, kteří mohou realizovat vybranou službu
     * @param {SiteApiGetStaffMembersByServiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getStaffMembersByServiceId(requestParameters: SiteApiGetStaffMembersByServiceIdRequest, options?: RawAxiosRequestConfig) {
        return SiteApiFp(this.configuration).getStaffMembersByServiceId(requestParameters.serviceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StaffApi - axios parameter creator
 * @export
 */
export const StaffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrací seznam pouze aktivních zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam aktivních zaměstnanců pro LoV
         * @param {string} [salonId] ID salonu pro filtrování (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveStaffLoV: async (salonId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staff/lov/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací seznam zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam všech zaměstnanců pro LoV
         * @param {string} [salonId] ID salonu pro filtrování (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStaffLoV: async (salonId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/staff/lov`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaffApi - functional programming interface
 * @export
 */
export const StaffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaffApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrací seznam pouze aktivních zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam aktivních zaměstnanců pro LoV
         * @param {string} [salonId] ID salonu pro filtrování (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveStaffLoV(salonId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaffLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveStaffLoV(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.getActiveStaffLoV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací seznam zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam všech zaměstnanců pro LoV
         * @param {string} [salonId] ID salonu pro filtrování (volitelné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStaffLoV(salonId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaffLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStaffLoV(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffApi.getAllStaffLoV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StaffApi - factory interface
 * @export
 */
export const StaffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaffApiFp(configuration)
    return {
        /**
         * Vrací seznam pouze aktivních zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam aktivních zaměstnanců pro LoV
         * @param {StaffApiGetActiveStaffLoVRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveStaffLoV(requestParameters: StaffApiGetActiveStaffLoVRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffLoVResponse>> {
            return localVarFp.getActiveStaffLoV(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací seznam zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
         * @summary Získá seznam všech zaměstnanců pro LoV
         * @param {StaffApiGetAllStaffLoVRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStaffLoV(requestParameters: StaffApiGetAllStaffLoVRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffLoVResponse>> {
            return localVarFp.getAllStaffLoV(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StaffApi - interface
 * @export
 * @interface StaffApi
 */
export interface StaffApiInterface {
    /**
     * Vrací seznam pouze aktivních zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
     * @summary Získá seznam aktivních zaměstnanců pro LoV
     * @param {StaffApiGetActiveStaffLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApiInterface
     */
    getActiveStaffLoV(requestParameters?: StaffApiGetActiveStaffLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffLoVResponse>>;

    /**
     * Vrací seznam zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
     * @summary Získá seznam všech zaměstnanců pro LoV
     * @param {StaffApiGetAllStaffLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApiInterface
     */
    getAllStaffLoV(requestParameters?: StaffApiGetAllStaffLoVRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffLoVResponse>>;

}

/**
 * Request parameters for getActiveStaffLoV operation in StaffApi.
 * @export
 * @interface StaffApiGetActiveStaffLoVRequest
 */
export interface StaffApiGetActiveStaffLoVRequest {
    /**
     * ID salonu pro filtrování (volitelné)
     * @type {string}
     * @memberof StaffApiGetActiveStaffLoV
     */
    readonly salonId?: string
}

/**
 * Request parameters for getAllStaffLoV operation in StaffApi.
 * @export
 * @interface StaffApiGetAllStaffLoVRequest
 */
export interface StaffApiGetAllStaffLoVRequest {
    /**
     * ID salonu pro filtrování (volitelné)
     * @type {string}
     * @memberof StaffApiGetAllStaffLoV
     */
    readonly salonId?: string
}

/**
 * StaffApi - object-oriented interface
 * @export
 * @class StaffApi
 * @extends {BaseAPI}
 */
export class StaffApi extends BaseAPI implements StaffApiInterface {
    /**
     * Vrací seznam pouze aktivních zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
     * @summary Získá seznam aktivních zaměstnanců pro LoV
     * @param {StaffApiGetActiveStaffLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public getActiveStaffLoV(requestParameters: StaffApiGetActiveStaffLoVRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).getActiveStaffLoV(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací seznam zaměstnanců z organizací přihlášeného uživatele s ID a jménem, seřazené podle jména
     * @summary Získá seznam všech zaměstnanců pro LoV
     * @param {StaffApiGetAllStaffLoVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    public getAllStaffLoV(requestParameters: StaffApiGetAllStaffLoVRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffApiFp(this.configuration).getAllStaffLoV(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WaitingListsApi - axios parameter creator
 * @export
 */
export const WaitingListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Přidá zákazníka do čekací listiny pro konkrétní službu
         * @summary Vytvořit čekací listinu
         * @param {string} salonId 
         * @param {CreateWaitingListRequest} createWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaitingList: async (salonId: string, createWaitingListRequest: CreateWaitingListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('createWaitingList', 'salonId', salonId)
            // verify required parameter 'createWaitingListRequest' is not null or undefined
            assertParamExists('createWaitingList', 'createWaitingListRequest', createWaitingListRequest)
            const localVarPath = `/api/app/waiting-lists/salons/{salonId}`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWaitingListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže čekací listinu
         * @summary Smazat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaitingList: async (id: string, salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWaitingList', 'id', id)
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('deleteWaitingList', 'salonId', salonId)
            const localVarPath = `/api/app/waiting-lists/{id}/salons/{salonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Získá detail čekací listiny podle ID
         * @summary Získat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingList: async (id: string, salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWaitingList', 'id', id)
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getWaitingList', 'salonId', salonId)
            const localVarPath = `/api/app/waiting-lists/{id}/salons/{salonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Získá statistiky čekacích listin pro salon
         * @summary Statistiky čekacích listin
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingListStats: async (salonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getWaitingListStats', 'salonId', salonId)
            const localVarPath = `/api/app/waiting-lists/salons/{salonId}/stats`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Získá seznam čekacích listin s možností filtrování
         * @summary Získat seznam čekacích listin
         * @param {string} salonId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {string} [serviceId] 
         * @param {string} [customerId] 
         * @param {string} [preferredWorkerId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {boolean} [includeExpired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingLists: async (salonId: string, pageable: Pageable, status?: string, serviceId?: string, customerId?: string, preferredWorkerId?: string, dateFrom?: string, dateTo?: string, includeExpired?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('getWaitingLists', 'salonId', salonId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getWaitingLists', 'pageable', pageable)
            const localVarPath = `/api/app/waiting-lists/salons/{salonId}`
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (preferredWorkerId !== undefined) {
                localVarQueryParameter['preferredWorkerId'] = preferredWorkerId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }

            if (includeExpired !== undefined) {
                localVarQueryParameter['includeExpired'] = includeExpired;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Označí čekací listinu jako převedenou do rezervace
         * @summary Označit jako rezervován
         * @param {string} id 
         * @param {string} salonId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsBooked: async (id: string, salonId: string, bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markAsBooked', 'id', id)
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('markAsBooked', 'salonId', salonId)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('markAsBooked', 'bookingId', bookingId)
            const localVarPath = `/api/app/waiting-lists/{id}/salons/{salonId}/book`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bookingId !== undefined) {
                localVarQueryParameter['bookingId'] = bookingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Označí zákazníka jako kontaktovaného
         * @summary Označit jako kontaktován
         * @param {string} id 
         * @param {string} salonId 
         * @param {string} [contactNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsContacted: async (id: string, salonId: string, contactNotes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markAsContacted', 'id', id)
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('markAsContacted', 'salonId', salonId)
            const localVarPath = `/api/app/waiting-lists/{id}/salons/{salonId}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contactNotes !== undefined) {
                localVarQueryParameter['contactNotes'] = contactNotes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje údaje čekací listiny
         * @summary Aktualizovat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {UpdateWaitingListRequest} updateWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaitingList: async (id: string, salonId: string, updateWaitingListRequest: UpdateWaitingListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWaitingList', 'id', id)
            // verify required parameter 'salonId' is not null or undefined
            assertParamExists('updateWaitingList', 'salonId', salonId)
            // verify required parameter 'updateWaitingListRequest' is not null or undefined
            assertParamExists('updateWaitingList', 'updateWaitingListRequest', updateWaitingListRequest)
            const localVarPath = `/api/app/waiting-lists/{id}/salons/{salonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"salonId"}}`, encodeURIComponent(String(salonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWaitingListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaitingListsApi - functional programming interface
 * @export
 */
export const WaitingListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaitingListsApiAxiosParamCreator(configuration)
    return {
        /**
         * Přidá zákazníka do čekací listiny pro konkrétní službu
         * @summary Vytvořit čekací listinu
         * @param {string} salonId 
         * @param {CreateWaitingListRequest} createWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWaitingList(salonId: string, createWaitingListRequest: CreateWaitingListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWaitingList(salonId, createWaitingListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.createWaitingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže čekací listinu
         * @summary Smazat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaitingList(id: string, salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWaitingList(id, salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.deleteWaitingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Získá detail čekací listiny podle ID
         * @summary Získat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitingList(id: string, salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitingList(id, salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.getWaitingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Získá statistiky čekacích listin pro salon
         * @summary Statistiky čekacích listin
         * @param {string} salonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitingListStats(salonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitingListStats(salonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.getWaitingListStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Získá seznam čekacích listin s možností filtrování
         * @summary Získat seznam čekacích listin
         * @param {string} salonId 
         * @param {Pageable} pageable 
         * @param {string} [status] 
         * @param {string} [serviceId] 
         * @param {string} [customerId] 
         * @param {string} [preferredWorkerId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {boolean} [includeExpired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaitingLists(salonId: string, pageable: Pageable, status?: string, serviceId?: string, customerId?: string, preferredWorkerId?: string, dateFrom?: string, dateTo?: string, includeExpired?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseWaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaitingLists(salonId, pageable, status, serviceId, customerId, preferredWorkerId, dateFrom, dateTo, includeExpired, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.getWaitingLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Označí čekací listinu jako převedenou do rezervace
         * @summary Označit jako rezervován
         * @param {string} id 
         * @param {string} salonId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsBooked(id: string, salonId: string, bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsBooked(id, salonId, bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.markAsBooked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Označí zákazníka jako kontaktovaného
         * @summary Označit jako kontaktován
         * @param {string} id 
         * @param {string} salonId 
         * @param {string} [contactNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsContacted(id: string, salonId: string, contactNotes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsContacted(id, salonId, contactNotes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.markAsContacted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje údaje čekací listiny
         * @summary Aktualizovat čekací listinu
         * @param {string} id 
         * @param {string} salonId 
         * @param {UpdateWaitingListRequest} updateWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaitingList(id: string, salonId: string, updateWaitingListRequest: UpdateWaitingListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWaitingList(id, salonId, updateWaitingListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WaitingListsApi.updateWaitingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WaitingListsApi - factory interface
 * @export
 */
export const WaitingListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaitingListsApiFp(configuration)
    return {
        /**
         * Přidá zákazníka do čekací listiny pro konkrétní službu
         * @summary Vytvořit čekací listinu
         * @param {WaitingListsApiCreateWaitingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaitingList(requestParameters: WaitingListsApiCreateWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.createWaitingList(requestParameters.salonId, requestParameters.createWaitingListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže čekací listinu
         * @summary Smazat čekací listinu
         * @param {WaitingListsApiDeleteWaitingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaitingList(requestParameters: WaitingListsApiDeleteWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWaitingList(requestParameters.id, requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Získá detail čekací listiny podle ID
         * @summary Získat čekací listinu
         * @param {WaitingListsApiGetWaitingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingList(requestParameters: WaitingListsApiGetWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.getWaitingList(requestParameters.id, requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Získá statistiky čekacích listin pro salon
         * @summary Statistiky čekacích listin
         * @param {WaitingListsApiGetWaitingListStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingListStats(requestParameters: WaitingListsApiGetWaitingListStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getWaitingListStats(requestParameters.salonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Získá seznam čekacích listin s možností filtrování
         * @summary Získat seznam čekacích listin
         * @param {WaitingListsApiGetWaitingListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaitingLists(requestParameters: WaitingListsApiGetWaitingListsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseWaitingListResponse> {
            return localVarFp.getWaitingLists(requestParameters.salonId, requestParameters.pageable, requestParameters.status, requestParameters.serviceId, requestParameters.customerId, requestParameters.preferredWorkerId, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.includeExpired, options).then((request) => request(axios, basePath));
        },
        /**
         * Označí čekací listinu jako převedenou do rezervace
         * @summary Označit jako rezervován
         * @param {WaitingListsApiMarkAsBookedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsBooked(requestParameters: WaitingListsApiMarkAsBookedRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.markAsBooked(requestParameters.id, requestParameters.salonId, requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Označí zákazníka jako kontaktovaného
         * @summary Označit jako kontaktován
         * @param {WaitingListsApiMarkAsContactedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsContacted(requestParameters: WaitingListsApiMarkAsContactedRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.markAsContacted(requestParameters.id, requestParameters.salonId, requestParameters.contactNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje údaje čekací listiny
         * @summary Aktualizovat čekací listinu
         * @param {WaitingListsApiUpdateWaitingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaitingList(requestParameters: WaitingListsApiUpdateWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.updateWaitingList(requestParameters.id, requestParameters.salonId, requestParameters.updateWaitingListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaitingListsApi - interface
 * @export
 * @interface WaitingListsApi
 */
export interface WaitingListsApiInterface {
    /**
     * Přidá zákazníka do čekací listiny pro konkrétní službu
     * @summary Vytvořit čekací listinu
     * @param {WaitingListsApiCreateWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    createWaitingList(requestParameters: WaitingListsApiCreateWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse>;

    /**
     * Smaže čekací listinu
     * @summary Smazat čekací listinu
     * @param {WaitingListsApiDeleteWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    deleteWaitingList(requestParameters: WaitingListsApiDeleteWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Získá detail čekací listiny podle ID
     * @summary Získat čekací listinu
     * @param {WaitingListsApiGetWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    getWaitingList(requestParameters: WaitingListsApiGetWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse>;

    /**
     * Získá statistiky čekacích listin pro salon
     * @summary Statistiky čekacích listin
     * @param {WaitingListsApiGetWaitingListStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    getWaitingListStats(requestParameters: WaitingListsApiGetWaitingListStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }>;

    /**
     * Získá seznam čekacích listin s možností filtrování
     * @summary Získat seznam čekacích listin
     * @param {WaitingListsApiGetWaitingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    getWaitingLists(requestParameters: WaitingListsApiGetWaitingListsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseWaitingListResponse>;

    /**
     * Označí čekací listinu jako převedenou do rezervace
     * @summary Označit jako rezervován
     * @param {WaitingListsApiMarkAsBookedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    markAsBooked(requestParameters: WaitingListsApiMarkAsBookedRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse>;

    /**
     * Označí zákazníka jako kontaktovaného
     * @summary Označit jako kontaktován
     * @param {WaitingListsApiMarkAsContactedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    markAsContacted(requestParameters: WaitingListsApiMarkAsContactedRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse>;

    /**
     * Aktualizuje údaje čekací listiny
     * @summary Aktualizovat čekací listinu
     * @param {WaitingListsApiUpdateWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApiInterface
     */
    updateWaitingList(requestParameters: WaitingListsApiUpdateWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse>;

}

/**
 * Request parameters for createWaitingList operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiCreateWaitingListRequest
 */
export interface WaitingListsApiCreateWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiCreateWaitingList
     */
    readonly salonId: string

    /**
     * 
     * @type {CreateWaitingListRequest}
     * @memberof WaitingListsApiCreateWaitingList
     */
    readonly createWaitingListRequest: CreateWaitingListRequest
}

/**
 * Request parameters for deleteWaitingList operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiDeleteWaitingListRequest
 */
export interface WaitingListsApiDeleteWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiDeleteWaitingList
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiDeleteWaitingList
     */
    readonly salonId: string
}

/**
 * Request parameters for getWaitingList operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiGetWaitingListRequest
 */
export interface WaitingListsApiGetWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingList
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingList
     */
    readonly salonId: string
}

/**
 * Request parameters for getWaitingListStats operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiGetWaitingListStatsRequest
 */
export interface WaitingListsApiGetWaitingListStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingListStats
     */
    readonly salonId: string
}

/**
 * Request parameters for getWaitingLists operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiGetWaitingListsRequest
 */
export interface WaitingListsApiGetWaitingListsRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly salonId: string

    /**
     * 
     * @type {Pageable}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly pageable: Pageable

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly serviceId?: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly preferredWorkerId?: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly dateTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof WaitingListsApiGetWaitingLists
     */
    readonly includeExpired?: boolean
}

/**
 * Request parameters for markAsBooked operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiMarkAsBookedRequest
 */
export interface WaitingListsApiMarkAsBookedRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsBooked
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsBooked
     */
    readonly salonId: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsBooked
     */
    readonly bookingId: string
}

/**
 * Request parameters for markAsContacted operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiMarkAsContactedRequest
 */
export interface WaitingListsApiMarkAsContactedRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsContacted
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsContacted
     */
    readonly salonId: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiMarkAsContacted
     */
    readonly contactNotes?: string
}

/**
 * Request parameters for updateWaitingList operation in WaitingListsApi.
 * @export
 * @interface WaitingListsApiUpdateWaitingListRequest
 */
export interface WaitingListsApiUpdateWaitingListRequest {
    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiUpdateWaitingList
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WaitingListsApiUpdateWaitingList
     */
    readonly salonId: string

    /**
     * 
     * @type {UpdateWaitingListRequest}
     * @memberof WaitingListsApiUpdateWaitingList
     */
    readonly updateWaitingListRequest: UpdateWaitingListRequest
}

/**
 * WaitingListsApi - object-oriented interface
 * @export
 * @class WaitingListsApi
 * @extends {BaseAPI}
 */
export class WaitingListsApi extends BaseAPI implements WaitingListsApiInterface {
    /**
     * Přidá zákazníka do čekací listiny pro konkrétní službu
     * @summary Vytvořit čekací listinu
     * @param {WaitingListsApiCreateWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public createWaitingList(requestParameters: WaitingListsApiCreateWaitingListRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).createWaitingList(requestParameters.salonId, requestParameters.createWaitingListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže čekací listinu
     * @summary Smazat čekací listinu
     * @param {WaitingListsApiDeleteWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public deleteWaitingList(requestParameters: WaitingListsApiDeleteWaitingListRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).deleteWaitingList(requestParameters.id, requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Získá detail čekací listiny podle ID
     * @summary Získat čekací listinu
     * @param {WaitingListsApiGetWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public getWaitingList(requestParameters: WaitingListsApiGetWaitingListRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).getWaitingList(requestParameters.id, requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Získá statistiky čekacích listin pro salon
     * @summary Statistiky čekacích listin
     * @param {WaitingListsApiGetWaitingListStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public getWaitingListStats(requestParameters: WaitingListsApiGetWaitingListStatsRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).getWaitingListStats(requestParameters.salonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Získá seznam čekacích listin s možností filtrování
     * @summary Získat seznam čekacích listin
     * @param {WaitingListsApiGetWaitingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public getWaitingLists(requestParameters: WaitingListsApiGetWaitingListsRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).getWaitingLists(requestParameters.salonId, requestParameters.pageable, requestParameters.status, requestParameters.serviceId, requestParameters.customerId, requestParameters.preferredWorkerId, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.includeExpired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Označí čekací listinu jako převedenou do rezervace
     * @summary Označit jako rezervován
     * @param {WaitingListsApiMarkAsBookedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public markAsBooked(requestParameters: WaitingListsApiMarkAsBookedRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).markAsBooked(requestParameters.id, requestParameters.salonId, requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Označí zákazníka jako kontaktovaného
     * @summary Označit jako kontaktován
     * @param {WaitingListsApiMarkAsContactedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public markAsContacted(requestParameters: WaitingListsApiMarkAsContactedRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).markAsContacted(requestParameters.id, requestParameters.salonId, requestParameters.contactNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje údaje čekací listiny
     * @summary Aktualizovat čekací listinu
     * @param {WaitingListsApiUpdateWaitingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaitingListsApi
     */
    public updateWaitingList(requestParameters: WaitingListsApiUpdateWaitingListRequest, options?: RawAxiosRequestConfig) {
        return WaitingListsApiFp(this.configuration).updateWaitingList(requestParameters.id, requestParameters.salonId, requestParameters.updateWaitingListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkingHoursApi - axios parameter creator
 * @export
 */
export const WorkingHoursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteWorkingHours: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDeleteWorkingHours', 'requestBody', requestBody)
            const localVarPath = `/working-hours/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny
         * @param {CreateWorkingHoursRequest} createWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHours: async (createWorkingHoursRequest: CreateWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWorkingHoursRequest' is not null or undefined
            assertParamExists('createWorkingHours', 'createWorkingHoursRequest', createWorkingHoursRequest)
            const localVarPath = `/working-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže pracovní hodiny (soft delete)
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHours: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkingHours', 'id', id)
            const localVarPath = `/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveWorkingHoursByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getActiveWorkingHoursByUser', 'userId', userId)
            const localVarPath = `/working-hours/user/{userId}/active`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin s možností filtrování
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [limit] Počet položek na stránku (výchozí: 20)
         * @param {string} [userId] ID uživatele
         * @param {string} [salonId] ID salonu
         * @param {number} [weekday] Den v týdnu (1-7)
         * @param {boolean} [isActive] Aktivní pracovní hodiny
         * @param {string} [sortBy] Řazení podle (výchozí: weekday)
         * @param {string} [sortOrder] Směr řazení (asc/desc, výchozí: asc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHours: async (page?: number, limit?: number, userId?: string, salonId?: string, weekday?: number, isActive?: boolean, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/working-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (salonId !== undefined) {
                localVarQueryParameter['salonId'] = salonId;
            }

            if (weekday !== undefined) {
                localVarQueryParameter['weekday'] = weekday;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny podle ID
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkingHoursById', 'id', id)
            const localVarPath = `/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkingHoursByUser', 'userId', userId)
            const localVarPath = `/working-hours/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {string} userId ID uživatele
         * @param {number} weekday Den v týdnu (1-7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUserAndWeekday: async (userId: string, weekday: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkingHoursByUserAndWeekday', 'userId', userId)
            // verify required parameter 'weekday' is not null or undefined
            assertParamExists('getWorkingHoursByUserAndWeekday', 'weekday', weekday)
            const localVarPath = `/working-hours/user/{userId}/weekday/{weekday}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"weekday"}}`, encodeURIComponent(String(weekday)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny
         * @param {string} id ID pracovních hodin
         * @param {UpdateWorkingHoursRequest} updateWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHours: async (id: string, updateWorkingHoursRequest: UpdateWorkingHoursRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWorkingHours', 'id', id)
            // verify required parameter 'updateWorkingHoursRequest' is not null or undefined
            assertParamExists('updateWorkingHours', 'updateWorkingHoursRequest', updateWorkingHoursRequest)
            const localVarPath = `/working-hours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkingHoursRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkingHoursApi - functional programming interface
 * @export
 */
export const WorkingHoursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkingHoursApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteWorkingHours(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteWorkingHours(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.bulkDeleteWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny
         * @param {CreateWorkingHoursRequest} createWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkingHours(createWorkingHoursRequest: CreateWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkingHours(createWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.createWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže pracovní hodiny (soft delete)
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkingHours(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkingHours(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.deleteWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveWorkingHoursByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveWorkingHoursByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.getActiveWorkingHoursByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin s možností filtrování
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [limit] Počet položek na stránku (výchozí: 20)
         * @param {string} [userId] ID uživatele
         * @param {string} [salonId] ID salonu
         * @param {number} [weekday] Den v týdnu (1-7)
         * @param {boolean} [isActive] Aktivní pracovní hodiny
         * @param {string} [sortBy] Řazení podle (výchozí: weekday)
         * @param {string} [sortOrder] Směr řazení (asc/desc, výchozí: asc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHours(page?: number, limit?: number, userId?: string, salonId?: string, weekday?: number, isActive?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHours(page, limit, userId, salonId, weekday, isActive, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.getWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny podle ID
         * @param {string} id ID pracovních hodin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.getWorkingHoursById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {string} userId ID uživatele
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHoursResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.getWorkingHoursByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {string} userId ID uživatele
         * @param {number} weekday Den v týdnu (1-7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkingHoursByUserAndWeekday(userId: string, weekday: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkingHoursByUserAndWeekday(userId, weekday, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.getWorkingHoursByUserAndWeekday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny
         * @param {string} id ID pracovních hodin
         * @param {UpdateWorkingHoursRequest} updateWorkingHoursRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkingHours(id: string, updateWorkingHoursRequest: UpdateWorkingHoursRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkingHours(id, updateWorkingHoursRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.updateWorkingHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkingHoursApi - factory interface
 * @export
 */
export const WorkingHoursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkingHoursApiFp(configuration)
    return {
        /**
         * 
         * @summary Hromadné smazání více pracovních hodin
         * @param {WorkingHoursApiBulkDeleteWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteWorkingHours(requestParameters: WorkingHoursApiBulkDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteWorkingHours(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvoří nové pracovní hodiny
         * @param {WorkingHoursApiCreateWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkingHours(requestParameters: WorkingHoursApiCreateWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse> {
            return localVarFp.createWorkingHours(requestParameters.createWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže pracovní hodiny (soft delete)
         * @param {WorkingHoursApiDeleteWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkingHours(requestParameters: WorkingHoursApiDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorkingHours(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá aktivní pracovní hodiny pro uživatele
         * @param {WorkingHoursApiGetActiveWorkingHoursByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveWorkingHoursByUser(requestParameters: WorkingHoursApiGetActiveWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>> {
            return localVarFp.getActiveWorkingHoursByUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá seznam pracovních hodin s možností filtrování
         * @param {WorkingHoursApiGetWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHours(requestParameters: WorkingHoursApiGetWorkingHoursRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageWorkingHoursResponse> {
            return localVarFp.getWorkingHours(requestParameters.page, requestParameters.limit, requestParameters.userId, requestParameters.salonId, requestParameters.weekday, requestParameters.isActive, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny podle ID
         * @param {WorkingHoursApiGetWorkingHoursByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursById(requestParameters: WorkingHoursApiGetWorkingHoursByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse> {
            return localVarFp.getWorkingHoursById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá všechny pracovní hodiny pro uživatele
         * @param {WorkingHoursApiGetWorkingHoursByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUser(requestParameters: WorkingHoursApiGetWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>> {
            return localVarFp.getWorkingHoursByUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získá pracovní hodiny pro konkrétní den v týdnu
         * @param {WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkingHoursByUserAndWeekday(requestParameters: WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse> {
            return localVarFp.getWorkingHoursByUserAndWeekday(requestParameters.userId, requestParameters.weekday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje existující pracovní hodiny
         * @param {WorkingHoursApiUpdateWorkingHoursRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkingHours(requestParameters: WorkingHoursApiUpdateWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse> {
            return localVarFp.updateWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkingHoursApi - interface
 * @export
 * @interface WorkingHoursApi
 */
export interface WorkingHoursApiInterface {
    /**
     * 
     * @summary Hromadné smazání více pracovních hodin
     * @param {WorkingHoursApiBulkDeleteWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    bulkDeleteWorkingHours(requestParameters: WorkingHoursApiBulkDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Vytvoří nové pracovní hodiny
     * @param {WorkingHoursApiCreateWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    createWorkingHours(requestParameters: WorkingHoursApiCreateWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse>;

    /**
     * 
     * @summary Smaže pracovní hodiny (soft delete)
     * @param {WorkingHoursApiDeleteWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    deleteWorkingHours(requestParameters: WorkingHoursApiDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Získá aktivní pracovní hodiny pro uživatele
     * @param {WorkingHoursApiGetActiveWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    getActiveWorkingHoursByUser(requestParameters: WorkingHoursApiGetActiveWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>>;

    /**
     * 
     * @summary Získá seznam pracovních hodin s možností filtrování
     * @param {WorkingHoursApiGetWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    getWorkingHours(requestParameters?: WorkingHoursApiGetWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageWorkingHoursResponse>;

    /**
     * 
     * @summary Získá pracovní hodiny podle ID
     * @param {WorkingHoursApiGetWorkingHoursByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    getWorkingHoursById(requestParameters: WorkingHoursApiGetWorkingHoursByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse>;

    /**
     * 
     * @summary Získá všechny pracovní hodiny pro uživatele
     * @param {WorkingHoursApiGetWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    getWorkingHoursByUser(requestParameters: WorkingHoursApiGetWorkingHoursByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHoursResponse>>;

    /**
     * 
     * @summary Získá pracovní hodiny pro konkrétní den v týdnu
     * @param {WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    getWorkingHoursByUserAndWeekday(requestParameters: WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse>;

    /**
     * 
     * @summary Aktualizuje existující pracovní hodiny
     * @param {WorkingHoursApiUpdateWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApiInterface
     */
    updateWorkingHours(requestParameters: WorkingHoursApiUpdateWorkingHoursRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHoursResponse>;

}

/**
 * Request parameters for bulkDeleteWorkingHours operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiBulkDeleteWorkingHoursRequest
 */
export interface WorkingHoursApiBulkDeleteWorkingHoursRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkingHoursApiBulkDeleteWorkingHours
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for createWorkingHours operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiCreateWorkingHoursRequest
 */
export interface WorkingHoursApiCreateWorkingHoursRequest {
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof WorkingHoursApiCreateWorkingHours
     */
    readonly createWorkingHoursRequest: CreateWorkingHoursRequest
}

/**
 * Request parameters for deleteWorkingHours operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiDeleteWorkingHoursRequest
 */
export interface WorkingHoursApiDeleteWorkingHoursRequest {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof WorkingHoursApiDeleteWorkingHours
     */
    readonly id: string
}

/**
 * Request parameters for getActiveWorkingHoursByUser operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiGetActiveWorkingHoursByUserRequest
 */
export interface WorkingHoursApiGetActiveWorkingHoursByUserRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof WorkingHoursApiGetActiveWorkingHoursByUser
     */
    readonly userId: string
}

/**
 * Request parameters for getWorkingHours operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiGetWorkingHoursRequest
 */
export interface WorkingHoursApiGetWorkingHoursRequest {
    /**
     * Číslo stránky (výchozí: 0)
     * @type {number}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly page?: number

    /**
     * Počet položek na stránku (výchozí: 20)
     * @type {number}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly limit?: number

    /**
     * ID uživatele
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly userId?: string

    /**
     * ID salonu
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly salonId?: string

    /**
     * Den v týdnu (1-7)
     * @type {number}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly weekday?: number

    /**
     * Aktivní pracovní hodiny
     * @type {boolean}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly isActive?: boolean

    /**
     * Řazení podle (výchozí: weekday)
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly sortBy?: string

    /**
     * Směr řazení (asc/desc, výchozí: asc)
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHours
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for getWorkingHoursById operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiGetWorkingHoursByIdRequest
 */
export interface WorkingHoursApiGetWorkingHoursByIdRequest {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHoursById
     */
    readonly id: string
}

/**
 * Request parameters for getWorkingHoursByUser operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiGetWorkingHoursByUserRequest
 */
export interface WorkingHoursApiGetWorkingHoursByUserRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHoursByUser
     */
    readonly userId: string
}

/**
 * Request parameters for getWorkingHoursByUserAndWeekday operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest
 */
export interface WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest {
    /**
     * ID uživatele
     * @type {string}
     * @memberof WorkingHoursApiGetWorkingHoursByUserAndWeekday
     */
    readonly userId: string

    /**
     * Den v týdnu (1-7)
     * @type {number}
     * @memberof WorkingHoursApiGetWorkingHoursByUserAndWeekday
     */
    readonly weekday: number
}

/**
 * Request parameters for updateWorkingHours operation in WorkingHoursApi.
 * @export
 * @interface WorkingHoursApiUpdateWorkingHoursRequest
 */
export interface WorkingHoursApiUpdateWorkingHoursRequest {
    /**
     * ID pracovních hodin
     * @type {string}
     * @memberof WorkingHoursApiUpdateWorkingHours
     */
    readonly id: string

    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof WorkingHoursApiUpdateWorkingHours
     */
    readonly updateWorkingHoursRequest: UpdateWorkingHoursRequest
}

/**
 * WorkingHoursApi - object-oriented interface
 * @export
 * @class WorkingHoursApi
 * @extends {BaseAPI}
 */
export class WorkingHoursApi extends BaseAPI implements WorkingHoursApiInterface {
    /**
     * 
     * @summary Hromadné smazání více pracovních hodin
     * @param {WorkingHoursApiBulkDeleteWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public bulkDeleteWorkingHours(requestParameters: WorkingHoursApiBulkDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).bulkDeleteWorkingHours(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvoří nové pracovní hodiny
     * @param {WorkingHoursApiCreateWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public createWorkingHours(requestParameters: WorkingHoursApiCreateWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).createWorkingHours(requestParameters.createWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže pracovní hodiny (soft delete)
     * @param {WorkingHoursApiDeleteWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public deleteWorkingHours(requestParameters: WorkingHoursApiDeleteWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).deleteWorkingHours(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá aktivní pracovní hodiny pro uživatele
     * @param {WorkingHoursApiGetActiveWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getActiveWorkingHoursByUser(requestParameters: WorkingHoursApiGetActiveWorkingHoursByUserRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getActiveWorkingHoursByUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá seznam pracovních hodin s možností filtrování
     * @param {WorkingHoursApiGetWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getWorkingHours(requestParameters: WorkingHoursApiGetWorkingHoursRequest = {}, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getWorkingHours(requestParameters.page, requestParameters.limit, requestParameters.userId, requestParameters.salonId, requestParameters.weekday, requestParameters.isActive, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny podle ID
     * @param {WorkingHoursApiGetWorkingHoursByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getWorkingHoursById(requestParameters: WorkingHoursApiGetWorkingHoursByIdRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getWorkingHoursById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá všechny pracovní hodiny pro uživatele
     * @param {WorkingHoursApiGetWorkingHoursByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getWorkingHoursByUser(requestParameters: WorkingHoursApiGetWorkingHoursByUserRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getWorkingHoursByUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získá pracovní hodiny pro konkrétní den v týdnu
     * @param {WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public getWorkingHoursByUserAndWeekday(requestParameters: WorkingHoursApiGetWorkingHoursByUserAndWeekdayRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).getWorkingHoursByUserAndWeekday(requestParameters.userId, requestParameters.weekday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje existující pracovní hodiny
     * @param {WorkingHoursApiUpdateWorkingHoursRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingHoursApi
     */
    public updateWorkingHours(requestParameters: WorkingHoursApiUpdateWorkingHoursRequest, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).updateWorkingHours(requestParameters.id, requestParameters.updateWorkingHoursRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



